var SECTION_ID_ATTR$1 = 'data-section-id'
function Section(container, properties) {
  ;(this.container = validateContainerElement(container)),
    (this.id = container.getAttribute(SECTION_ID_ATTR$1)),
    (this.extensions = []),
    Object.assign(this, validatePropertiesObject(properties)),
    this.onLoad()
}
Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,
  extend: function (extension) {
    this.extensions.push(extension)
    var extensionClone = Object.assign({}, extension)
    delete extensionClone.init,
      Object.assign(this, extensionClone),
      typeof extension.init == 'function' && extension.init.apply(this)
  },
}
function validateContainerElement(container) {
  if (!(container instanceof Element))
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    )
  if (container.getAttribute(SECTION_ID_ATTR$1) === null)
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' +
        SECTION_ID_ATTR$1 +
        ' attribute.'
    )
  return container
}
function validatePropertiesObject(value) {
  if ((typeof value < 'u' && typeof value != 'object') || value === null)
    throw new TypeError('Theme Sections: The properties object provided is not a valid')
  return value
}
typeof Object.assign != 'function' &&
  Object.defineProperty(Object, 'assign', {
    value: function (target) {
      if (target == null) throw new TypeError('Cannot convert undefined or null to object')
      for (var to = Object(target), index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index]
        if (nextSource != null)
          for (var nextKey in nextSource)
            Object.prototype.hasOwnProperty.call(nextSource, nextKey) &&
              (to[nextKey] = nextSource[nextKey])
      }
      return to
    },
    writable: !0,
    configurable: !0,
  })
var SECTION_TYPE_ATTR = 'data-section-type',
  SECTION_ID_ATTR = 'data-section-id'
;(window.Shopify = window.Shopify || {}),
  (window.Shopify.theme = window.Shopify.theme || {}),
  (window.Shopify.theme.sections = window.Shopify.theme.sections || {})
var registered = (window.Shopify.theme.sections.registered =
    window.Shopify.theme.sections.registered || {}),
  instances = (window.Shopify.theme.sections.instances =
    window.Shopify.theme.sections.instances || [])
function register(type, properties) {
  if (typeof type != 'string')
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    )
  if (typeof registered[type] < 'u')
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice'
    )
  function TypedSection(container) {
    Section.call(this, container, properties)
  }
  return (
    (TypedSection.constructor = Section),
    (TypedSection.prototype = Object.create(Section.prototype)),
    (TypedSection.prototype.type = type),
    (registered[type] = TypedSection)
  )
}
function load(types, containers) {
  ;(types = normalizeType(types)),
    typeof containers > 'u' &&
      (containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']')),
    (containers = normalizeContainers(containers)),
    types.forEach(function (type) {
      var TypedSection = registered[type]
      typeof TypedSection > 'u' ||
        (containers = containers.filter(function (container) {
          return isInstance(container) || container.getAttribute(SECTION_TYPE_ATTR) === null
            ? !1
            : container.getAttribute(SECTION_TYPE_ATTR) !== type
            ? !0
            : (instances.push(new TypedSection(container)), !1)
        }))
    })
}
function unload(selector) {
  var instancesToUnload = getInstances(selector)
  instancesToUnload.forEach(function (instance) {
    var index = instances
      .map(function (e2) {
        return e2.id
      })
      .indexOf(instance.id)
    instances.splice(index, 1), instance.onUnload()
  })
}
function getInstances(selector) {
  var filteredInstances = []
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector))
    var firstElement = selector[0]
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector)
    containers.forEach(function (container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function (instance) {
          return instance.container === container
        })
      )
    })
  } else if (typeof selector == 'string' || typeof firstElement == 'string') {
    var types = normalizeType(selector)
    types.forEach(function (type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function (instance) {
          return instance.type === type
        })
      )
    })
  }
  return filteredInstances
}
function getInstanceById(id) {
  for (var instance, i2 = 0; i2 < instances.length; i2++)
    if (instances[i2].id === id) {
      instance = instances[i2]
      break
    }
  return instance
}
function isInstance(selector) {
  return getInstances(selector).length > 0
}
function normalizeType(types) {
  return (
    types === '*'
      ? (types = Object.keys(registered))
      : typeof types == 'string'
      ? (types = [types])
      : types.constructor === Section
      ? (types = [types.prototype.type])
      : Array.isArray(types) &&
        types[0].constructor === Section &&
        (types = types.map(function (TypedSection) {
          return TypedSection.prototype.type
        })),
    (types = types.map(function (type) {
      return type.toLowerCase()
    })),
    types
  )
}
function normalizeContainers(containers) {
  return (
    NodeList.prototype.isPrototypeOf(containers) && containers.length > 0
      ? (containers = Array.prototype.slice.call(containers))
      : NodeList.prototype.isPrototypeOf(containers) && containers.length === 0
      ? (containers = [])
      : containers === null
      ? (containers = [])
      : !Array.isArray(containers) && containers instanceof Element && (containers = [containers]),
    containers
  )
}
window.Shopify.designMode &&
  (document.addEventListener('shopify:section:load', function (event) {
    var container,
      id = event.detail.sectionId
    window.Shopify.visualPreviewMode
      ? (container = event.target.querySelector('[data-section-id]'))
      : (container = event.target.querySelector('[' + SECTION_ID_ATTR + '="' + id + '"]')),
      container !== null && load(container.getAttribute(SECTION_TYPE_ATTR), container)
  }),
  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail.sectionId,
      container = event.target.querySelector('[' + SECTION_ID_ATTR + '="' + id + '"]'),
      instance = getInstances(container)[0]
    typeof instance == 'object' && unload(container)
  }),
  document.addEventListener('shopify:section:select', function (event) {
    var instance = getInstanceById(event.detail.sectionId)
    typeof instance == 'object' && instance.onSelect(event)
  }),
  document.addEventListener('shopify:section:deselect', function (event) {
    var instance = getInstanceById(event.detail.sectionId)
    typeof instance == 'object' && instance.onDeselect(event)
  }),
  document.addEventListener('shopify:block:select', function (event) {
    var instance = getInstanceById(event.detail.sectionId)
    typeof instance == 'object' && instance.onBlockSelect(event)
  }),
  document.addEventListener('shopify:block:deselect', function (event) {
    var instance = getInstanceById(event.detail.sectionId)
    typeof instance == 'object' && instance.onBlockDeselect(event)
  }))
function n$2(n2, t2) {
  return t2 === void 0 && (t2 = document), t2.querySelector(n2)
}
function t$2(n2, t2) {
  return t2 === void 0 && (t2 = document), [].slice.call(t2.querySelectorAll(n2))
}
function c$1(n2, t2) {
  return Array.isArray(n2) ? n2.forEach(t2) : t2(n2)
}
function r$2(n2) {
  return function (t2, r2, e2) {
    return c$1(t2, function (t3) {
      return t3[n2 + 'EventListener'](r2, e2)
    })
  }
}
function e$2(n2, t2, c2) {
  return (
    r$2('add')(n2, t2, c2),
    function () {
      return r$2('remove')(n2, t2, c2)
    }
  )
}
function o$2(n2) {
  return function (t2) {
    var r2 = arguments
    return c$1(t2, function (t3) {
      var c2
      return (c2 = t3.classList)[n2].apply(c2, [].slice.call(r2, 1))
    })
  }
}
function u$1(n2) {
  o$2('add').apply(void 0, [n2].concat([].slice.call(arguments, 1)))
}
function i$1(n2) {
  o$2('remove').apply(void 0, [n2].concat([].slice.call(arguments, 1)))
}
function l(n2) {
  o$2('toggle').apply(void 0, [n2].concat([].slice.call(arguments, 1)))
}
function a$1(n2, t2) {
  return n2.classList.contains(t2)
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x
}
var isMobile$2 = { exports: {} }
;(isMobile$2.exports = isMobile),
  (isMobile$2.exports.isMobile = isMobile),
  (isMobile$2.exports.default = isMobile)
var mobileRE =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
  tabletRE =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
function isMobile(opts) {
  opts || (opts = {})
  var ua = opts.ua
  if (
    (!ua && typeof navigator < 'u' && (ua = navigator.userAgent),
    ua &&
      ua.headers &&
      typeof ua.headers['user-agent'] == 'string' &&
      (ua = ua.headers['user-agent']),
    typeof ua != 'string')
  )
    return !1
  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
  return (
    !result &&
      opts.tablet &&
      opts.featureDetect &&
      navigator &&
      navigator.maxTouchPoints > 1 &&
      ua.indexOf('Macintosh') !== -1 &&
      ua.indexOf('Safari') !== -1 &&
      (result = !0),
    result
  )
}
var isMobile$1 = isMobile$2.exports,
  browser = { exports: {} }
;(function (module, exports) {
  Object.defineProperty(exports, '__esModule', { value: !0 }), (exports.default = void 0)
  function Delegate2(root) {
    ;(this.listenerMap = [{}, {}]),
      root && this.root(root),
      (this.handle = Delegate2.prototype.handle.bind(this)),
      (this._removedListeners = [])
  }
  ;(Delegate2.prototype.root = function (root) {
    var listenerMap = this.listenerMap,
      eventType
    if (this.rootElement) {
      for (eventType in listenerMap[1])
        listenerMap[1].hasOwnProperty(eventType) &&
          this.rootElement.removeEventListener(eventType, this.handle, !0)
      for (eventType in listenerMap[0])
        listenerMap[0].hasOwnProperty(eventType) &&
          this.rootElement.removeEventListener(eventType, this.handle, !1)
    }
    if (!root || !root.addEventListener) return this.rootElement && delete this.rootElement, this
    this.rootElement = root
    for (eventType in listenerMap[1])
      listenerMap[1].hasOwnProperty(eventType) &&
        this.rootElement.addEventListener(eventType, this.handle, !0)
    for (eventType in listenerMap[0])
      listenerMap[0].hasOwnProperty(eventType) &&
        this.rootElement.addEventListener(eventType, this.handle, !1)
    return this
  }),
    (Delegate2.prototype.captureForType = function (eventType) {
      return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1
    }),
    (Delegate2.prototype.on = function (eventType, selector, handler, useCapture) {
      var root, listenerMap, matcher, matcherParam
      if (!eventType) throw new TypeError('Invalid event type: ' + eventType)
      if (
        (typeof selector == 'function' &&
          ((useCapture = handler), (handler = selector), (selector = null)),
        useCapture === void 0 && (useCapture = this.captureForType(eventType)),
        typeof handler != 'function')
      )
        throw new TypeError('Handler must be a type of Function')
      return (
        (root = this.rootElement),
        (listenerMap = this.listenerMap[useCapture ? 1 : 0]),
        listenerMap[eventType] ||
          (root && root.addEventListener(eventType, this.handle, useCapture),
          (listenerMap[eventType] = [])),
        selector
          ? /^[a-z]+$/i.test(selector)
            ? ((matcherParam = selector), (matcher = matchesTag))
            : /^#[a-z0-9\-_]+$/i.test(selector)
            ? ((matcherParam = selector.slice(1)), (matcher = matchesId))
            : ((matcherParam = selector), (matcher = Element.prototype.matches))
          : ((matcherParam = null), (matcher = matchesRoot.bind(this))),
        listenerMap[eventType].push({ selector, handler, matcher, matcherParam }),
        this
      )
    }),
    (Delegate2.prototype.off = function (eventType, selector, handler, useCapture) {
      var i2, listener, listenerMap, listenerList, singleEventType
      if (
        (typeof selector == 'function' &&
          ((useCapture = handler), (handler = selector), (selector = null)),
        useCapture === void 0)
      )
        return (
          this.off(eventType, selector, handler, !0),
          this.off(eventType, selector, handler, !1),
          this
        )
      if (((listenerMap = this.listenerMap[useCapture ? 1 : 0]), !eventType)) {
        for (singleEventType in listenerMap)
          listenerMap.hasOwnProperty(singleEventType) &&
            this.off(singleEventType, selector, handler)
        return this
      }
      if (((listenerList = listenerMap[eventType]), !listenerList || !listenerList.length))
        return this
      for (i2 = listenerList.length - 1; i2 >= 0; i2--)
        (listener = listenerList[i2]),
          (!selector || selector === listener.selector) &&
            (!handler || handler === listener.handler) &&
            (this._removedListeners.push(listener), listenerList.splice(i2, 1))
      return (
        listenerList.length ||
          (delete listenerMap[eventType],
          this.rootElement &&
            this.rootElement.removeEventListener(eventType, this.handle, useCapture)),
        this
      )
    }),
    (Delegate2.prototype.handle = function (event) {
      var i2,
        l2,
        type = event.type,
        root,
        phase,
        listener,
        returned,
        listenerList = [],
        target,
        eventIgnore = 'ftLabsDelegateIgnore'
      if (event[eventIgnore] !== !0) {
        switch (
          ((target = event.target),
          target.nodeType === 3 && (target = target.parentNode),
          target.correspondingUseElement && (target = target.correspondingUseElement),
          (root = this.rootElement),
          (phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2)),
          phase)
        ) {
          case 1:
            listenerList = this.listenerMap[1][type]
            break
          case 2:
            this.listenerMap[0] &&
              this.listenerMap[0][type] &&
              (listenerList = listenerList.concat(this.listenerMap[0][type])),
              this.listenerMap[1] &&
                this.listenerMap[1][type] &&
                (listenerList = listenerList.concat(this.listenerMap[1][type]))
            break
          case 3:
            listenerList = this.listenerMap[0][type]
            break
        }
        var toFire = []
        for (l2 = listenerList.length; target && l2; ) {
          for (i2 = 0; i2 < l2 && ((listener = listenerList[i2]), !!listener); i2++)
            target.tagName &&
            ['button', 'input', 'select', 'textarea'].indexOf(target.tagName.toLowerCase()) > -1 &&
            target.hasAttribute('disabled')
              ? (toFire = [])
              : listener.matcher.call(target, listener.matcherParam, target) &&
                toFire.push([event, target, listener])
          if (
            target === root ||
            ((l2 = listenerList.length),
            (target = target.parentElement || target.parentNode),
            target instanceof HTMLDocument)
          )
            break
        }
        var ret
        for (i2 = 0; i2 < toFire.length; i2++)
          if (
            !(this._removedListeners.indexOf(toFire[i2][2]) > -1) &&
            ((returned = this.fire.apply(this, toFire[i2])), returned === !1)
          ) {
            ;(toFire[i2][0][eventIgnore] = !0), toFire[i2][0].preventDefault(), (ret = !1)
            break
          }
        return ret
      }
    }),
    (Delegate2.prototype.fire = function (event, target, listener) {
      return listener.handler.call(target, event, target)
    })
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase()
  }
  function matchesRoot(selector, element) {
    return this.rootElement === window
      ? element === document || element === document.documentElement || element === window
      : this.rootElement === element
  }
  function matchesId(id, element) {
    return id === element.id
  }
  Delegate2.prototype.destroy = function () {
    this.off(), this.root()
  }
  var _default = Delegate2
  ;(exports.default = _default), (module.exports = exports.default)
})(browser, browser.exports)
var Delegate = getDefaultExportFromCjs(browser.exports),
  pageTransition = () => {
    const pageTransitionOverlay = document.querySelector('#page-transition-overlay'),
      animationDuration = 200
    pageTransitionOverlay &&
      (pageTransitionOverlay.classList.remove('skip-transition'),
      setTimeout(function () {
        pageTransitionOverlay.classList.remove('active')
      }, 0),
      setTimeout(() => {
        pageTransitionOverlay.classList.remove('active')
      }, animationDuration),
      new Delegate(document.body).on(
        'click',
        'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"]):not([href="javascript:void(0)"])',
        onClickedToLeave
      ),
      (window.onpageshow = function (e2) {
        e2.persisted && pageTransitionOverlay.classList.remove('active')
      }))
    function onClickedToLeave(event, target) {
      if (event.ctrlKey || event.metaKey) return
      event.preventDefault()
      let linkHint = document.createElement('link')
      linkHint.setAttribute('rel', 'prerender'),
        linkHint.setAttribute('href', target.href),
        document.head.appendChild(linkHint),
        setTimeout(() => {
          window.location.href = target.href
        }, animationDuration),
        pageTransitionOverlay.classList.add('active')
    }
  }
/*!
 * tabbable 5.3.3
 * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
 */ var candidateSelectors = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]:not(slot)',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    'details>summary:first-of-type',
    'details',
  ],
  candidateSelector = candidateSelectors.join(','),
  NoElement = typeof Element > 'u',
  matches = NoElement
    ? function () {}
    : Element.prototype.matches ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector,
  getRootNode =
    !NoElement && Element.prototype.getRootNode
      ? function (element) {
          return element.getRootNode()
        }
      : function (element) {
          return element.ownerDocument
        },
  getCandidates = function (el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector))
    return (
      includeContainer && matches.call(el, candidateSelector) && candidates.unshift(el),
      (candidates = candidates.filter(filter)),
      candidates
    )
  },
  getCandidatesIteratively = function getCandidatesIteratively2(
    elements,
    includeContainer,
    options
  ) {
    for (var candidates = [], elementsToCheck = Array.from(elements); elementsToCheck.length; ) {
      var element = elementsToCheck.shift()
      if (element.tagName === 'SLOT') {
        var assigned = element.assignedElements(),
          content = assigned.length ? assigned : element.children,
          nestedCandidates = getCandidatesIteratively2(content, !0, options)
        options.flatten
          ? candidates.push.apply(candidates, nestedCandidates)
          : candidates.push({ scope: element, candidates: nestedCandidates })
      } else {
        var validCandidate = matches.call(element, candidateSelector)
        validCandidate &&
          options.filter(element) &&
          (includeContainer || !elements.includes(element)) &&
          candidates.push(element)
        var shadowRoot =
            element.shadowRoot ||
            (typeof options.getShadowRoot == 'function' && options.getShadowRoot(element)),
          validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element)
        if (shadowRoot && validShadowRoot) {
          var _nestedCandidates = getCandidatesIteratively2(
            shadowRoot === !0 ? element.children : shadowRoot.children,
            !0,
            options
          )
          options.flatten
            ? candidates.push.apply(candidates, _nestedCandidates)
            : candidates.push({ scope: element, candidates: _nestedCandidates })
        } else elementsToCheck.unshift.apply(elementsToCheck, element.children)
      }
    }
    return candidates
  },
  getTabindex = function (node, isScope) {
    return node.tabIndex < 0 &&
      (isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) &&
      isNaN(parseInt(node.getAttribute('tabindex'), 10))
      ? 0
      : node.tabIndex
  },
  sortOrderedTabbables = function (a2, b) {
    return a2.tabIndex === b.tabIndex
      ? a2.documentOrder - b.documentOrder
      : a2.tabIndex - b.tabIndex
  },
  isInput = function (node) {
    return node.tagName === 'INPUT'
  },
  isHiddenInput = function (node) {
    return isInput(node) && node.type === 'hidden'
  },
  isDetailsWithSummary = function (node) {
    var r2 =
      node.tagName === 'DETAILS' &&
      Array.prototype.slice.apply(node.children).some(function (child) {
        return child.tagName === 'SUMMARY'
      })
    return r2
  },
  getCheckedRadio = function (nodes, form) {
    for (var i2 = 0; i2 < nodes.length; i2++)
      if (nodes[i2].checked && nodes[i2].form === form) return nodes[i2]
  },
  isTabbableRadio = function (node) {
    if (!node.name) return !0
    var radioScope = node.form || getRootNode(node),
      queryRadios = function (name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]')
      },
      radioSet
    if (typeof window < 'u' && typeof window.CSS < 'u' && typeof window.CSS.escape == 'function')
      radioSet = queryRadios(window.CSS.escape(node.name))
    else
      try {
        radioSet = queryRadios(node.name)
      } catch (err) {
        return (
          console.error(
            'Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s',
            err.message
          ),
          !1
        )
      }
    var checked = getCheckedRadio(radioSet, node.form)
    return !checked || checked === node
  },
  isRadio = function (node) {
    return isInput(node) && node.type === 'radio'
  },
  isNonTabbableRadio = function (node) {
    return isRadio(node) && !isTabbableRadio(node)
  },
  isZeroArea = function (node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height
    return width === 0 && height === 0
  },
  isHidden = function (node, _ref) {
    var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot
    if (getComputedStyle(node).visibility === 'hidden') return !0
    var isDirectSummary = matches.call(node, 'details>summary:first-of-type'),
      nodeUnderDetails = isDirectSummary ? node.parentElement : node
    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) return !0
    var nodeRootHost = getRootNode(node).host,
      nodeIsAttached =
        nodeRootHost?.ownerDocument.contains(nodeRootHost) || node.ownerDocument.contains(node)
    if (!displayCheck || displayCheck === 'full') {
      if (typeof getShadowRoot == 'function') {
        for (var originalNode = node; node; ) {
          var parentElement = node.parentElement,
            rootNode = getRootNode(node)
          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === !0)
            return isZeroArea(node)
          node.assignedSlot
            ? (node = node.assignedSlot)
            : !parentElement && rootNode !== node.ownerDocument
            ? (node = rootNode.host)
            : (node = parentElement)
        }
        node = originalNode
      }
      if (nodeIsAttached) return !node.getClientRects().length
    } else if (displayCheck === 'non-zero-area') return isZeroArea(node)
    return !1
  },
  isDisabledFromFieldset = function (node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName))
      for (var parentNode = node.parentElement; parentNode; ) {
        if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
          for (var i2 = 0; i2 < parentNode.children.length; i2++) {
            var child = parentNode.children.item(i2)
            if (child.tagName === 'LEGEND')
              return matches.call(parentNode, 'fieldset[disabled] *') ? !0 : !child.contains(node)
          }
          return !0
        }
        parentNode = parentNode.parentElement
      }
    return !1
  },
  isNodeMatchingSelectorFocusable = function (options, node) {
    return !(
      node.disabled ||
      isHiddenInput(node) ||
      isHidden(node, options) ||
      isDetailsWithSummary(node) ||
      isDisabledFromFieldset(node)
    )
  },
  isNodeMatchingSelectorTabbable = function (options, node) {
    return !(
      isNonTabbableRadio(node) ||
      getTabindex(node) < 0 ||
      !isNodeMatchingSelectorFocusable(options, node)
    )
  },
  isValidShadowRootTabbable = function (shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10)
    return !!(isNaN(tabIndex) || tabIndex >= 0)
  },
  sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [],
      orderedTabbables = []
    return (
      candidates.forEach(function (item, i2) {
        var isScope = !!item.scope,
          element = isScope ? item.scope : item,
          candidateTabindex = getTabindex(element, isScope),
          elements = isScope ? sortByOrder2(item.candidates) : element
        candidateTabindex === 0
          ? isScope
            ? regularTabbables.push.apply(regularTabbables, elements)
            : regularTabbables.push(element)
          : orderedTabbables.push({
              documentOrder: i2,
              tabIndex: candidateTabindex,
              item,
              isScope,
              content: elements,
            })
      }),
      orderedTabbables
        .sort(sortOrderedTabbables)
        .reduce(function (acc, sortable) {
          return (
            sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content),
            acc
          )
        }, [])
        .concat(regularTabbables)
    )
  },
  tabbable = function (el, options) {
    options = options || {}
    var candidates
    return (
      options.getShadowRoot
        ? (candidates = getCandidatesIteratively([el], options.includeContainer, {
            filter: isNodeMatchingSelectorTabbable.bind(null, options),
            flatten: !1,
            getShadowRoot: options.getShadowRoot,
            shadowRootFilter: isValidShadowRootTabbable,
          }))
        : (candidates = getCandidates(
            el,
            options.includeContainer,
            isNodeMatchingSelectorTabbable.bind(null, options)
          )),
      sortByOrder(candidates)
    )
  },
  focusable = function (el, options) {
    options = options || {}
    var candidates
    return (
      options.getShadowRoot
        ? (candidates = getCandidatesIteratively([el], options.includeContainer, {
            filter: isNodeMatchingSelectorFocusable.bind(null, options),
            flatten: !0,
            getShadowRoot: options.getShadowRoot,
          }))
        : (candidates = getCandidates(
            el,
            options.includeContainer,
            isNodeMatchingSelectorFocusable.bind(null, options)
          )),
      candidates
    )
  },
  isTabbable = function (node, options) {
    if (((options = options || {}), !node)) throw new Error('No node provided')
    return matches.call(node, candidateSelector) === !1
      ? !1
      : isNodeMatchingSelectorTabbable(options, node)
  },
  focusableCandidateSelector = candidateSelectors.concat('iframe').join(','),
  isFocusable = function (node, options) {
    if (((options = options || {}), !node)) throw new Error('No node provided')
    return matches.call(node, focusableCandidateSelector) === !1
      ? !1
      : isNodeMatchingSelectorFocusable(options, node)
  }
/*!
 * focus-trap 6.9.4
 * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
 */ function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object)
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object)
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable
      })),
      keys.push.apply(keys, symbols)
  }
  return keys
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {}
    i2 % 2
      ? ownKeys(Object(source), !0).forEach(function (key) {
          _defineProperty(target, key, source[key])
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
        })
  }
  return target
}
function _defineProperty(obj, key, value) {
  return (
    key in obj
      ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 })
      : (obj[key] = value),
    obj
  )
}
var activeFocusTraps = (function () {
    var trapQueue = []
    return {
      activateTrap: function (trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1]
          activeTrap !== trap && activeTrap.pause()
        }
        var trapIndex = trapQueue.indexOf(trap)
        trapIndex === -1 || trapQueue.splice(trapIndex, 1), trapQueue.push(trap)
      },
      deactivateTrap: function (trap) {
        var trapIndex = trapQueue.indexOf(trap)
        trapIndex !== -1 && trapQueue.splice(trapIndex, 1),
          trapQueue.length > 0 && trapQueue[trapQueue.length - 1].unpause()
      },
    }
  })(),
  isSelectableInput = function (node) {
    return (
      node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select == 'function'
    )
  },
  isEscapeEvent = function (e2) {
    return e2.key === 'Escape' || e2.key === 'Esc' || e2.keyCode === 27
  },
  isTabEvent = function (e2) {
    return e2.key === 'Tab' || e2.keyCode === 9
  },
  delay = function (fn) {
    return setTimeout(fn, 0)
  },
  findIndex = function (arr, fn) {
    var idx = -1
    return (
      arr.every(function (value, i2) {
        return fn(value) ? ((idx = i2), !1) : !0
      }),
      idx
    )
  },
  valueOrHandler = function (value) {
    for (
      var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1;
      _key < _len;
      _key++
    )
      params[_key - 1] = arguments[_key]
    return typeof value == 'function' ? value.apply(void 0, params) : value
  },
  getActualTarget = function (event) {
    return event.target.shadowRoot && typeof event.composedPath == 'function'
      ? event.composedPath()[0]
      : event.target
  },
  createFocusTrap = function (elements, userOptions) {
    var doc = userOptions?.document || document,
      config = _objectSpread2(
        { returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0 },
        userOptions
      ),
      state = {
        containers: [],
        containerGroups: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0,
      },
      trap,
      getOption = function (configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0
          ? configOverrideOptions[optionName]
          : config[configOptionName || optionName]
      },
      findContainerIndex = function (element) {
        return state.containerGroups.findIndex(function (_ref) {
          var container = _ref.container,
            tabbableNodes = _ref.tabbableNodes
          return (
            container.contains(element) ||
            tabbableNodes.find(function (node) {
              return node === element
            })
          )
        })
      },
      getNodeForOption = function (optionName) {
        var optionValue = config[optionName]
        if (typeof optionValue == 'function') {
          for (
            var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1;
            _key2 < _len2;
            _key2++
          )
            params[_key2 - 1] = arguments[_key2]
          optionValue = optionValue.apply(void 0, params)
        }
        if ((optionValue === !0 && (optionValue = void 0), !optionValue)) {
          if (optionValue === void 0 || optionValue === !1) return optionValue
          throw new Error(
            '`'.concat(optionName, '` was specified but was not a node, or did not return a node')
          )
        }
        var node = optionValue
        if (typeof optionValue == 'string' && ((node = doc.querySelector(optionValue)), !node))
          throw new Error('`'.concat(optionName, '` as selector refers to no known node'))
        return node
      },
      getInitialFocusNode = function () {
        var node = getNodeForOption('initialFocus')
        if (node === !1) return !1
        if (node === void 0)
          if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement
          else {
            var firstTabbableGroup = state.tabbableGroups[0],
              firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode
            node = firstTabbableNode || getNodeForOption('fallbackFocus')
          }
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element')
        return node
      },
      updateTabbableNodes = function () {
        if (
          ((state.containerGroups = state.containers.map(function (container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions),
              focusableNodes = focusable(container, config.tabbableOptions)
            return {
              container,
              tabbableNodes,
              focusableNodes,
              firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
              lastTabbableNode:
                tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
              nextTabbableNode: function (node) {
                var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                  nodeIdx = focusableNodes.findIndex(function (n2) {
                    return n2 === node
                  })
                if (!(nodeIdx < 0))
                  return forward
                    ? focusableNodes.slice(nodeIdx + 1).find(function (n2) {
                        return isTabbable(n2, config.tabbableOptions)
                      })
                    : focusableNodes
                        .slice(0, nodeIdx)
                        .reverse()
                        .find(function (n2) {
                          return isTabbable(n2, config.tabbableOptions)
                        })
              },
            }
          })),
          (state.tabbableGroups = state.containerGroups.filter(function (group) {
            return group.tabbableNodes.length > 0
          })),
          state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus'))
        )
          throw new Error(
            'Your focus-trap must have at least one container with at least one tabbable node in it at all times'
          )
      },
      tryFocus = function tryFocus2(node) {
        if (node !== !1 && node !== doc.activeElement) {
          if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode())
            return
          }
          node.focus({ preventScroll: !!config.preventScroll }),
            (state.mostRecentlyFocusedNode = node),
            isSelectableInput(node) && node.select()
        }
      },
      getReturnFocusNode = function (previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', previousActiveElement)
        return node || (node === !1 ? !1 : previousActiveElement)
      },
      checkPointerDown = function (e2) {
        var target = getActualTarget(e2)
        if (!(findContainerIndex(target) >= 0)) {
          if (valueOrHandler(config.clickOutsideDeactivates, e2)) {
            trap.deactivate({
              returnFocus:
                config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions),
            })
            return
          }
          valueOrHandler(config.allowOutsideClick, e2) || e2.preventDefault()
        }
      },
      checkFocusIn = function (e2) {
        var target = getActualTarget(e2),
          targetContained = findContainerIndex(target) >= 0
        targetContained || target instanceof Document
          ? targetContained && (state.mostRecentlyFocusedNode = target)
          : (e2.stopImmediatePropagation(),
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode()))
      },
      checkTab = function (e2) {
        var target = getActualTarget(e2)
        updateTabbableNodes()
        var destinationNode = null
        if (state.tabbableGroups.length > 0) {
          var containerIndex = findContainerIndex(target),
            containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0
          if (containerIndex < 0)
            e2.shiftKey
              ? (destinationNode =
                  state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode)
              : (destinationNode = state.tabbableGroups[0].firstTabbableNode)
          else if (e2.shiftKey) {
            var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
              var firstTabbableNode = _ref2.firstTabbableNode
              return target === firstTabbableNode
            })
            if (
              (startOfGroupIndex < 0 &&
                (containerGroup.container === target ||
                  (isFocusable(target, config.tabbableOptions) &&
                    !isTabbable(target, config.tabbableOptions) &&
                    !containerGroup.nextTabbableNode(target, !1))) &&
                (startOfGroupIndex = containerIndex),
              startOfGroupIndex >= 0)
            ) {
              var destinationGroupIndex =
                  startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1,
                destinationGroup = state.tabbableGroups[destinationGroupIndex]
              destinationNode = destinationGroup.lastTabbableNode
            }
          } else {
            var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
              var lastTabbableNode = _ref3.lastTabbableNode
              return target === lastTabbableNode
            })
            if (
              (lastOfGroupIndex < 0 &&
                (containerGroup.container === target ||
                  (isFocusable(target, config.tabbableOptions) &&
                    !isTabbable(target, config.tabbableOptions) &&
                    !containerGroup.nextTabbableNode(target))) &&
                (lastOfGroupIndex = containerIndex),
              lastOfGroupIndex >= 0)
            ) {
              var _destinationGroupIndex =
                  lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1,
                _destinationGroup = state.tabbableGroups[_destinationGroupIndex]
              destinationNode = _destinationGroup.firstTabbableNode
            }
          }
        } else destinationNode = getNodeForOption('fallbackFocus')
        destinationNode && (e2.preventDefault(), tryFocus(destinationNode))
      },
      checkKey = function (e2) {
        if (isEscapeEvent(e2) && valueOrHandler(config.escapeDeactivates, e2) !== !1) {
          e2.preventDefault(), trap.deactivate()
          return
        }
        if (isTabEvent(e2)) {
          checkTab(e2)
          return
        }
      },
      checkClick = function (e2) {
        var target = getActualTarget(e2)
        findContainerIndex(target) >= 0 ||
          valueOrHandler(config.clickOutsideDeactivates, e2) ||
          valueOrHandler(config.allowOutsideClick, e2) ||
          (e2.preventDefault(), e2.stopImmediatePropagation())
      },
      addListeners = function () {
        if (state.active)
          return (
            activeFocusTraps.activateTrap(trap),
            (state.delayInitialFocusTimer = config.delayInitialFocus
              ? delay(function () {
                  tryFocus(getInitialFocusNode())
                })
              : tryFocus(getInitialFocusNode())),
            doc.addEventListener('focusin', checkFocusIn, !0),
            doc.addEventListener('mousedown', checkPointerDown, { capture: !0, passive: !1 }),
            doc.addEventListener('touchstart', checkPointerDown, { capture: !0, passive: !1 }),
            doc.addEventListener('click', checkClick, { capture: !0, passive: !1 }),
            doc.addEventListener('keydown', checkKey, { capture: !0, passive: !1 }),
            trap
          )
      },
      removeListeners = function () {
        if (state.active)
          return (
            doc.removeEventListener('focusin', checkFocusIn, !0),
            doc.removeEventListener('mousedown', checkPointerDown, !0),
            doc.removeEventListener('touchstart', checkPointerDown, !0),
            doc.removeEventListener('click', checkClick, !0),
            doc.removeEventListener('keydown', checkKey, !0),
            trap
          )
      }
    return (
      (trap = {
        get active() {
          return state.active
        },
        get paused() {
          return state.paused
        },
        activate: function (activateOptions) {
          if (state.active) return this
          var onActivate = getOption(activateOptions, 'onActivate'),
            onPostActivate = getOption(activateOptions, 'onPostActivate'),
            checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap')
          checkCanFocusTrap || updateTabbableNodes(),
            (state.active = !0),
            (state.paused = !1),
            (state.nodeFocusedBeforeActivation = doc.activeElement),
            onActivate && onActivate()
          var finishActivation = function () {
            checkCanFocusTrap && updateTabbableNodes(),
              addListeners(),
              onPostActivate && onPostActivate()
          }
          return checkCanFocusTrap
            ? (checkCanFocusTrap(state.containers.concat()).then(
                finishActivation,
                finishActivation
              ),
              this)
            : (finishActivation(), this)
        },
        deactivate: function (deactivateOptions) {
          if (!state.active) return this
          var options = _objectSpread2(
            {
              onDeactivate: config.onDeactivate,
              onPostDeactivate: config.onPostDeactivate,
              checkCanReturnFocus: config.checkCanReturnFocus,
            },
            deactivateOptions
          )
          clearTimeout(state.delayInitialFocusTimer),
            (state.delayInitialFocusTimer = void 0),
            removeListeners(),
            (state.active = !1),
            (state.paused = !1),
            activeFocusTraps.deactivateTrap(trap)
          var onDeactivate = getOption(options, 'onDeactivate'),
            onPostDeactivate = getOption(options, 'onPostDeactivate'),
            checkCanReturnFocus = getOption(options, 'checkCanReturnFocus'),
            returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate')
          onDeactivate && onDeactivate()
          var finishDeactivation = function () {
            delay(function () {
              returnFocus && tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)),
                onPostDeactivate && onPostDeactivate()
            })
          }
          return returnFocus && checkCanReturnFocus
            ? (checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(
                finishDeactivation,
                finishDeactivation
              ),
              this)
            : (finishDeactivation(), this)
        },
        pause: function () {
          return state.paused || !state.active
            ? this
            : ((state.paused = !0), removeListeners(), this)
        },
        unpause: function () {
          return !state.paused || !state.active
            ? this
            : ((state.paused = !1), updateTabbableNodes(), addListeners(), this)
        },
        updateContainerElements: function (containerElements) {
          var elementsAsArray = [].concat(containerElements).filter(Boolean)
          return (
            (state.containers = elementsAsArray.map(function (element) {
              return typeof element == 'string' ? doc.querySelector(element) : element
            })),
            state.active && updateTabbableNodes(),
            this
          )
        },
      }),
      trap.updateContainerElements(elements),
      trap
    )
  }
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i2 = 0, arr2 = Array(arr.length); i2 < arr.length; i2++) arr2[i2] = arr[i2]
    return arr2
  } else return Array.from(arr)
}
var hasPassiveEvents = !1
if (typeof window < 'u') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = !0
    },
  }
  window.addEventListener('testPassive', null, passiveTestOptions),
    window.removeEventListener('testPassive', null, passiveTestOptions)
}
var isIosDevice =
    typeof window < 'u' &&
    window.navigator &&
    window.navigator.platform &&
    (/iP(ad|hone|od)/.test(window.navigator.platform) ||
      (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)),
  locks = [],
  documentListenerAdded = !1,
  initialClientY = -1,
  previousBodyOverflowSetting = void 0,
  previousBodyPaddingRight = void 0,
  allowTouchMove = function (el) {
    return locks.some(function (lock) {
      return !!(lock.options.allowTouchMove && lock.options.allowTouchMove(el))
    })
  },
  preventDefault$1 = function (rawEvent) {
    var e2 = rawEvent || window.event
    return allowTouchMove(e2.target) || e2.touches.length > 1
      ? !0
      : (e2.preventDefault && e2.preventDefault(), !1)
  },
  setOverflowHidden = function (options) {
    if (previousBodyPaddingRight === void 0) {
      var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === !0,
        scrollBarGap = window.innerWidth - document.documentElement.clientWidth
      _reserveScrollBarGap &&
        scrollBarGap > 0 &&
        ((previousBodyPaddingRight = document.body.style.paddingRight),
        (document.body.style.paddingRight = scrollBarGap + 'px'))
    }
    previousBodyOverflowSetting === void 0 &&
      ((previousBodyOverflowSetting = document.body.style.overflow),
      (document.body.style.overflow = 'hidden'))
  },
  restoreOverflowSetting = function () {
    previousBodyPaddingRight !== void 0 &&
      ((document.body.style.paddingRight = previousBodyPaddingRight),
      (previousBodyPaddingRight = void 0)),
      previousBodyOverflowSetting !== void 0 &&
        ((document.body.style.overflow = previousBodyOverflowSetting),
        (previousBodyOverflowSetting = void 0))
  },
  isTargetElementTotallyScrolled = function (targetElement) {
    return targetElement
      ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight
      : !1
  },
  handleScroll = function (event, targetElement) {
    var clientY = event.targetTouches[0].clientY - initialClientY
    return allowTouchMove(event.target)
      ? !1
      : (targetElement && targetElement.scrollTop === 0 && clientY > 0) ||
        (isTargetElementTotallyScrolled(targetElement) && clientY < 0)
      ? preventDefault$1(event)
      : (event.stopPropagation(), !0)
  },
  disableBodyScroll = function (targetElement, options) {
    if (!targetElement) {
      console.error(
        'disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.'
      )
      return
    }
    if (
      !locks.some(function (lock2) {
        return lock2.targetElement === targetElement
      })
    ) {
      var lock = { targetElement, options: options || {} }
      ;(locks = [].concat(_toConsumableArray(locks), [lock])),
        isIosDevice
          ? ((targetElement.ontouchstart = function (event) {
              event.targetTouches.length === 1 && (initialClientY = event.targetTouches[0].clientY)
            }),
            (targetElement.ontouchmove = function (event) {
              event.targetTouches.length === 1 && handleScroll(event, targetElement)
            }),
            documentListenerAdded ||
              (document.addEventListener(
                'touchmove',
                preventDefault$1,
                hasPassiveEvents ? { passive: !1 } : void 0
              ),
              (documentListenerAdded = !0)))
          : setOverflowHidden(options)
    }
  },
  enableBodyScroll = function (targetElement) {
    if (!targetElement) {
      console.error(
        'enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.'
      )
      return
    }
    ;(locks = locks.filter(function (lock) {
      return lock.targetElement !== targetElement
    })),
      isIosDevice
        ? ((targetElement.ontouchstart = null),
          (targetElement.ontouchmove = null),
          documentListenerAdded &&
            locks.length === 0 &&
            (document.removeEventListener(
              'touchmove',
              preventDefault$1,
              hasPassiveEvents ? { passive: !1 } : void 0
            ),
            (documentListenerAdded = !1)))
        : locks.length || restoreOverflowSetting()
  },
  n$1 = function (n2) {
    if (typeof (t2 = n2) != 'object' || Array.isArray(t2)) throw 'state should be an object'
    var t2
  },
  t$1 = function (n2, t2, e2, c2) {
    return ((r2 = n2),
    r2.reduce(function (n3, t3, e3) {
      return n3.indexOf(t3) > -1 ? n3 : n3.concat(t3)
    }, []))
      .reduce(function (n3, e3) {
        return n3.concat(t2[e3] || [])
      }, [])
      .map(function (n3) {
        return n3(e2, c2)
      })
    var r2
  },
  e$1 = a(),
  c = e$1.on,
  r$1 = e$1.emit,
  o$1 = e$1.hydrate
function a(e2) {
  e2 === void 0 && (e2 = {})
  var c2 = {}
  return {
    getState: function () {
      return Object.assign({}, e2)
    },
    hydrate: function (r2) {
      return (
        n$1(r2),
        Object.assign(e2, r2),
        function () {
          var n2 = ['*'].concat(Object.keys(r2))
          t$1(n2, c2, e2)
        }
      )
    },
    on: function (n2, t2) {
      return (
        (n2 = [].concat(n2)).map(function (n3) {
          return (c2[n3] = (c2[n3] || []).concat(t2))
        }),
        function () {
          return n2.map(function (n3) {
            return c2[n3].splice(c2[n3].indexOf(t2), 1)
          })
        }
      )
    },
    emit: function (r2, o2, u2) {
      var a2 = (r2 === '*' ? [] : ['*']).concat(r2)
      ;(o2 = typeof o2 == 'function' ? o2(e2) : o2) &&
        (n$1(o2), Object.assign(e2, o2), (a2 = a2.concat(Object.keys(o2)))),
        t$1(a2, c2, e2, u2)
    },
  }
}
function wrapIframes() {
  ;(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).forEach((el) => {
    const wrapper = document.createElement('div')
    wrapper.classList.add('rte__iframe'),
      el.parentNode.insertBefore(wrapper, el),
      wrapper.appendChild(el),
      (el.src = el.src)
  })
}
function wrapTables() {
  ;(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).forEach((el) => {
    const wrapper = document.createElement('div')
    wrapper.classList.add('rte__table-wrapper'),
      (wrapper.tabIndex = 0),
      el.parentNode.insertBefore(wrapper, el),
      wrapper.appendChild(el)
  })
}
const classes$I = { visible: 'is-visible', active: 'active', fixed: 'is-fixed' },
  selectors$1J = {
    closeBtn: '[data-modal-close]',
    wash: '.modal__wash',
    modalContent: '.modal__content',
  },
  modal = (node) => {
    const focusTrap = createFocusTrap(node, { allowOutsideClick: !0 }),
      modalContent = n$2(selectors$1J.modalContent, node)
    new Delegate(document).on('click', selectors$1J.wash, () => _close())
    const events2 = [
        e$2(n$2(selectors$1J.closeBtn, node), 'click', (e2) => {
          e2.preventDefault(), _close()
        }),
        e$2(node, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && _close()
        }),
        c('modal:open', (state, _ref2) => {
          let { modalContent: modalContent2, narrow = !1 } = _ref2
          l(node, 'modal--narrow', narrow), _renderModalContent(modalContent2), _open()
        }),
      ],
      _renderModalContent = (content) => {
        const clonedContent = content.cloneNode(!0)
        ;(modalContent.innerHTML = ''),
          modalContent.appendChild(clonedContent),
          wrapIframes(t$2('iframe', modalContent)),
          wrapTables(t$2('table', modalContent))
      },
      _open = () => {
        u$1(node, classes$I.active),
          document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
          focusTrap.activate(),
          disableBodyScroll(node, {
            allowTouchMove: (el) => {
              for (; el && el !== document.body; ) {
                if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
                el = el.parentNode
              }
            },
            reserveScrollBarGap: !0,
          })
      },
      _close = () => {
        focusTrap.deactivate(),
          i$1(node, classes$I.active),
          document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
          enableBodyScroll(node),
          setTimeout(() => {
            modalContent.innerHTML = ''
          }, 300)
      }
    return {
      unload: () => {
        events2.forEach((unsubscribe) => unsubscribe())
      },
    }
  }
var AnimateProductItem = (items) => {
  const events2 = []
  items.forEach((item) => {
    const imageOne = n$2('.product-item__image--one', item),
      imageTwo = n$2('.product-item__image--two', item)
    t$2('.product-item-options__list', item),
      events2.push(
        e$2(item, 'mouseenter', () => {
          enterItemAnimation(imageOne, imageTwo)
        })
      ),
      events2.push(
        e$2(item, 'mouseleave', () => {
          leaveItemAnimation(imageOne, imageTwo)
        })
      )
  })
  function enterItemAnimation(imageOne, imageTwo, optionsElements) {
    imageTwo && u$1(imageTwo, 'active')
  }
  function leaveItemAnimation(imageOne, imageTwo, optionsElements) {
    imageTwo && i$1(imageTwo, 'active')
  }
  return {
    destroy() {
      events2.forEach((unsubscribe) => unsubscribe())
    },
  }
}
function getMediaQuery(querySize) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    '--media-'.concat(querySize)
  )
  return value || (console.warn('Invalid querySize passed to getMediaQuery'), !1)
}
var intersectionWatcher = function (node) {
    let instant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1
    const margin = window.matchMedia(getMediaQuery('above-720')).matches ? 200 : 100
    let threshold = 0
    instant || (threshold = Math.min(margin / node.offsetHeight, 0.5))
    const observer = new IntersectionObserver(
      (_ref) => {
        let [{ isIntersecting: visible }] = _ref
        visible && (u$1(node, 'is-visible'), observer.disconnect())
      },
      { threshold }
    )
    return (
      observer.observe(node),
      {
        destroy() {
          observer?.disconnect()
        },
      }
    )
  },
  delayOffset = function (node, items) {
    let delayOffset2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0
    items.forEach((selector) => {
      t$2(selector, node).forEach((item) => {
        item.style.setProperty('--delay-offset-multiplier', delayOffset2), delayOffset2++
      })
    })
  },
  shouldAnimate = (node) =>
    a$1(node, 'animation') && !a$1(document.documentElement, 'prefers-reduced-motion')
const selectors$1I = {
  sectionBlockItems: '.section-blocks > *',
  image: '.image-with-text__image .image__img',
  imageSmall: '.image-with-text__small-image .image__img',
  imageCaption: '.image-with-text__image-caption',
}
var animateImageWithText = (node) => {
  delayOffset(node, [selectors$1I.image, selectors$1I.imageSmall, selectors$1I.imageCaption]),
    delayOffset(node, [selectors$1I.sectionBlockItems], 6)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1H = {
  sectionBlockItems: '.section-blocks > *',
  image: '.image-with-text-split__image .image__img',
}
var animateImageWithTextSplit = (node) => {
  delayOffset(node, [selectors$1H.image]), delayOffset(node, [selectors$1H.sectionBlockItems], 6)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1G = {
    content: '.testimonials__item-content > *',
    image: '.testimonials__item-product-image',
    imageCaption: '.testimonials__item-product-title',
    item: '.animation--item',
  },
  classes$H = { imageRight: 'testimonials__item--image-placement-right' }
var animateTestimonials = (node) => {
  const delayItems = []
  a$1(node, classes$H.imageRight)
    ? (delayItems.push(selectors$1G.content),
      delayItems.push(selectors$1G.image),
      delayItems.push(selectors$1G.imageCaption))
    : (delayItems.push(selectors$1G.image),
      delayItems.push(selectors$1G.imageCaption),
      delayItems.push(selectors$1G.content)),
    delayOffset(node, delayItems, 2),
    delayOffset(node, [selectors$1G.item])
}
const selectors$1F = { content: '.quote__item-inner > *' }
var animateQuotes = (node) => {
  delayOffset(node, [selectors$1F.content])
}
const selectors$1E = {
  sectionBlockItems: '.animation--section-introduction > *',
  controls: '.animation--controls',
  items: '.animation--item',
}
var animateListSlider = (node) => {
  const delayItems = [selectors$1E.sectionBlockItems, selectors$1E.controls, selectors$1E.items]
  delayOffset(node, delayItems)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1D = {
    introductionItems: '.section-introduction > *',
    media:
      '.complete-the-look__image-wrapper .image__img, .complete-the-look__image-wrapper .video',
    product: '.complete-the-look__product',
    products: '.complete-the-look__products',
  },
  classes$G = { imageLeft: 'complete-the-look--image-left' }
var animateCompleteTheLook = (node) => {
  const delayItems = []
  delayItems.push(selectors$1D.introductionItems),
    a$1(node, classes$G.imageLeft) || window.matchMedia(getMediaQuery('below-720')).matches
      ? (delayItems.push(selectors$1D.media),
        delayItems.push(selectors$1D.products),
        delayItems.push(selectors$1D.product))
      : (delayItems.push(selectors$1D.products),
        delayItems.push(selectors$1D.product),
        delayItems.push(selectors$1D.media)),
    delayOffset(node, delayItems)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer.destroy()
    },
  }
}
const selectors$1C = {
  introductionItems: '.section-introduction > *',
  image: '.shoppable-image__image-wrapper .image__img',
  hotspots: '.shoppable-item__hotspot-wrapper',
}
var animateShoppableImage = (node) => {
  delayOffset(node, [selectors$1C.introductionItems, selectors$1C.image, selectors$1C.hotspots])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer.destroy()
    },
  }
}
const selectors$1B = {
  introductionItems: '.section-introduction > *',
  carousel: '.shoppable-feature__secondary-content .shoppable-feature__carousel-outer',
  hotspots: '.shoppable-item__hotspot-wrapper',
  mobileDrawerItems:
    '.animation--shoppable-feature-mobile-drawer  .shoppable-feature__carousel-outer > *:not(.swiper-pagination)',
}
var animateShoppableFeature = (node) => {
  delayOffset(node, [selectors$1B.introductionItems, selectors$1B.carousel], 1),
    delayOffset(node, [selectors$1B.hotspots], 1),
    delayOffset(node, [selectors$1B.mobileDrawerItems], 1)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer.destroy()
    },
  }
}
const selectors$1A = { textContent: '.image-hero-split-item__text-container-inner > *' }
var animateImageHeroSplit = (node) => {
  delayOffset(node, [selectors$1A.textContent], 1)
}
const selectors$1z = { textContent: '.image-hero__text-container-inner > *' }
var animateImageHero = (node) => {
  delayOffset(node, [selectors$1z.textContent], 3)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const classes$F = { animation: 'animation--image-compare' },
  selectors$1y = {
    introductionItems: '.animation--section-introduction > *',
    image: '.image_compare__image-wrapper .image__img',
    labels: '.image-compare__label-container',
    sliderLine: '.image-compare__slider-line',
    sliderButton: '.image-compare__slider-button',
  }
var animateImageCompare = (node) => {
  delayOffset(node, [
    selectors$1y.introductionItems,
    selectors$1y.image,
    selectors$1y.labels,
    selectors$1y.sliderLine,
    selectors$1y.sliderButton,
  ])
  const margin = window.matchMedia(getMediaQuery('above-720')).matches ? 200 : 100,
    threshold = Math.min(margin / node.offsetHeight, 0.5),
    observer = new IntersectionObserver(
      (_ref) => {
        let [{ isIntersecting: visible }] = _ref
        visible &&
          (u$1(node, 'is-visible'),
          setTimeout(() => {
            i$1(node, classes$F.animation)
          }, 1200),
          observer.disconnect())
      },
      { threshold }
    )
  return (
    observer.observe(node),
    {
      destroy() {
        observer.destroy()
      },
    }
  )
}
const selectors$1x = { textContent: '.video__text-container > *' }
var animateVideo = (node) => {
  delayOffset(node, [selectors$1x.textContent], 3)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1w = { textContent: '.video-hero__text-container > *' }
var animateVideoHero = (node) => {
  delayOffset(node, [selectors$1w.textContent], 3)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1v = {
  articleHeading: `
    .article__image-container,
    .article__header-inner > *
  `,
  articleContent: '.article__content',
}
var animateArticle = (node) => {
  delayOffset(node, [selectors$1v.articleHeading, selectors$1v.articleContent])
  const articleHeading = t$2(selectors$1v.articleHeading, node),
    articleContent = n$2(selectors$1v.articleContent, node),
    observers = articleHeading.map((item) => intersectionWatcher(item))
  return (
    observers.push(intersectionWatcher(articleContent)),
    {
      destroy() {
        observers.forEach((observer) => observer.destroy())
      },
    }
  )
}
const selectors$1u = {
  image: '.collection-banner__image-container',
  content: '.collection-banner__text-container-inner > *',
}
var animateCollectionBanner = (node) => {
  delayOffset(node, [selectors$1u.image, selectors$1u.content])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1t = {
    stickyHeader: ".header[data-enable-sticky-header='true']",
    partial: '[data-partial]',
    filterBar: '[data-filter-bar]',
    mobileFilterBar: '[data-mobile-filters]',
    productItems: '.animation--item:not(.animation--item-revealed)',
  },
  classes$E = {
    hideProducts: 'animation--collection-products-hide',
    itemRevealed: 'animation--item-revealed',
    stickyFilterBar: 'filter-bar--sticky',
  }
var animateCollection = (node) => {
  const stickyHeader = n$2(selectors$1t.stickyHeader, document),
    partial = n$2(selectors$1t.partial, node),
    filterbarEl = n$2(selectors$1t.filterBar, node),
    mobileFilterBarEl = n$2(selectors$1t.mobileFilterBar, node)
  let filterbarObserver = null
  filterbarEl && (filterbarObserver = intersectionWatcher(filterbarEl, !0))
  let mobileFilterBarObserver = null
  mobileFilterBarEl && (mobileFilterBarObserver = intersectionWatcher(mobileFilterBarEl, !0)),
    setupProductItem()
  function setupProductItem() {
    let productItems = t$2(selectors$1t.productItems, node)
    delayOffset(node, [selectors$1t.productItems]),
      setTimeout(() => {
        u$1(productItems, classes$E.itemRevealed)
      }, 0)
  }
  function _scrollIntoView() {
    const stickyHeaderHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height / 2 : 0,
      y = node.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  function updateContents() {
    setupProductItem(), i$1(partial, classes$E.hideProducts), _scrollIntoView()
  }
  function infiniteScrollReveal() {
    setupProductItem()
  }
  return {
    updateContents,
    infiniteScrollReveal,
    destroy() {
      var _filterbarObserver, _mobileFilterBarObser
      ;(_filterbarObserver = filterbarObserver) === null ||
        _filterbarObserver === void 0 ||
        _filterbarObserver.destroy(),
        (_mobileFilterBarObser = mobileFilterBarObserver) === null ||
          _mobileFilterBarObser === void 0 ||
          _mobileFilterBarObser.destroy()
    },
  }
}
const selectors$1s = {
  saleAmount: '.animation--sale-amount',
  sectionBlockItems: '.animation--section-blocks > *',
  saleItems: `.sale-promotion .sale-promotion__type,
  .sale-promotion .sale-promotion__unit-currency,
  .sale-promotion .sale-promotion__unit-percent,
  .sale-promotion .sale-promotion__unit-off,
  .sale-promotion .sale-promotion__amount,
  .sale-promotion .sale-promotion__per-month,
  .sale-promotion .sale-promotion__per-year,
  .sale-promotion .sale-promotion__terms,
  .sale-promotion .sales-banner__button`,
}
var animateSalesBanner = (node) => {
  const leftColumnDelayItems = [selectors$1s.saleAmount, selectors$1s.saleItems],
    rightColumnDelayItems = [selectors$1s.sectionBlockItems]
  delayOffset(node, leftColumnDelayItems), delayOffset(node, rightColumnDelayItems, 1)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1r = { sectionBlockItems: '.section-blocks > *' }
var animateCountdownBanner = (node) => {
  const observer = intersectionWatcher(node)
  return (
    delayOffset(node, [selectors$1r.sectionBlockItems]),
    {
      destroy() {
        observer?.destroy()
      },
    }
  )
}
const selectors$1q = {
  items: `
  .sales-banner__bar-item--heading,
  .sales-banner__bar-text,
  .sales-banner__button,
  .countdown-banner__bar-item--heading,
  .countdown-banner__bar-item--timer,
  .countdown-banner__bar-text,
  .countdown-banner__button`,
}
var animateCountdownBar = (node) => {
    const observer = intersectionWatcher(node)
    return (
      delayOffset(node, [selectors$1q.items]),
      {
        destroy() {
          observer?.destroy()
        },
      }
    )
  },
  animatePromotionBar = (node) => {
    const observer = intersectionWatcher(node)
    return {
      destroy() {
        observer?.destroy()
      },
    }
  }
const selectors$1p = {
  headerItems: '.animation--blog-header > *',
  articleItem: '.article-item',
  pagination: '.blog__pagination',
}
var animateBlog = (node) => {
  delayOffset(node, [selectors$1p.headerItems, selectors$1p.articleItem, selectors$1p.pagination])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1o = {
    flyouts: '[data-filter-modal]',
    animationFilterDrawerItem: '.animation--filter-drawer-item',
  },
  classes$D = {
    animationRevealed: 'animation--filter-bar-revealed',
    animationFilterDrawerItem: 'animation--filter-drawer-item',
  }
var animateFilterDrawer = (node) => {
  t$2(selectors$1o.flyouts, node).forEach(_setupItemOffsets)
  function _setupItemOffsets(flyout) {
    delayOffset(flyout, [selectors$1o.animationFilterDrawerItem])
  }
  function open(flyout) {
    u$1(flyout, classes$D.animationRevealed)
  }
  function close(flyouts2) {
    i$1(flyouts2, classes$D.animationRevealed)
  }
  return { open, close }
}
const selectors$1n = {
    sidebar: '.filter-sidebar-inner',
    sidebarItem: '.animation--filter-drawer-item',
  },
  classes$C = { animationRevealed: 'animation--filter-sidebar-revealed' }
var animateFilterSidebar = (node) => {
  const sidebar = n$2(selectors$1n.sidebar, node)
  delayOffset(sidebar, [selectors$1n.sidebarItem])
  function open(sidebar2) {
    u$1(sidebar2, classes$C.animationRevealed)
  }
  function close(sidebar2) {
    i$1(sidebar2, classes$C.animationRevealed)
  }
  return { open, close }
}
const selectors$1m = { animationItem: '.animation--drawer-menu-item' },
  classes$B = { animationRevealed: 'animation--drawer-menu-revealed' }
var animateDrawerMenu = (node) => {
  delayOffset(node, [selectors$1m.animationItem])
  function open() {
    shouldAnimate(node) && u$1(node, classes$B.animationRevealed)
  }
  function close() {
    shouldAnimate(node) && i$1(node, classes$B.animationRevealed)
  }
  return { open, close }
}
const selectors$1l = {
    animationItem: '.animation--quick-cart-items > *, .animation--quick-cart-footer',
  },
  classes$A = { animationRevealed: 'animation--quick-cart-revealed' }
var animateQuickCart = (node) => {
  setup()
  function open() {
    u$1(node, classes$A.animationRevealed)
  }
  function close() {
    i$1(node, classes$A.animationRevealed)
  }
  function setup() {
    delayOffset(node, [selectors$1l.animationItem])
  }
  return { open, close, setup }
}
const selectors$1k = { animationItems: '.animation--quick-view-items > *' },
  classes$z = { animationRevealed: 'animation--quick-view-revealed' }
var animateQuickView = (node) => {
  function animate() {
    delayOffset(node, [selectors$1k.animationItems]),
      setTimeout(() => {
        u$1(node, classes$z.animationRevealed)
      }, 0)
  }
  function reset() {
    i$1(node, classes$z.animationRevealed)
  }
  return { animate, reset }
}
const selectors$1j = {
  columns: '.meganav__list-parent > li',
  image: '.meganav__promo-image .image__img',
  overlay: '.meganav__secondary-promo-overlay',
  promoItems: '.meganav__secondary-promo-text > *',
  hasPromo: 'meganav--has-promo',
  promoLeft: 'meganav--promo-position-left',
}
var animateMeganav = (node) => {
  const delayItems = [],
    columnItems = t$2(selectors$1j.columns, node)
  a$1(node, selectors$1j.hasPromo)
    ? (delayOffset(node, [selectors$1j.image, selectors$1j.overlay, selectors$1j.promoItems]),
      a$1(node, selectors$1j.promoLeft)
        ? assignColumnDelays(columnItems, 4)
        : assignColumnDelays(columnItems))
    : assignColumnDelays(columnItems),
    delayOffset(node, delayItems)
  function assignColumnDelays(items) {
    let delayMultiplier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0,
      columnOffset
    items.forEach((item, i2) => {
      const leftOffset = item.getBoundingClientRect
        ? item.getBoundingClientRect().left
        : item.offsetLeft
      i2 === 0 && (columnOffset = leftOffset),
        columnOffset != leftOffset && ((columnOffset = leftOffset), delayMultiplier++),
        item.style.setProperty('--delay-offset-multiplier', delayMultiplier)
    })
  }
}
const selectors$1i = { heading: '.list-collections__heading', productItems: '.animation--item' }
var animateListCollections = (node) => {
  delayOffset(node, [selectors$1i.heading, selectors$1i.productItems])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer.destroy()
    },
  }
}
const selectors$1h = { gridItems: '.grid-item' }
var animateGrid = (node) => {
  delayOffset(node, [selectors$1h.gridItems])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer.destroy()
    },
  }
}
const selectors$1g = {
    animationItems: '.animation--purchase-confirmation-item',
    animationFooterItems: '.animation--purchase-confirmation-footer-item',
  },
  classes$y = { animationRevealed: 'animation--purchase-confirmation-revealed' }
var animatePurchaseConfirmation = (node) => {
  function animate() {
    delayOffset(node, [selectors$1g.animationItems]),
      delayOffset(node, [selectors$1g.animationFooterItems]),
      setTimeout(() => {
        u$1(node, classes$y.animationRevealed)
      }, 0)
  }
  function reset() {
    i$1(node, classes$y.animationRevealed)
  }
  return { animate, reset }
}
const selectors$1f = { pageItems: '.page-section__inner > *' }
var animatePage = (node) => {
  delayOffset(node, [selectors$1f.pageItems])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer.forEach((observer2) => observer2.destroy())
    },
  }
}
const selectors$1e = { items: '.collapsible-row-list__inner > *' }
var animateCollapsibleRowList = (node) => {
  delayOffset(node, [selectors$1e.items])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1d = { items: '.animation--section-blocks > *' }
var animateRichText = (node) => {
  delayOffset(node, [selectors$1d.items])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1c = {
  headerItems: '.animation--section-introduction > *',
  articleItem: '.article-item',
}
var animateBlogPosts = (node) => {
  delayOffset(node, [selectors$1c.headerItems, selectors$1c.articleItem])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1b = { intro: '.animation--section-introduction > *', items: '.animation--item' }
var animateFeaturedCollectionGrid = (node) => {
  delayOffset(node, [selectors$1b.intro, selectors$1b.items])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$1a = {
  productItems: '.animation--item',
  introductionItems: '.animation--section-introduction > *',
}
var animateCollectionListGrid = (node) => {
  delayOffset(node, [selectors$1a.introductionItems, selectors$1a.productItems])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$19 = { animationItems: '.animation--store-availability-drawer-items > *' },
  classes$x = { animationRevealed: 'animation--store-availability-drawer-revealed' }
var animateStoreAvailabilityDrawer = (node) => {
  function animate() {
    t$2(selectors$19.animationItems, node).forEach((item, i2) => {
      item.style.setProperty('--position-offset-multiplier', i2)
    }),
      setTimeout(() => {
        u$1(node, classes$x.animationRevealed)
      }, 0)
  }
  function reset() {
    i$1(node, classes$x.animationRevealed)
  }
  return { animate, reset }
}
const selectors$18 = { media: '.animation--product-media' }
var animateProduct = (node) => {
  delayOffset(node, [selectors$18.media])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$17 = {
  headerItems: '.animation--section-introduction > *',
  animationItem: '.animation--item',
}
var animateContactForm = (node) => {
  delayOffset(node, [selectors$17.headerItems, selectors$17.animationItem])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$16 = {
    partial: '[data-partial]',
    filterBar: '[data-filter-bar]',
    mobileFilterBar: '[data-mobile-filters]',
    productItems: '.animation--item:not(.animation--item-revealed)',
  },
  classes$w = {
    hideProducts: 'animation--search-products-hide',
    itemRevealed: 'animation--item-revealed',
  }
var animateSearch = (node) => {
  const partial = n$2(selectors$16.partial, node),
    filterbarEl = n$2(selectors$16.filterBar, node),
    mobileFilterBarEl = n$2(selectors$16.mobileFilterBar, node)
  let filterbarObserver = null
  filterbarEl && (filterbarObserver = intersectionWatcher(filterbarEl, !0))
  let mobileFilterBarObserver = null
  mobileFilterBarEl && (mobileFilterBarObserver = intersectionWatcher(mobileFilterBarEl, !0)),
    _setupProductItem()
  function _setupProductItem() {
    let productItems = t$2(selectors$16.productItems, node)
    delayOffset(node, [selectors$16.productItems]),
      setTimeout(() => {
        u$1(productItems, classes$w.itemRevealed)
      }, 0)
  }
  function _scrollIntoView() {
    const y =
      partial.getBoundingClientRect().top +
      window.pageYOffset -
      filterbarEl.getBoundingClientRect().height
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  function updateContents() {
    _setupProductItem(), i$1(partial, classes$w.hideProducts), _scrollIntoView()
  }
  function infiniteScrollReveal() {
    _setupProductItem()
  }
  return {
    updateContents,
    infiniteScrollReveal,
    destroy() {
      var _filterbarObserver, _mobileFilterBarObser
      ;(_filterbarObserver = filterbarObserver) === null ||
        _filterbarObserver === void 0 ||
        _filterbarObserver.destroy(),
        (_mobileFilterBarObser = mobileFilterBarObserver) === null ||
          _mobileFilterBarObser === void 0 ||
          _mobileFilterBarObser.destroy()
    },
  }
}
const selectors$15 = { content: '.animation--section-blocks > *' }
var animateSearchBanner = (node) => {
  delayOffset(node, [selectors$15.content])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$14 = {
  headerItems: '.animation--section-introduction > *',
  columnItems: '.multi-column__grid-item',
}
var animateMultiColumn = (node) => {
  delayOffset(node, [selectors$14.headerItems, selectors$14.columnItems])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer.destroy()
    },
  }
}
const selectors$13 = { textContent: '.password__text-container-inner > *' }
var animatePassword = (node) => {
  delayOffset(node, [selectors$13.textContent], 3)
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$12 = { animationItem: '.animation--popup-item' },
  classes$v = { animationRevealed: 'animation--popup-revealed' }
var animatePopup = (node) => {
  delayOffset(node, [selectors$12.animationItem])
  function open() {
    shouldAnimate(node) && u$1(node, classes$v.animationRevealed)
  }
  function close() {
    shouldAnimate(node) && i$1(node, classes$v.animationRevealed)
  }
  return { open, close }
}
const selectors$11 = { items: '.animation--section-blocks > *' }
var animateNewsletter = (node) => {
  delayOffset(node, [selectors$11.items])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$10 = { items: '.animation--section-blocks > *' }
var animateNewsletterCompact = (node) => {
  delayOffset(node, [selectors$10.items])
  const observer = intersectionWatcher(node, !0)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$$ = {
  headerItems: '.animation--section-introduction > *',
  eventItems: '.event-item',
}
var animateEvents = (node) => {
  delayOffset(node, [selectors$$.headerItems])
  const observer = intersectionWatcher(node, !0)
  function animateEventItems() {
    delayOffset(node, [selectors$$.eventItems]),
      setTimeout(() => {
        u$1(node, 'animate-event-items')
      }, 50)
  }
  return {
    animateEventItems,
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$_ = {
  giantHeading: '.animation--giant-heading',
  sectionBlockItems: '.animation--section-blocks > *',
}
var animatePromoBanner = (node) => {
    delayOffset(node, [selectors$_.giantHeading, selectors$_.sectionBlockItems])
    const observer = intersectionWatcher(node)
    return {
      destroy() {
        observer?.destroy()
      },
    }
  },
  animateScrollingContent = (node) => {
    const observer = intersectionWatcher(node)
    return {
      destroy() {
        observer?.destroy()
      },
    }
  }
const selectors$Z = {
  controls: '.product-tabs__tab-buttons',
  items: '.product-tabs__tab-list-wrapper',
  accordionItems: '.accordion',
}
var animateProductTabs = (node) => {
  delayOffset(node, [selectors$Z.controls, selectors$Z.items]),
    delayOffset(node, [selectors$Z.accordionItems])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
const selectors$Y = { intro: '.animation--section-introduction > *', items: '.animation--item' }
var animateApps = (node) => {
  delayOffset(node, [selectors$Y.intro, selectors$Y.items])
  const observer = intersectionWatcher(node)
  return {
    destroy() {
      observer?.destroy()
    },
  }
}
function makeRequest(method, url) {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest()
    xhr.open(method, url),
      (xhr.onload = function () {
        this.status >= 200 && this.status < 300
          ? resolve(xhr.response)
          : reject(new Error(this.status))
      }),
      (xhr.onerror = function () {
        reject(new Error(this.status))
      }),
      xhr.send()
  })
}
const classes$u = { active: 'active' },
  selectors$X = {
    drawerTrigger: '[data-store-availability-drawer-trigger]',
    closeBtn: '[data-store-availability-close]',
    productTitle: '[data-store-availability-product-title]',
    variantTitle: '[data-store-availability-variant-title]',
    storeListContainer: '[data-store-list-container]',
    storeListContent: '[data-store-availability-list-content]',
    wash: '[data-store-availability-drawer-wash]',
    parentWrapper: '[data-store-availability-container]',
  },
  storeAvailabilityDrawer = (node) => {
    var focusTrap = createFocusTrap(node, { allowOutsideClick: !0 })
    const wash = n$2(selectors$X.wash, node.parentNode),
      productTitleContainer = n$2(selectors$X.productTitle),
      variantTitleContainer = n$2(selectors$X.variantTitle),
      storeListContainer = n$2(selectors$X.storeListContainer, node)
    let storeAvailabilityDrawerAnimate = null
    shouldAnimate(node) && (storeAvailabilityDrawerAnimate = animateStoreAvailabilityDrawer(node))
    const events2 = [
        e$2([n$2(selectors$X.closeBtn, node), wash], 'click', (e2) => {
          e2.preventDefault(), _close()
        }),
        e$2(node, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && _close()
        }),
      ],
      _handleClick = (target) => {
        const parentContainer = target.closest(selectors$X.parentWrapper),
          { baseUrl, variantId, productTitle, variantTitle } = parentContainer.dataset,
          variantSectionUrl = ''
            .concat(baseUrl, '/variants/')
            .concat(variantId, '/?section_id=store-availability')
        makeRequest('GET', variantSectionUrl)
          .then((storeAvailabilityHTML) => {
            let container = document.createElement('div')
            ;(container.innerHTML = storeAvailabilityHTML),
              (productTitleContainer.innerText = productTitle),
              (variantTitleContainer.innerText = variantTitle === 'null' ? '' : variantTitle)
            const storeList = n$2(selectors$X.storeListContent, container)
            ;(storeListContainer.innerHTML = ''), storeListContainer.appendChild(storeList)
          })
          .then(_open)
      },
      _open = () => {
        u$1(node, classes$u.active),
          shouldAnimate(node) && storeAvailabilityDrawerAnimate.animate(),
          node.setAttribute('aria-hidden', 'false'),
          focusTrap.activate(),
          document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
          disableBodyScroll(node, {
            allowTouchMove: (el) => {
              for (; el && el !== document.body; ) {
                if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
                el = el.parentNode
              }
            },
            reserveScrollBarGap: !0,
          })
      },
      _close = () => {
        focusTrap.deactivate(),
          i$1(node, classes$u.active),
          node.setAttribute('aria-hidden', 'true'),
          setTimeout(() => {
            shouldAnimate(node) && storeAvailabilityDrawerAnimate.reset(),
              document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
              enableBodyScroll(node)
          }, 500)
      }
    return (
      new Delegate(document.body).on('click', selectors$X.drawerTrigger, (_, target) =>
        _handleClick(target)
      ),
      {
        unload: () => {
          events2.forEach((unsubscribe) => unsubscribe())
        },
      }
    )
  },
  {
    strings: { accessibility: strings$7 },
  } = window.theme,
  handleTab = () => {
    let tabHandler = null
    const formElments = ['INPUT', 'TEXTAREA', 'SELECT']
    function handleFirstTab(e2) {
      e2.keyCode === 9 &&
        !formElments.includes(document.activeElement.tagName) &&
        (document.body.classList.add('user-is-tabbing'),
        tabHandler(),
        (tabHandler = e$2(window, 'mousedown', handleMouseDownOnce)))
    }
    function handleMouseDownOnce() {
      document.body.classList.remove('user-is-tabbing'),
        tabHandler(),
        (tabHandler = e$2(window, 'keydown', handleFirstTab))
    }
    tabHandler = e$2(window, 'keydown', handleFirstTab)
  },
  focusFormStatus = (node) => {
    const formStatus = n$2('.form-status', node)
    if (!formStatus) return
    const focusElement = n$2('[data-form-status]', formStatus)
    focusElement && focusElement.focus()
  },
  prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
function backgroundVideoHandler(container) {
  const pause = n$2('.video-pause', container),
    video = container.getElementsByTagName('VIDEO')[0]
  if (!pause || !video) return
  const pauseVideo = () => {
      video.pause(), (pause.innerText = strings$7.play_video)
    },
    playVideo = () => {
      video.play(), (pause.innerText = strings$7.pause_video)
    }
  prefersReducedMotion() && pauseVideo()
  const pauseListener = e$2(pause, 'click', (e2) => {
    e2.preventDefault(), video.paused ? playVideo() : pauseVideo()
  })
  return () => pauseListener()
}
const classes$t = { hidden: 'hidden' }
var sectionClasses = () => {
  function adjustClasses() {
    t$2('.main .shopify-section').forEach((section) => {
      const { firstElementChild: child } = section
      child && child.classList.contains(classes$t.hidden) && u$1(section, classes$t.hidden)
    })
  }
  adjustClasses(), e$2(document, 'shopify:section:load', adjustClasses)
}
const dispatchCustomEvent = function (eventName) {
  let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
  const detail = { detail: data },
    event = new CustomEvent(eventName, data ? detail : null)
  document.dispatchEvent(event)
}
function getVariantFromId(product, value) {
  if ((_validateProductStructure(product), typeof value != 'number'))
    throw new TypeError(value + ' is not a Number.')
  var result = product.variants.filter(function (variant) {
    return variant.id === value
  })
  return result[0] || null
}
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product)
  var optionArray = _createOptionArrayFromOptionCollection(product, collection)
  return getVariantFromOptionArray(product, optionArray)
}
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product), _validateOptionsArray(options)
  var result = product.variants.filter(function (variant) {
    return options.every(function (option, index) {
      return variant.options[index] === option
    })
  })
  return result[0] || null
}
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product), _validateSerializedArray(collection)
  var optionArray = []
  return (
    collection.forEach(function (option) {
      for (var i2 = 0; i2 < product.options.length; i2++)
        if (product.options[i2].name.toLowerCase() === option.name.toLowerCase()) {
          optionArray[i2] = option.value
          break
        }
    }),
    optionArray
  )
}
function _validateProductStructure(product) {
  if (typeof product != 'object') throw new TypeError(product + ' is not an object.')
  if (Object.keys(product).length === 0 && product.constructor === Object)
    throw new Error(product + ' is empty.')
}
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) throw new TypeError(collection + ' is not an array.')
  if (collection.length === 0) return []
  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name != 'string')
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      )
  } else throw new Error(collection[0] + 'does not contain name key.')
}
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] == 'object')
    throw new Error(options + 'is not a valid array of options.')
}
function getUrlWithVariant(url, id) {
  return /variant=/.test(url)
    ? url.replace(/(variant=)[^&]+/, '$1' + id)
    : /\?/.test(url)
    ? url.concat('&variant=').concat(id)
    : url.concat('?variant=').concat(id)
}
const selectors$W = {
    sentinal: '.scroll-sentinal',
    scrollButtons: '.scroll-button',
    scrollViewport: '[data-scroll-container-viewport]',
  },
  scrollContainer = (node) => {
    const sentinals = t$2(selectors$W.sentinal, node),
      buttons = t$2(selectors$W.scrollButtons, node),
      { axis, startAtEnd } = node.dataset,
      scrollAttribute = axis == 'vertical' ? 'scrollTop' : 'scrollLeft',
      scrollerViewport = n$2(selectors$W.scrollViewport, node)
    window.addEventListener(
      'load',
      () => {
        u$1(node, 'scroll-container-initialized'), startAtEnd === 'true' && _startAtEnd()
      },
      { once: !0 }
    )
    const events2 = [
        e$2(buttons, 'click', (e2) => {
          const button = e2.currentTarget,
            scrollAttribute2 = axis == 'vertical' ? 'scrollTop' : 'scrollLeft',
            scrollOffset = 100
          button.dataset.position === 'start'
            ? scrollerViewport[scrollAttribute2] < scrollOffset * 1.5
              ? (scrollerViewport[scrollAttribute2] = 0)
              : (scrollerViewport[scrollAttribute2] -= scrollOffset)
            : (scrollerViewport[scrollAttribute2] += scrollOffset)
        }),
      ],
      ioOptions = { root: scrollerViewport },
      intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          const position = entry.target.dataset.position,
            visible = entry.isIntersecting
          node.setAttribute('data-at-'.concat(position), visible ? 'true' : 'false')
        })
      }, ioOptions)
    sentinals.forEach((sentinal) => {
      intersectionObserver.observe(sentinal)
    })
    const scrollTo = (element) => {
        const scrollDistance =
          axis == 'vertical'
            ? element.offsetTop - element.getBoundingClientRect().height
            : element.offsetLeft - element.getBoundingClientRect().width
        scrollerViewport[scrollAttribute] = scrollDistance
      },
      unload2 = () => {
        sentinals.forEach((sentinal) => {
          intersectionObserver.unobserve(sentinal)
        }),
          events2.forEach((unsubscribe) => unsubscribe())
      }
    function _startAtEnd() {
      const scrollAttribute2 = axis == 'vertical' ? 'scrollTop' : 'scrollLeft',
        scrollDirection = axis == 'vertical' ? 'scrollHeight' : 'scrollWidth'
      ;(scrollerViewport[scrollAttribute2] = scrollerViewport[scrollDirection] * 2),
        (node.dataset.startAtEnd = !1)
    }
    return { scrollTo, unload: unload2 }
  }
var n,
  e,
  i,
  o,
  t,
  r,
  f,
  d,
  p,
  u = []
function w(n2, a2) {
  return (
    (e = window.pageXOffset),
    (o = window.pageYOffset),
    (r = window.innerHeight),
    (d = window.innerWidth),
    i === void 0 && (i = e),
    t === void 0 && (t = o),
    p === void 0 && (p = d),
    f === void 0 && (f = r),
    (a2 || o !== t || e !== i || r !== f || d !== p) &&
      ((function (n3) {
        for (var w2 = 0; w2 < u.length; w2++)
          u[w2]({ x: e, y: o, px: i, py: t, vh: r, pvh: f, vw: d, pvw: p }, n3)
      })(n2),
      (i = e),
      (t = o),
      (f = r),
      (p = d)),
    requestAnimationFrame(w)
  )
}
function srraf(e2) {
  return (
    u.indexOf(e2) < 0 && u.push(e2),
    (n = n || w(performance.now())),
    {
      update: function () {
        return w(performance.now(), !0), this
      },
      destroy: function () {
        u.splice(u.indexOf(e2), 1)
      },
    }
  )
}
const atBreakpointChange = (breakpointToWatch, callback) => {
    let screenUnderBP =
      (window.innerWidth || document.documentElement.clientWidth) <= breakpointToWatch
    const widthWatcher = srraf((_ref) => {
      let { vw } = _ref
      const currentScreenWidthUnderBP = vw <= breakpointToWatch
      if (currentScreenWidthUnderBP !== screenUnderBP)
        return (screenUnderBP = currentScreenWidthUnderBP), callback()
    })
    return {
      unload: () => {
        widthWatcher.destroy()
      },
    }
  },
  sel$4 = {
    container: '.social-share',
    button: '.social-share__button',
    popup: '.social-sharing__popup',
    copyURLButton: '.social-share__copy-url',
    successMessage: '.social-share__success-message',
  },
  classes$s = { hidden: 'hidden', linkCopied: 'social-sharing__popup--success' }
var SocialShare = (node) => {
  if (!node) return Function()
  const button = n$2(sel$4.button, node),
    popup = n$2(sel$4.popup, node),
    copyURLButton = n$2(sel$4.copyURLButton, node),
    successMessage = n$2(sel$4.successMessage, node)
  let clickListener = e$2(window, 'click', handleClick)
  ;(!navigator.clipboard || !navigator.clipboard.writeText) && u$1(copyURLButton, classes$s.hidden)
  function handleClick(evt) {
    const buttonClicked = evt.target.closest(sel$4.button) === button,
      popupClicked = evt.target.closest(sel$4.popup) === popup,
      copyURLClicked = evt.target.closest(sel$4.copyURLButton) === copyURLButton
    let isActive = !1
    if (
      (buttonClicked && (isActive = button.getAttribute('aria-expanded') === 'true'),
      popupClicked || close(),
      buttonClicked && !isActive && open(),
      copyURLClicked)
    ) {
      const { url } = copyURLButton.dataset
      writeToClipboard(url).then(showSuccessMessage, showErrorMessage)
    }
  }
  function close() {
    button.setAttribute('aria-expanded', !1), popup.setAttribute('aria-hidden', !0)
  }
  function open() {
    button.setAttribute('aria-expanded', !0), popup.setAttribute('aria-hidden', !1)
  }
  function writeToClipboard(str) {
    return navigator.clipboard.writeText(str)
  }
  function showMessage(message) {
    ;(successMessage.innerHTML = message),
      i$1(successMessage, classes$s.hidden),
      u$1(popup, classes$s.linkCopied),
      setTimeout(() => {
        u$1(successMessage, classes$s.hidden), i$1(popup, classes$s.linkCopied)
      }, 2e3)
  }
  function showSuccessMessage() {
    const { successMessage: successMessage2 } = copyURLButton.dataset
    showMessage(successMessage2)
  }
  function showErrorMessage() {
    const { errorMessage } = copyURLButton.dataset
    showMessage(errorMessage || 'Error copying link.')
  }
  function destroy2() {
    close(), clickListener()
  }
  return destroy2
}
function localStorageAvailable() {
  var test = 'test'
  try {
    return (
      localStorage.setItem(test, test),
      localStorage.getItem(test) !== test ? !1 : (localStorage.removeItem(test), !0)
    )
  } catch {
    return !1
  }
}
const PREFIX = 'fluco_'
function getStorage(key) {
  return localStorageAvailable() ? JSON.parse(localStorage.getItem(PREFIX + key)) : null
}
function removeStorage(key) {
  return localStorageAvailable() ? (localStorage.removeItem(PREFIX + key), !0) : null
}
function setStorage(key, val) {
  return localStorageAvailable() ? (localStorage.setItem(PREFIX + key, val), !0) : null
}
var _window$flu$states$3
const routes = window.theme.routes.cart || {},
  paths = {
    base: ''.concat(routes.base || '/cart', '.js'),
    add: ''.concat(routes.add || '/cart/add', '.js'),
    change: ''.concat(routes.change || '/cart/change', '.js'),
    clear: ''.concat(routes.clear || '/cart/clear', '.js'),
    update: ''.concat(routes.update || '/cart/update', '.js'),
  },
  {
    strings: { cart: strings$6 },
  } = window.theme,
  useCustomEvents$3 =
    (_window$flu$states$3 = window.flu.states) === null || _window$flu$states$3 === void 0
      ? void 0
      : _window$flu$states$3.useCustomEvents
function sortCart(cart2) {
  const order = getStorage('cart_order') || []
  return order.length
    ? ((cart2.sorted = [...cart2.items].sort(
        (a2, b) => order.indexOf(a2.variant_id) - order.indexOf(b.variant_id)
      )),
      cart2)
    : ((cart2.sorted = cart2.items), cart2)
}
function updateItem(key, quantity) {
  return get().then((_ref) => {
    let { items } = _ref
    for (let i2 = 0; i2 < items.length; i2++)
      if (items[i2].key === key) return changeItem(i2 + 1, key, quantity)
  })
}
function changeItem(line, itemKey, quantity) {
  return fetch(paths.change, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity }),
  })
    .then((res) => {
      if (res.status == '422') {
        const error = { code: 422, message: strings$6.quantityError }
        handleError(error, 'changeItem', itemKey)
      } else return res.json()
    })
    .then(
      (cart2) => (
        r$1('cart:updated', { cart: cart2 }),
        r$1('quick-cart:updated'),
        useCustomEvents$3 && dispatchCustomEvent('cart:updated', { cart: cart2 }),
        sortCart(cart2)
      )
    )
}
function addItemById(id, quantity) {
  r$1('cart:updating')
  let data = { items: [{ id, quantity }] }
  return fetch(paths.add, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((r2) => r2.json())
    .then((res) => {
      if (res.status == '422') {
        const error = { code: 422, message: res.description }
        handleError(error, 'addItemById', id)
      }
      return get().then(
        (cart2) => (
          r$1('quick-cart:updated'),
          r$1('cart:updated', { cart: cart2 }),
          useCustomEvents$3 && dispatchCustomEvent('cart:updated', { cart: sortCart(cart2) }),
          { res, cart: cart2 }
        )
      )
    })
}
function get() {
  return fetch(paths.base, { method: 'GET', credentials: 'include' })
    .then((res) => res.json())
    .then((data) => sortCart(data))
}
function addItem(form) {
  return (
    r$1('cart:updating'),
    fetch(paths.add, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: serialize(form),
    })
      .then((r2) => r2.json())
      .then((res) => {
        if (res.status == '422') {
          const error = { code: 422, message: res.description }
          handleError(error, 'addItem', null)
        }
        return get().then((cart2) => {
          const order = getStorage('cart_order') || [],
            newOrder = [res.variant_id, ...order.filter((i2) => i2 !== res.variant_id)]
          return (
            setStorage('cart_order', JSON.stringify(newOrder)),
            r$1('cart:updated', { cart: sortCart(cart2) }),
            r$1('quick-cart:updated'),
            r$1('quick-view:close'),
            useCustomEvents$3 && dispatchCustomEvent('cart:updated', { cart: sortCart(cart2) }),
            { item: res, cart: sortCart(cart2) }
          )
        })
      })
  )
}
function handleError(error, source, itemKeyOrId) {
  throw (
    (useCustomEvents$3 && dispatchCustomEvent('cart:error', { errorMessage: error.message }),
    source === 'changeItem'
      ? (r$1('quick-cart:error', null, { key: itemKeyOrId, errorMessage: strings$6.quantityError }),
        r$1('cart:error', null, { key: itemKeyOrId, errorMessage: strings$6.quantityError }))
      : source === 'addItemById' &&
        r$1('quick-add:error', null, { id: itemKeyOrId, errorMessage: strings$6.quantityError }),
    error)
  )
}
function serialize(form) {
  var arr = []
  return (
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !(
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
      ) {
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            option.selected &&
              arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value))
          })
          return
        }
        ;(['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) ||
          arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value))
      }
    }),
    arr.join('&')
  )
}
var cart = { addItem, get, updateItem, addItemById }
const moneyFormat = '${{amount}}'
function formatMoney$1(cents, format) {
  typeof cents == 'string' && (cents = cents.replace('.', ''))
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || moneyFormat
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0
    number = (number / 100).toFixed(precision)
    const parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`),
      centsAmount = parts[1] ? decimal + parts[1] : ''
    return dollarsAmount + centsAmount
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }
  return formatString.replace(placeholderRegex, value)
}
var formatMoney = (val) => formatMoney$1(val, window.theme.moneyFormat || '${{amount}}'),
  getProduct = (handle) => (cb) =>
    fetch(''.concat(window.theme.routes.products, '/').concat(handle, '.js'))
      .then((res) => res.json())
      .then((data) => cb(data))
      .catch((err) => console.log(err.message))
/*!
 * slide-anim
 * https://github.com/yomotsu/slide-anim
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */ const pool = [],
  inAnimItems = {
    add(el, defaultStyle, timeoutId, onCancelled) {
      const inAnimItem = { el, defaultStyle, timeoutId, onCancelled }
      this.remove(el), pool.push(inAnimItem)
    },
    remove(el) {
      const index = inAnimItems.findIndex(el)
      if (index === -1) return
      const inAnimItem = pool[index]
      clearTimeout(inAnimItem.timeoutId), inAnimItem.onCancelled(), pool.splice(index, 1)
    },
    find(el) {
      return pool[inAnimItems.findIndex(el)]
    },
    findIndex(el) {
      let index = -1
      return pool.some((item, i2) => (item.el === el ? ((index = i2), !0) : !1)), index
    },
  },
  CSS_EASEOUT_EXPO = 'cubic-bezier( 0.19, 1, 0.22, 1 )'
function slideDown(el, options = {}) {
  return new Promise((resolve) => {
    if (inAnimItems.findIndex(el) !== -1) return
    const _isVisible = isVisible(el),
      hasEndHeight = typeof options.endHeight == 'number',
      display = options.display || 'block',
      duration = options.duration || 400,
      onCancelled = options.onCancelled || function () {},
      defaultStyle = el.getAttribute('style') || '',
      style = window.getComputedStyle(el),
      defaultStyles = getDefaultStyles(el, display),
      isBorderBox = /border-box/.test(style.getPropertyValue('box-sizing')),
      contentHeight = defaultStyles.height,
      minHeight = defaultStyles.minHeight,
      paddingTop = defaultStyles.paddingTop,
      paddingBottom = defaultStyles.paddingBottom,
      borderTop = defaultStyles.borderTop,
      borderBottom = defaultStyles.borderBottom,
      cssDuration = `${duration}ms`,
      cssEasing = CSS_EASEOUT_EXPO,
      cssTransition = [
        `height ${cssDuration} ${cssEasing}`,
        `min-height ${cssDuration} ${cssEasing}`,
        `padding ${cssDuration} ${cssEasing}`,
        `border-width ${cssDuration} ${cssEasing}`,
      ].join(),
      startHeight = _isVisible ? style.height : '0px',
      startMinHeight = _isVisible ? style.minHeight : '0px',
      startPaddingTop = _isVisible ? style.paddingTop : '0px',
      startPaddingBottom = _isVisible ? style.paddingBottom : '0px',
      startBorderTopWidth = _isVisible ? style.borderTopWidth : '0px',
      startBorderBottomWidth = _isVisible ? style.borderBottomWidth : '0px',
      endHeight = hasEndHeight
        ? `${options.endHeight}px`
        : isBorderBox
        ? `${contentHeight + borderTop + borderBottom}px`
        : `${contentHeight - paddingTop - paddingBottom}px`,
      endMinHeight = `${minHeight}px`,
      endPaddingTop = `${paddingTop}px`,
      endPaddingBottom = `${paddingBottom}px`,
      endBorderTopWidth = `${borderTop}px`,
      endBorderBottomWidth = `${borderBottom}px`
    if (
      startHeight === endHeight &&
      startPaddingTop === endPaddingTop &&
      startPaddingBottom === endPaddingBottom &&
      startBorderTopWidth === endBorderTopWidth &&
      startBorderBottomWidth === endBorderBottomWidth
    ) {
      resolve()
      return
    }
    requestAnimationFrame(() => {
      ;(el.style.height = startHeight),
        (el.style.minHeight = startMinHeight),
        (el.style.paddingTop = startPaddingTop),
        (el.style.paddingBottom = startPaddingBottom),
        (el.style.borderTopWidth = startBorderTopWidth),
        (el.style.borderBottomWidth = startBorderBottomWidth),
        (el.style.display = display),
        (el.style.overflow = 'hidden'),
        (el.style.visibility = 'visible'),
        (el.style.transition = cssTransition),
        (el.style.webkitTransition = cssTransition),
        requestAnimationFrame(() => {
          ;(el.style.height = endHeight),
            (el.style.minHeight = endMinHeight),
            (el.style.paddingTop = endPaddingTop),
            (el.style.paddingBottom = endPaddingBottom),
            (el.style.borderTopWidth = endBorderTopWidth),
            (el.style.borderBottomWidth = endBorderBottomWidth)
        })
    })
    const timeoutId = setTimeout(() => {
      resetStyle(el),
        (el.style.display = display),
        hasEndHeight &&
          ((el.style.height = `${options.endHeight}px`), (el.style.overflow = 'hidden')),
        inAnimItems.remove(el),
        resolve()
    }, duration)
    inAnimItems.add(el, defaultStyle, timeoutId, onCancelled)
  })
}
function slideUp(el, options = {}) {
  return new Promise((resolve) => {
    if (inAnimItems.findIndex(el) !== -1) return
    const _isVisible = isVisible(el),
      display = options.display || 'block',
      duration = options.duration || 400,
      onCancelled = options.onCancelled || function () {}
    if (!_isVisible) {
      resolve()
      return
    }
    const defaultStyle = el.getAttribute('style') || '',
      style = window.getComputedStyle(el),
      isBorderBox = /border-box/.test(style.getPropertyValue('box-sizing')),
      minHeight = pxToNumber(style.getPropertyValue('min-height')),
      paddingTop = pxToNumber(style.getPropertyValue('padding-top')),
      paddingBottom = pxToNumber(style.getPropertyValue('padding-bottom')),
      borderTop = pxToNumber(style.getPropertyValue('border-top-width')),
      borderBottom = pxToNumber(style.getPropertyValue('border-bottom-width')),
      contentHeight = el.scrollHeight,
      cssDuration = duration + 'ms',
      cssEasing = CSS_EASEOUT_EXPO,
      cssTransition = [
        `height ${cssDuration} ${cssEasing}`,
        `padding ${cssDuration} ${cssEasing}`,
        `border-width ${cssDuration} ${cssEasing}`,
      ].join(),
      startHeight = isBorderBox
        ? `${contentHeight + borderTop + borderBottom}px`
        : `${contentHeight - paddingTop - paddingBottom}px`,
      startMinHeight = `${minHeight}px`,
      startPaddingTop = `${paddingTop}px`,
      startPaddingBottom = `${paddingBottom}px`,
      startBorderTopWidth = `${borderTop}px`,
      startBorderBottomWidth = `${borderBottom}px`
    requestAnimationFrame(() => {
      ;(el.style.height = startHeight),
        (el.style.minHeight = startMinHeight),
        (el.style.paddingTop = startPaddingTop),
        (el.style.paddingBottom = startPaddingBottom),
        (el.style.borderTopWidth = startBorderTopWidth),
        (el.style.borderBottomWidth = startBorderBottomWidth),
        (el.style.display = display),
        (el.style.overflow = 'hidden'),
        (el.style.transition = cssTransition),
        (el.style.webkitTransition = cssTransition),
        requestAnimationFrame(() => {
          ;(el.style.height = '0'),
            (el.style.minHeight = '0'),
            (el.style.paddingTop = '0'),
            (el.style.paddingBottom = '0'),
            (el.style.borderTopWidth = '0'),
            (el.style.borderBottomWidth = '0')
        })
    })
    const timeoutId = setTimeout(() => {
      resetStyle(el), (el.style.display = 'none'), inAnimItems.remove(el), resolve()
    }, duration)
    inAnimItems.add(el, defaultStyle, timeoutId, onCancelled)
  })
}
function slideStop(el) {
  if (!inAnimItems.find(el)) return
  const style = window.getComputedStyle(el),
    height = style.height,
    paddingTop = style.paddingTop,
    paddingBottom = style.paddingBottom,
    borderTopWidth = style.borderTopWidth,
    borderBottomWidth = style.borderBottomWidth
  resetStyle(el),
    (el.style.height = height),
    (el.style.paddingTop = paddingTop),
    (el.style.paddingBottom = paddingBottom),
    (el.style.borderTopWidth = borderTopWidth),
    (el.style.borderBottomWidth = borderBottomWidth),
    (el.style.overflow = 'hidden'),
    inAnimItems.remove(el)
}
function isVisible(el) {
  return el.offsetHeight !== 0
}
function resetStyle(el) {
  ;(el.style.visibility = ''),
    (el.style.height = ''),
    (el.style.minHeight = ''),
    (el.style.paddingTop = ''),
    (el.style.paddingBottom = ''),
    (el.style.borderTopWidth = ''),
    (el.style.borderBottomWidth = ''),
    (el.style.overflow = ''),
    (el.style.transition = ''),
    (el.style.webkitTransition = '')
}
function getDefaultStyles(el, defaultDisplay = 'block') {
  const defaultStyle = el.getAttribute('style') || '',
    style = window.getComputedStyle(el)
  ;(el.style.visibility = 'hidden'), (el.style.display = defaultDisplay)
  const width = pxToNumber(style.getPropertyValue('width'))
  ;(el.style.position = 'absolute'),
    (el.style.width = `${width}px`),
    (el.style.height = ''),
    (el.style.minHeight = ''),
    (el.style.paddingTop = ''),
    (el.style.paddingBottom = ''),
    (el.style.borderTopWidth = ''),
    (el.style.borderBottomWidth = '')
  const minHeight = pxToNumber(style.getPropertyValue('min-height')),
    paddingTop = pxToNumber(style.getPropertyValue('padding-top')),
    paddingBottom = pxToNumber(style.getPropertyValue('padding-bottom')),
    borderTop = pxToNumber(style.getPropertyValue('border-top-width')),
    borderBottom = pxToNumber(style.getPropertyValue('border-bottom-width')),
    height = el.scrollHeight
  return (
    el.setAttribute('style', defaultStyle),
    { height, minHeight, paddingTop, paddingBottom, borderTop, borderBottom }
  )
}
function pxToNumber(px) {
  return +px.replace(/px/, '')
}
function accordion(node, options) {
  const labels = t$2('.accordion__label', node),
    content = t$2('.accordion__content', node)
  labels.forEach((label) => {
    label.href = '#'
  }),
    content.forEach((t2) => u$1(t2, 'measure'))
  const labelClick = e$2(labels, 'click', (e2) => {
    e2.preventDefault()
    const label = e2.currentTarget,
      { parentNode: group, nextElementSibling: content2 } = label
    slideStop(content2),
      isVisible(content2) ? _close(label, group, content2) : _open(label, group, content2)
  })
  function _open(label, group, content2) {
    slideDown(content2),
      group.setAttribute('data-open', !0),
      label.setAttribute('aria-expanded', !0),
      content2.setAttribute('aria-hidden', !1)
  }
  function _close(label, group, content2) {
    slideUp(content2),
      group.setAttribute('data-open', !1),
      label.setAttribute('aria-expanded', !1),
      content2.setAttribute('aria-hidden', !0)
  }
  if (options.firstOpen) {
    const { parentNode: group, nextElementSibling: content2 } = labels[0]
    _open(labels[0], group, content2)
  }
  function destroy2() {
    return () => labelClick()
  }
  return { destroy: destroy2 }
}
function Accordions(elements) {
  let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
  if (Array.isArray(elements) && !elements.length) return
  const opts = Object.assign({ firstOpen: !0 }, options)
  let accordions = []
  elements.length
    ? (accordions = elements.map((node) => accordion(node, opts)))
    : accordions.push(accordion(elements, opts))
  function unload2() {
    accordions.forEach((accordion2) => accordion2.destroy())
  }
  return { unload: unload2 }
}
function Media(node) {
  if (!node) return
  const { Shopify: Shopify2, YT: YT2 } = window,
    { icons: icons2 } = window.theme,
    elements = t$2('[data-interactive]', node)
  if (!elements.length) return
  const acceptedTypes = ['video', 'model', 'external_video']
  let activeMedia = null,
    featuresLoaded = !1,
    instances2 = {}
  const selectors2 = { mediaContainer: '.media', videoPoster: '.mobile-media-carousel__poster' },
    mediaContainers = t$2(selectors2.mediaContainer, node)
  let hasMobileVideoModal = !1
  mediaContainers.forEach((mediaContainer) => {
    if (mediaContainer.dataset.hasMobileVideoModal === 'true') {
      hasMobileVideoModal = !0
      return
    }
  }),
    featuresLoaded && elements.forEach(initElement),
    window.Shopify.loadFeatures(
      [
        { name: 'model-viewer-ui', version: '1.0' },
        { name: 'shopify-xr', version: '1.0' },
        { name: 'video-ui', version: '1.0' },
      ],
      () => {
        ;(featuresLoaded = !0),
          'YT' in window && YT2.loaded
            ? elements.forEach(initElement)
            : (window.onYouTubeIframeAPIReady = function () {
                elements.forEach(initElement)
              })
      }
    )
  function initElement(el) {
    const { mediaId, mediaType } = el.dataset
    if (
      !mediaType ||
      !acceptedTypes.includes(mediaType) ||
      Object.keys(instances2).includes(mediaId)
    )
      return
    let instance = { id: mediaId, type: mediaType, container: el, media: el.children[0] }
    switch (instance.type) {
      case 'video':
        instance.player = new Shopify2.Plyr(instance.media, {
          loop: { active: el.dataset.loop == 'true' },
        })
        break
      case 'external_video': {
        if (hasMobileVideoModal) {
          const photoSwipe = import(flu.chunks.photoswipe),
            videoPoster = n$2(selectors2.videoPoster, instance.container)
          let photoSwipeInstance
          photoSwipe.then((_ref) => {
            let { PhotoSwipeLightbox, PhotoSwipe } = _ref
            ;(photoSwipeInstance = new PhotoSwipeLightbox({
              dataSource: [{ html: instance.media.outerHTML }],
              pswpModule: PhotoSwipe,
              mainClass: 'pswp--product-lightbox',
              closeSVG: icons2.close,
              arrowPrev: !1,
              arrowNext: !1,
              zoom: !1,
              counter: !1,
            })),
              photoSwipeInstance.init(),
              e$2(videoPoster, 'click', () => {
                photoSwipeInstance.loadAndOpen()
              })
          })
        }
        break
      }
      case 'model':
        ;(instance.viewer = new Shopify2.ModelViewerUI(n$2('model-viewer', el))),
          e$2(n$2('.model-poster', el), 'click', (e2) => {
            e2.preventDefault(), playModel(instance)
          })
        break
    }
    instance.player &&
      (instance.type === 'video'
        ? instance.player.on('playing', () => {
            pauseActiveMedia(instance), (activeMedia = instance)
          })
        : instance.type === 'external_video' &&
          instance.player.addEventListener('onStateChange', (event) => {
            event.data === 1 && (pauseActiveMedia(instance), (activeMedia = instance))
          }))
  }
  function playModel(instance) {
    pauseActiveMedia(instance),
      instance.viewer.play(),
      u$1(instance.container, 'model-active'),
      (activeMedia = instance),
      setTimeout(() => {
        n$2('model-viewer', instance.container).focus()
      }, 300)
  }
  function pauseActiveMedia(instance) {
    if (!(!activeMedia || instance == activeMedia)) {
      if (activeMedia.player) {
        activeMedia.type === 'video'
          ? activeMedia.player.pause()
          : activeMedia.type === 'external_video' && activeMedia.player.pauseVideo(),
          (activeMedia = null)
        return
      }
      activeMedia.viewer &&
        (i$1(activeMedia.container, 'model-active'),
        activeMedia.viewer.pause(),
        (activeMedia = null))
    }
  }
  return { pauseActiveMedia }
}
const selectors$V = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[data-quantity-input]',
  formQuantity: '[name="quantity"]',
  propertyInput: '[name^="properties"]',
}
function ProductForm(container, form, prod) {
  let config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}
  const product = validateProductObject(prod),
    listeners = [],
    getOptions = () =>
      _serializeOptionValues(optionInputs, function (item) {
        var regex = /(?:^(options\[))(.*?)(?:[\]](?![\]]))/
        return (item.name = regex.exec(item.name)[2]), item
      }),
    getVariant = () => getVariantFromSerializedArray(product, getOptions()),
    getProperties = () => {
      const properties = _serializePropertyValues(propertyInputs, function (propertyName) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/,
          name = regex.exec(propertyName)[2]
        return name
      })
      return Object.entries(properties).length === 0 ? null : properties
    },
    getQuantity = () =>
      formQuantityInput[0] ? Number.parseInt(formQuantityInput[0].value, 10) : 1,
    getProductFormEventData = () => ({
      options: getOptions(),
      variant: getVariant(),
      properties: getProperties(),
      quantity: getQuantity(),
    }),
    onFormEvent = (cb) => {
      if (!(typeof cb > 'u'))
        return (event) => {
          ;(event.dataset = getProductFormEventData()), cb(event)
        }
    },
    setIdInputValue = (value) => {
      let idInputElement = form.querySelector(selectors$V.idInput)
      idInputElement ||
        ((idInputElement = document.createElement('input')),
        (idInputElement.type = 'hidden'),
        (idInputElement.name = 'id'),
        form.appendChild(idInputElement)),
        (idInputElement.value = value.toString())
    },
    onSubmit = (event) => {
      ;(event.dataset = getProductFormEventData()),
        setIdInputValue(event.dataset.variant.id),
        config.onFormSubmit && config.onFormSubmit(event)
    },
    initInputs = (selector, cb) =>
      [...container.querySelectorAll(selector)].map(
        (element) => (listeners.push(e$2(element, 'change', onFormEvent(cb))), element)
      )
  listeners.push(e$2(form, 'submit', onSubmit))
  const optionInputs = initInputs(selectors$V.optionInput, config.onOptionChange),
    formQuantityInput = initInputs(selectors$V.quantityInput, config.onQuantityChange),
    propertyInputs = initInputs(selectors$V.propertyInput, config.onPropertyChange)
  return {
    getVariant,
    destroy: () => {
      listeners.forEach((unsubscribe) => unsubscribe())
    },
  }
}
function validateProductObject(product) {
  if (typeof product != 'object') throw new TypeError(product + ' is not an object.')
  if (typeof product.variants[0].options > 'u')
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
    )
  return product
}
function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function (options, input) {
    return (
      (input.checked || (input.type !== 'radio' && input.type !== 'checkbox')) &&
        options.push(transform({ name: input.name, value: input.value })),
      options
    )
  }, [])
}
function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function (properties, input) {
    return (
      (input.checked || (input.type !== 'radio' && input.type !== 'checkbox')) &&
        (properties[transform(input.name)] = input.value),
      properties
    )
  }, {})
}
var preventDefault = (fn) => (e2) => {
  e2.preventDefault(), fn()
}
const selectors$U = {
    imageById: (id) => "[data-media-item-id='".concat(id, "']"),
    imageWrapper: '[data-product-media-wrapper]',
    inYourSpace: '[data-in-your-space]',
  },
  classes$r = { hidden: 'hidden' }
function switchImage(container, imageId, inYourSpaceButton) {
  const newImage = n$2(selectors$U.imageWrapper + selectors$U.imageById(imageId), container),
    otherImages = t$2(
      ''.concat(selectors$U.imageWrapper, ':not(').concat(selectors$U.imageById(imageId), ')'),
      container
    )
  newImage && i$1(newImage, classes$r.hidden),
    inYourSpaceButton &&
      newImage.dataset.mediaType === 'model' &&
      inYourSpaceButton.setAttribute('data-shopify-model3d-id', newImage.dataset.mediaItemId),
    otherImages.forEach((image) => u$1(image, classes$r.hidden))
}
function provideResizeObserver() {
  return window.ResizeObserver
    ? Promise.resolve({ ResizeObserver })
    : import(flu.chunks.polyfillResizeObserver)
}
function quantityInput(container) {
  const quantityWrapper = n$2('.quantity-input', container)
  if (!quantityWrapper) return
  const quantityInput2 = n$2('[data-quantity-input]', quantityWrapper),
    addQuantity = n$2('[data-add-quantity]', quantityWrapper),
    subtractQuantity = n$2('[data-subtract-quantity]', quantityWrapper),
    handleAddQuantity = () => {
      const newValue = parseInt(quantityInput2.value) + 1
      ;(quantityInput2.value = newValue), quantityInput2.dispatchEvent(new Event('change'))
    },
    handleSubtractQuantity = () => {
      const currentValue = parseInt(quantityInput2.value)
      if (currentValue === 1) return
      const newValue = currentValue - 1
      ;(quantityInput2.value = newValue), quantityInput2.dispatchEvent(new Event('change'))
    },
    events2 = [
      e$2(addQuantity, 'click', handleAddQuantity),
      e$2(subtractQuantity, 'click', handleSubtractQuantity),
    ]
  return {
    unload: () => {
      events2.forEach((unsubscribe) => unsubscribe())
    },
  }
}
const selectors$T = { popupTrigger: '[data-popup-trigger]' },
  informationPopup = (node) => {
    const events2 = [],
      popupTriggers = t$2(selectors$T.popupTrigger, node)
    if (!popupTriggers.length) return
    const listener = e$2(popupTriggers, 'click', (e2) => {
      e2.preventDefault(), e2.stopPropagation()
      const { modalContentId } = e2.target.dataset,
        content = n$2('#'.concat(modalContentId), node)
      r$1('modal:open', null, { modalContent: content })
    })
    events2.push(listener)
    function unload2() {
      events2.forEach((evt) => evt())
    }
    return { unload: unload2 }
  },
  selectors$S = {
    moreButton: '[data-more-media]',
    moreBar: '[data-more-media-bar]',
    productMedia: '[data-product-media]',
  },
  states = { closed: 'closed', beforeOpen: 'beforeOpen', opening: 'opening', open: 'open' },
  moreMedia = (node) => {
    if (!node) return
    const moreButton = n$2(selectors$S.moreButton, node)
    if (!moreButton) return
    const moreBar = n$2(selectors$S.moreBar, node),
      productMedia = n$2(selectors$S.productMedia, node),
      initialAR = parseFloat(window.getComputedStyle(productMedia).aspectRatio)
    let isOpen = !1
    const updateText = (open2) => {
        moreButton.innerHTML = moreButton.dataset[open2 ? 'langLessMedia' : 'langMoreMedia']
      },
      close = () => {
        if (isOpen) {
          if (!isFinite(initialAR)) {
            ;(productMedia.dataset.productMedia = states.closed), (isOpen = !1), updateText(!1)
            return
          }
          ;(productMedia.dataset.productMedia = states.opening),
            window.requestAnimationFrame(() => {
              const transitionEnd = e$2(productMedia, 'transitionend', () => {
                transitionEnd(), (productMedia.dataset.productMedia = states.closed), (isOpen = !1)
              })
              ;(productMedia.dataset.productMedia = states.beforeOpen), updateText(!1)
            })
        }
      },
      scrollIntoView = (variantImage) => {
        variantImage &&
          variantImage.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
      },
      setOpen = () => {
        ;(productMedia.dataset.productMedia = states.open), (isOpen = !0)
      },
      open = function (variantImage) {
        let skipTransition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1
        if (!isOpen) {
          if (!isFinite(initialAR)) {
            setOpen(), updateText(!0)
            return
          }
          ;(productMedia.dataset.productMedia = states.beforeOpen),
            window.requestAnimationFrame(() => {
              const { width } = productMedia.getBoundingClientRect(),
                { scrollHeight } = productMedia,
                gridGap = parseInt(window.getComputedStyle(productMedia).rowGap, 10),
                barBottom = parseInt(window.getComputedStyle(moreBar).bottom, 10),
                openAspectRatio = width / (scrollHeight - gridGap - barBottom)
              if (
                (productMedia.style.setProperty(
                  '--overflow-gallery-aspect-ratio-open',
                  openAspectRatio
                ),
                skipTransition)
              ) {
                const transitionCopy = productMedia.style.transition
                ;(productMedia.style.transition = 'none'),
                  setOpen(),
                  scrollIntoView(variantImage),
                  (productMedia.style.transition = transitionCopy)
              } else {
                const transitionEnd = e$2(productMedia, 'transitionend', (e2) => {
                  e2.target === productMedia &&
                    (transitionEnd(), scrollIntoView(variantImage), setOpen())
                })
                productMedia.dataset.productMedia = states.opening
              }
              updateText(!0)
            })
        }
      },
      events2 = [
        e$2(moreButton, 'click', () => {
          isOpen ? close() : open()
        }),
      ]
    return {
      open,
      unload: () => {
        events2.forEach((evt) => evt())
      },
    }
  },
  {
    strings: { products: strings$5 },
  } = window.theme,
  selectors$R = {
    price: '[data-price]',
    comparePrice: '[data-compare-price]',
    defaultProductContainer: '.product__top',
    quickProductContainer: '.quick-product',
  }
function updatePrices(container, variant, isProductPage) {
  const price = t$2(selectors$R.price, container),
    comparePrice = t$2(selectors$R.comparePrice, container),
    unavailableString = strings$5.product.unavailable
  if (!variant) {
    price.forEach((el) => (el.innerHTML = unavailableString)),
      comparePrice.forEach((el) => (el.innerHTML = ''))
    return
  }
  const defaultProdContainer = n$2(selectors$R.defaultProductContainer, container),
    quickProdContainer = n$2(selectors$R.quickProductContainer, document)
  let productContainer
  isProductPage
    ? (productContainer = defaultProdContainer)
    : (productContainer = quickProdContainer)
  const {
    zeroPriceDisplay,
    zeroPriceCustomContent,
    soldOutPriceDisplay,
    soldOutPriceCustomContent,
  } = productContainer.dataset
  let priceContentType = 'price',
    priceContent = formatMoney(variant.price)
  variant.available
    ? variant.compare_at_price === null &&
      variant.price === 0 &&
      (zeroPriceDisplay === 'hide'
        ? ((priceContentType = 'hide'), (priceContent = ''))
        : zeroPriceDisplay === 'replace' &&
          ((priceContentType = 'custom'), (priceContent = zeroPriceCustomContent)))
    : soldOutPriceDisplay === 'hide'
    ? ((priceContentType = 'hide'), (priceContent = ''))
    : soldOutPriceDisplay === 'replace' &&
      ((priceContentType = 'custom'), (priceContent = soldOutPriceCustomContent)),
    isProductPage
      ? defaultProdContainer.setAttribute('data-price-display-type', priceContentType)
      : quickProdContainer.setAttribute('data-price-display-type', priceContentType),
    price.forEach((el) => (el.innerHTML = priceContent)),
    comparePrice.forEach(
      (el) =>
        (el.innerHTML =
          variant.compare_at_price > variant.price && priceContentType === 'price'
            ? formatMoney(variant.compare_at_price)
            : '')
    )
}
const selectors$Q = {
    productSku: '[data-product-sku]',
    productSkuContainer: '.product__vendor_and_sku',
  },
  {
    strings: { products: strings$4 },
  } = window.theme
function updateSku(container, variant) {
  const skuElement = n$2(selectors$Q.productSku, container),
    skuContainer = n$2(selectors$Q.productSkuContainer, container)
  if (!skuElement) return
  const { sku } = strings$4.product,
    skuString = (value) => ''.concat(sku, ': ').concat(value)
  if (!variant || !variant.sku) {
    ;(skuElement.innerText = ''), skuContainer.setAttribute('data-showing-sku', !1)
    return
  }
  ;(skuElement.innerText = skuString(variant.sku)),
    skuContainer.setAttribute('data-showing-sku', !0)
}
function updateBuyButton(btn, variant) {
  const text = n$2('[data-add-to-cart-text]', btn),
    { langAvailable, langUnavailable, langSoldOut } = btn.dataset
  variant
    ? variant.available
      ? (btn.removeAttribute('disabled'), (text.textContent = langAvailable))
      : (btn.setAttribute('disabled', 'disabled'), (text.textContent = langSoldOut))
    : (btn.setAttribute('disabled', 'disabled'), (text.textContent = langUnavailable))
}
const selectors$P = {
    accordionShell: '.accordion.product-reviews',
    accordionContent: '.accordion__content',
  },
  classes$q = { hidden: 'hidden', accordion: 'accordion' }
function reviewsHandler(node, container) {
  if (!node) return
  const parentAppBlockContainer = node.parentNode,
    accordion2 = n$2(selectors$P.accordionShell, container)
  n$2(selectors$P.accordionContent, accordion2).appendChild(node),
    parentAppBlockContainer.appendChild(accordion2),
    u$1(parentAppBlockContainer, classes$q.accordion),
    i$1(accordion2, classes$q.hidden)
}
function OptionButtons(els) {
  const groups = els.map(createOptionGroup)
  function destroy2() {
    groups && groups.forEach((group) => group())
  }
  return { groups, destroy: destroy2 }
}
function createOptionGroup(el) {
  const select = n$2('select', el),
    buttons = t$2('[data-button]', el),
    buttonClick = e$2(buttons, 'click', (e2) => {
      e2.preventDefault()
      const buttonEl = e2.currentTarget,
        { optionHandle } = buttonEl.dataset
      buttons.forEach((btn) => {
        l(btn, 'selected', btn.dataset.optionHandle === optionHandle)
      })
      const opt = n$2('[data-value-handle="'.concat(optionHandle, '"]'), select)
      ;(opt.selected = !0), select.dispatchEvent(new Event('change'))
    })
  return () => buttonClick()
}
const selectors$O = {
    counterContainer: '[data-inventory-counter]',
    inventoryMessage: '.inventory-counter__message',
    countdownBar: '.inventory-counter__bar',
    progressBar: '.inventory-counter__bar-progress',
  },
  classes$p = {
    hidden: 'hidden',
    inventoryLow: 'inventory--low',
    inventoryEmpty: 'inventory--empty',
    inventoryUnavailable: 'inventory--unavailable',
  },
  inventoryCounter = (container, config) => {
    const variantsInventories = config.variantsInventories,
      counterContainer = n$2(selectors$O.counterContainer, container),
      inventoryMessageElement = n$2(selectors$O.inventoryMessage, container),
      progressBar = n$2(selectors$O.progressBar, container),
      { lowInventoryThreshold, showUntrackedQuantity, stockCountdownMax, unavailableText } =
        counterContainer.dataset
    if (!lowInventoryThreshold.match(/^[0-9]+$/) || !stockCountdownMax.match(/^[0-9]+$/)) return
    const threshold = parseInt(lowInventoryThreshold, 10),
      countDownMax = parseInt(stockCountdownMax, 10)
    l(counterContainer, classes$p.hidden, !productIventoryValid(variantsInventories[config.id])),
      checkThreshold(variantsInventories[config.id]),
      setProgressBar(
        variantsInventories[config.id].inventory_quantity,
        variantsInventories[config.id].inventory_management
      ),
      setInventoryMessage(variantsInventories[config.id].inventory_message)
    function checkThreshold(_ref) {
      let { inventory_policy, inventory_quantity, inventory_management } = _ref
      i$1(counterContainer, classes$p.inventoryLow),
        inventory_management !== null
          ? inventory_quantity <= 0 && inventory_policy === 'deny'
            ? (u$1(counterContainer, classes$p.inventoryEmpty),
              counterContainer.setAttribute('data-stock-category', 'empty'))
            : inventory_quantity <= threshold ||
              (inventory_quantity <= 0 && inventory_policy === 'continue')
            ? counterContainer.setAttribute('data-stock-category', 'low')
            : counterContainer.setAttribute('data-stock-category', 'sufficient')
          : inventory_management === null &&
            showUntrackedQuantity == 'true' &&
            counterContainer.setAttribute('data-stock-category', 'sufficient')
    }
    function setProgressBar(inventoryQuantity, inventoryManagement) {
      if (inventoryManagement === null && showUntrackedQuantity == 'true') {
        progressBar.style.width = ''.concat(100, '%')
        return
      }
      if (inventoryQuantity <= 0) {
        progressBar.style.width = ''.concat(0, '%')
        return
      }
      const progressValue =
        inventoryQuantity < countDownMax ? (inventoryQuantity / countDownMax) * 100 : 100
      progressBar.style.width = ''.concat(progressValue, '%')
    }
    function setInventoryMessage(message) {
      inventoryMessageElement.innerText = message
    }
    function productIventoryValid(product) {
      return (
        product.inventory_message &&
        (product.inventory_management !== null ||
          (product.inventory_management === null && showUntrackedQuantity == 'true'))
      )
    }
    const update = (variant) => {
      if (!variant) {
        setUnavailable()
        return
      }
      l(counterContainer, classes$p.hidden, !productIventoryValid(variantsInventories[variant.id])),
        checkThreshold(variantsInventories[variant.id]),
        setProgressBar(
          variantsInventories[variant.id].inventory_quantity,
          variantsInventories[variant.id].inventory_management
        ),
        setInventoryMessage(variantsInventories[variant.id].inventory_message)
    }
    function setUnavailable() {
      i$1(counterContainer, classes$p.hidden),
        u$1(counterContainer, classes$p.inventoryUnavailable),
        counterContainer.setAttribute('data-stock-category', 'unavailable'),
        setProgressBar(0),
        setInventoryMessage(unavailableText)
    }
    return { update }
  },
  selectors$N = {
    item: '.product-item',
    itemInner: '.product-item__inner',
    quickAddButton: '[data-quick-shop-trigger="quick-add"]',
    quickViewButton: '[data-quick-shop-trigger="quick-view"]',
    quickCart: '.quick-cart',
    purchaseConfirmation: '.purchase-confirmation-popup',
  }
function ProductItem(container) {
  const items = t$2(selectors$N.item, container)
  if (!items.length) return
  items.forEach((item, i2) => item.style.setProperty('--z-index-item', items.length - i2))
  const productItemAnimations = AnimateProductItem(items),
    quickAddButtons = t$2(selectors$N.quickAddButton, container),
    quickViewButtons = t$2(selectors$N.quickViewButton, container),
    quickCart2 = n$2(selectors$N.quickCart, document),
    purchaseConfirmation2 = n$2(selectors$N.purchaseConfirmation, document),
    events2 = [
      e$2(quickAddButtons, 'click', (e2) => {
        const buttonEl = e2.currentTarget
        if ((u$1(buttonEl, 'loading'), !purchaseConfirmation2 && !quickCart2)) return
        e2.preventDefault(), e2.stopPropagation()
        const { productId } = buttonEl.dataset
        productId &&
          cart.addItemById(productId, 1).then((_ref) => {
            let { res } = _ref
            i$1(buttonEl, 'loading'),
              purchaseConfirmation2
                ? r$1('confirmation-popup:open', null, { product: res.items[0] })
                : (r$1('quick-cart:updated'),
                  setTimeout(() => {
                    r$1('quick-cart:open')
                  }, 300))
          })
      }),
      e$2(quickViewButtons, 'click', (e2) => {
        e2.preventDefault(), e2.stopPropagation()
        const buttonEl = e2.currentTarget,
          { productUrl } = buttonEl.dataset
        productUrl && r$1('quick-view:open', null, { productUrl })
      }),
    ]
  return {
    unload: () => {
      productItemAnimations.destroy(), events2.forEach((unsubscribe) => unsubscribe())
    },
  }
}
const selectors$M = { sliderContainer: '.swiper', visibleSlides: '.swiper-slide-visible' },
  classes$o = { overflow: 'has-overflow', carousel: 'carousel' }
var Carousel = function (node) {
  let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
  const swiperContainer = a$1(node, classes$o.carousel)
    ? node
    : n$2(selectors$M.sliderContainer, node)
  if (!swiperContainer) return
  let carousel
  const events2 = [],
    defaultSwiperOptions = {
      slidesPerView: 2,
      grabCursor: !0,
      preloadImages: !1,
      watchSlidesProgress: !0,
      on: {
        init: function () {
          handleOverflow(this.slides)
        },
        breakpoint: function () {
          onBreakpointChange(this.slides)
        },
      },
    },
    nextButton = n$2('[data-next]', node),
    prevButton = n$2('[data-prev]', node),
    useNav = nextButton && prevButton,
    handleOverflow = (slides) => {
      setTimeout(() => {
        const hasOverflow = a$1(swiperContainer, classes$o.overflow),
          needsOverflow = t$2(selectors$M.visibleSlides, swiperContainer).length !== slides.length
        !hasOverflow && needsOverflow
          ? u$1(swiperContainer, classes$o.overflow)
          : hasOverflow && !needsOverflow && i$1(swiperContainer, classes$o.overflow)
      }, 0)
    },
    onBreakpointChange = (slides) => {
      handleOverflow(slides)
    }
  function handleFocus(event) {
    const slide = event.target.closest('.swiper-slide'),
      slideIndex = [...slide.parentElement.children].indexOf(slide)
    document.body.classList.contains('user-is-tabbing') && carousel.slideTo(slideIndex)
  }
  return (
    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Navigation: Navigation2 } = _ref,
        swiperOptions = Object.assign(defaultSwiperOptions, options)
      'navigation' in swiperOptions
        ? (swiperOptions = Object.assign(swiperOptions, { modules: [Navigation2] }))
        : useNav &&
          (swiperOptions = Object.assign(swiperOptions, {
            modules: [Navigation2],
            navigation: { nextEl: nextButton, prevEl: prevButton },
          })),
        (carousel = new Swiper(swiperContainer, swiperOptions)),
        events2.push(e$2(swiperContainer, 'focusin', handleFocus))
    }),
    {
      destroy: () => {
        var _carousel
        ;(_carousel = carousel) === null || _carousel === void 0 || _carousel.destroy(),
          events2.forEach((unsubscribe) => unsubscribe())
      },
    }
  )
}
const selectors$L = {
    wrappingContainer: '.product__block-featured-products',
    featuredProducts: '[data-featured-products]',
    featuredProductsContent: '[data-featured-products-content]',
    leftSideMobileFeaturedProducts: '.left-side-blocks.for-mobile [data-featured-products]',
  },
  featuredProducts = (node) => {
    const featuredProducts2 = t$2(selectors$L.featuredProducts, node)
    if (!featuredProducts2.length) return
    let productItems, mobileSwiper, mobileFeaturedProducts
    const {
      recommendationsType,
      productId: id,
      sectionId,
      enableMobileSwiper,
      maxRecommendations,
    } = featuredProducts2[0].dataset
    recommendationsType === 'app-recommendations'
      ? handleRecommendedProducts()
      : ((productItems = featuredProducts2.map((productContainer) =>
          ProductItem(productContainer)
        )),
        handleMobileSwiper())
    function handleRecommendedProducts() {
      const requestUrl = ''
        .concat(window.theme.routes.productRecommendations, '?section_id=')
        .concat(sectionId, '&limit=')
        .concat(maxRecommendations, '&product_id=')
        .concat(id, '&intent=complementary')
      fetch(requestUrl)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = n$2(selectors$L.featuredProductsContent, html)
          recommendations &&
            recommendations.innerHTML.trim().length &&
            (featuredProducts2.forEach((block) => (block.innerHTML = recommendations.innerHTML)),
            (productItems = featuredProducts2.map((productContainer) =>
              ProductItem(productContainer)
            )),
            featuredProducts2.forEach((block) => {
              i$1(block.closest(selectors$L.wrappingContainer), 'hidden')
            }),
            handleMobileSwiper())
        })
        .catch((error) => {
          throw error
        })
    }
    function handleMobileSwiper() {
      enableMobileSwiper === 'true' &&
        ((mobileFeaturedProducts =
          n$2(selectors$L.leftSideMobileFeaturedProducts, node) ||
          n$2(selectors$L.featuredProducts, node)),
        window.matchMedia(getMediaQuery('below-720')).matches && _initMobileSwiper(),
        atBreakpointChange(720, () => {
          if (window.matchMedia(getMediaQuery('below-720')).matches) _initMobileSwiper()
          else {
            var _mobileSwiper
            ;(_mobileSwiper = mobileSwiper) === null ||
              _mobileSwiper === void 0 ||
              _mobileSwiper.destroy()
          }
        }))
    }
    function _initMobileSwiper() {
      mobileSwiper = Carousel(mobileFeaturedProducts, { slidesPerView: 2.1, spaceBetween: 12 })
    }
    function unload2() {
      var _productItems, _mobileSwiper2
      ;(_productItems = productItems) === null ||
        _productItems === void 0 ||
        _productItems.forEach((item) => item.unload()),
        (_mobileSwiper2 = mobileSwiper) === null ||
          _mobileSwiper2 === void 0 ||
          _mobileSwiper2.destroy()
    }
    return { unload: unload2 }
  },
  classes$n = { disabled: 'disabled' },
  selectors$K = {
    variantsWrapper: '.product__variants-wrapper',
    variantsJson: '[data-variant-json]',
    input: '.dynamic-variant-input',
    inputWrap: '.dynamic-variant-input-wrap',
    inputWrapWithValue: (option) =>
      ''.concat(selectors$K.inputWrap, '[data-index="').concat(option, '"]'),
    buttonWrap: '.dynamic-variant-button',
    buttonWrapWithValue: (value) =>
      ''.concat(selectors$K.buttonWrap, '[data-option-value="').concat(value, '"]'),
  }
function variantAvailability(container) {
  const variantsWrapper = n$2(selectors$K.variantsWrapper, container)
  if (!variantsWrapper) return
  const { enableDynamicProductOptions, currentVariantId } = variantsWrapper.dataset
  if (enableDynamicProductOptions === 'false') return
  const productVariants = JSON.parse(n$2(selectors$K.variantsJson, container).innerText),
    variantSelectors = t$2(selectors$K.input, container),
    variantSelectorWrappers = t$2(selectors$K.inputWrap, container),
    events2 = []
  init()
  function init() {
    variantSelectors.forEach((el) => {
      events2.push(e$2(el, 'change', handleChange))
    }),
      setInitialAvailability()
  }
  function setInitialAvailability() {
    variantSelectorWrappers.forEach((group) => disableVariantGroup(group))
    const currentlySelectedValues = productVariants
        .find((variant) => variant.id === parseInt(currentVariantId, 10))
        .options.map((value, index) => ({ value, index: 'option'.concat(index + 1) }))

    const initialOptions = createAvailableOptionsTree(productVariants, currentlySelectedValues)
    for (const [option, values] of Object.entries(initialOptions)) {
      manageOptionState(option, values)
    }

    updateNextOptionSelectorValues(-1)
  }
  function createAvailableOptionsTree(variants, currentlySelectedValues) {
    return variants.reduce(
      (options, variant) => (
        Object.keys(options).forEach((index) => {
          if (variant[index] === null) return
          let entry = options[index].find((option) => option.value === variant[index])
          typeof entry > 'u' &&
            ((entry = { value: variant[index], soldOut: !0 }), options[index].push(entry))
          const currentOption1 = currentlySelectedValues.find((_ref) => {
              let { index: index2 } = _ref
              return index2 === 'option1'
            }),
            currentOption2 = currentlySelectedValues.find((_ref2) => {
              let { index: index2 } = _ref2
              return index2 === 'option2'
            })
          switch (index) {
            case 'option1':
              entry.soldOut = entry.soldOut && variant.available ? !1 : entry.soldOut
              break
            case 'option2':
              currentOption1 &&
                variant.option1 === currentOption1.value &&
                (entry.soldOut = entry.soldOut && variant.available ? !1 : entry.soldOut)
              break
            case 'option3':
              currentOption1 &&
                variant.option1 === currentOption1.value &&
                currentOption2 &&
                variant.option2 === currentOption2.value &&
                (entry.soldOut = entry.soldOut && variant.available ? !1 : entry.soldOut)
          }
        }),
        options
      ),
      { option1: [], option2: [], option3: [] }
    )
  }
  function handleChange(e2) {
    const select = e2 && e2.target
    if (select instanceof HTMLSelectElement) {
      const key = select.dataset.index
      if (key && key.startsWith('option')) {
        const index = Number(key.replace('option', '')) - 1
        updateNextOptionSelectorValues(index)
      }
    }

    const currentlySelectedValues = variantSelectors.map((el) => ({
      value: el.value,
      index: el.id,
    }))
    setAvailability(currentlySelectedValues)
  }
  function updateNextOptionSelectorValues(index) {
    variantSelectors.slice(index + 1).forEach((_select, i2) => {
      let absIndex = i2 + index + 1
      const prevValues = variantSelectors
          .slice(0, absIndex)
          .map((select) => ({ value: select.value, index: select.id })),
        optionKeyIndex = absIndex + 1,
        optionKey = 'option' + optionKeyIndex,
        options = productVariants.reduce((acc, v) => {
          if (prevValues.every((x) => v[x.index] === x.value) && v.available) {
            const value = v[optionKey]
            value && !acc.includes(value) && acc.push(value)
          }
          return acc
        }, [])
      let prevSelectValue = _select.value
      _select.options.length = 0
      for (let i3 = 0; i3 < options.length; i3++) {
        const x = options[i3],
          selected = prevSelectValue === x,
          opt = new Option(x, x, selected, selected)
        opt.setAttribute('data-value-handle', `${handleize(x)}--${optionKeyIndex}`),
          _select.options.add(opt)
      }
    })
  }
  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '')
  }
  function setAvailability(selectedValues) {
    const valuesToManage = createAvailableOptionsTree(productVariants, selectedValues)
    for (const [option, values] of Object.entries(valuesToManage)) manageOptionState(option, values)
  }
  function manageOptionState(option, values) {
    const group = n$2(selectors$K.inputWrapWithValue(option), container)
    values.forEach((obj) => {
      toggleVariantOption(group, obj)
    })
  }
  function toggleVariantOption(group, obj) {
    const value = escapeQuotes(obj.value)
    if (a$1(group, 'select-wrapper')) return
    const button = n$2(selectors$K.buttonWrapWithValue(value), group)
    i$1(button, classes$n.disabled), obj.soldOut && u$1(button, classes$n.disabled)
  }
  function disableVariantGroup(group) {
    a$1(group, 'select-wrapper') ||
      t$2(selectors$K.buttonWrap, group).forEach((button) => u$1(button, classes$n.disabled))
  }
  function escapeQuotes(str) {
    const escapeMap = { '"': '\\"', "'": "\\'" }
    return str.replace(/"|'/g, (m) => escapeMap[m])
  }
  return {
    unload: () => {
      events2.forEach((unsubscribe) => unsubscribe())
    },
  }
}
const selectors$J = {
  siblingProducts: '[data-sibling-products]',
  siblingSwatch: '[data-sibling-swatch]',
  siblingLabelEl: '[data-sibling-label-value]',
}
function siblingProducts(container) {
  const siblingProducts2 = n$2(selectors$J.siblingProducts, container)
  if (!siblingProducts2) return
  const siblingSwatches = t$2(selectors$J.siblingSwatch, siblingProducts2),
    labelValueEl = n$2(selectors$J.siblingLabelEl, siblingProducts2),
    baseLabel = labelValueEl.innerText,
    events2 = []
  siblingSwatches.forEach((item) => {
    events2.push(
      e$2(item, 'mouseout', () => handleOut()),
      e$2(item, 'mouseover', (e2) => handleOver(e2))
    )
  })
  function handleOver(e2) {
    const cutline = e2.target.dataset.siblingCutline
    labelValueEl.innerText = cutline
  }
  function handleOut() {
    labelValueEl.innerText !== baseLabel && (labelValueEl.innerText = baseLabel)
  }
  return {
    unload: () => {
      events2.forEach((unsubscribe) => unsubscribe())
    },
  }
}
function giftCardRecipient(container) {
  const displayRecipientFormContainer = n$2(
      ".product-form__gift-card-recipient[data-source='product-display']",
      container
    ),
    formRecipientFormContainer = n$2(
      ".product-form__gift-card-recipient[data-source='product-form']",
      container
    )
  if (!displayRecipientFormContainer || !formRecipientFormContainer) return
  const sectionID = displayRecipientFormContainer.dataset.sectionId,
    selectors2 = {
      display: {
        controlInput: '#display-gift-card-recipient-enable--'.concat(sectionID),
        recipientForm: '.gift-card-recipient-fields',
        emailInput: '#display-gift-card-recipient-email--'.concat(sectionID),
        nameInput: '#display-gift-card-recipient-name--'.concat(sectionID),
        messageInput: '#display-gift-card-recipient-message--'.concat(sectionID),
        sendOnInput: '#display-gift-card-recipient-send_on--'.concat(sectionID),
        errors: '.product__gift-card-recipient-error',
      },
      form: {
        controlInput: '#form-gift-card-recipient-control--'.concat(sectionID),
        emailInput: '#form-gift-card-recipient-email--'.concat(sectionID),
        nameInput: '#form-gift-card-recipient-name--'.concat(sectionID),
        messageInput: '#form-gift-card-recipient-message--'.concat(sectionID),
        sendOnInput: '#form-gift-card-recipient-send_on--'.concat(sectionID),
        offsetInput: '#form-gift-card-recipient-timezone-offset--'.concat(sectionID),
      },
    },
    elements = {
      display: {
        controlInput: n$2(selectors2.display.controlInput, displayRecipientFormContainer),
        emailInput: n$2(selectors2.display.emailInput, displayRecipientFormContainer),
        nameInput: n$2(selectors2.display.nameInput, displayRecipientFormContainer),
        messageInput: n$2(selectors2.display.messageInput, displayRecipientFormContainer),
        sendOnInput: n$2(selectors2.display.sendOnInput, displayRecipientFormContainer),
        recipientForm: n$2(selectors2.display.recipientForm, displayRecipientFormContainer),
        errors: t$2(selectors2.display.errors, displayRecipientFormContainer),
      },
      form: {
        controlInput: n$2(selectors2.form.controlInput, formRecipientFormContainer),
        emailInput: n$2(selectors2.form.emailInput, formRecipientFormContainer),
        nameInput: n$2(selectors2.form.nameInput, formRecipientFormContainer),
        messageInput: n$2(selectors2.form.messageInput, formRecipientFormContainer),
        sendOnInput: n$2(selectors2.form.sendOnInput, formRecipientFormContainer),
        offsetInput: n$2(selectors2.form.offsetInput, formRecipientFormContainer),
      },
    }
  Object.entries(elements.display).forEach((_ref) => {
    let [key, value] = _ref
    value.controls = elements.form[key]
  })
  const getInputs = (type) => [
      elements[type].emailInput,
      elements[type].nameInput,
      elements[type].messageInput,
      elements[type].sendOnInput,
    ],
    disableableInputs = () => [
      ...getInputs('form'),
      elements.form.controlInput,
      elements.form.offsetInput,
    ],
    clearableInputs = () => [...getInputs('display'), ...getInputs('form')],
    disableInputs = (inputs, disable) => {
      inputs.forEach((input) => {
        input.disabled = disable
      })
    },
    clearInputs = (inputs) => {
      inputs.forEach((input) => {
        input.value = ''
      })
    },
    clearErrors = () => {
      elements.display.errors.forEach((error) => {
        u$1(error, 'hidden')
      })
    },
    handleChange = (e2) => {
      const el = e2.target
      ;(el.controls.value = el.value),
        el.type === 'checkbox' &&
          (el.checked
            ? (elements.display.recipientForm.style.display = 'block')
            : (clearInputs(clearableInputs()),
              clearErrors(),
              (elements.display.recipientForm.style.display = 'none')),
          disableInputs(disableableInputs(), !el.checked))
    }
  u$1(formRecipientFormContainer, 'visually-hidden'),
    disableInputs(disableableInputs(), !0),
    (elements.form.offsetInput.value = new Date().getTimezoneOffset())
  const events2 = [e$2(elements.display.controlInput, 'change', handleChange)]
  return (
    getInputs('display').forEach((input) => {
      events2.push(e$2(input, 'change', handleChange))
    }),
    {
      unload: () => {
        events2.forEach((unsubscribe) => unsubscribe())
      },
    }
  )
}
function stickyAtcBar(container) {
  const classes2 = { hidden: 'hidden' },
    selectors2 = {
      buyButtons: '.product-form__item--submit',
      changeOptionButton: '[data-change-option-trigger]',
      imageWrap: '.product__media',
      optionValues: '.sticky-atc-bar__meta-options',
      pageFooter: 'footer',
      stickyAtcBar: '.sticky-atc-bar',
      variantSelector: '.product__variants-wrapper',
    },
    elements = {
      buyButtons: n$2(selectors2.buyButtons, container),
      pageFooter: n$2(selectors2.pageFooter, document),
      stickyAtcBar: n$2(selectors2.stickyAtcBar, container),
      variantSelector: n$2(selectors2.variantSelector, container),
    }
  if (elements.stickyAtcBar == null) return
  ;(elements.imageWrap = n$2(selectors2.imageWrap, elements.stickyAtcBar)),
    (elements.optionValues = n$2(selectors2.optionValues, elements.stickyAtcBar)),
    (elements.changeOptionButton = n$2(selectors2.changeOptionButton, elements.stickyAtcBar))
  const events2 = []
  elements.changeOptionButton &&
    events2.push(e$2(elements.changeOptionButton, 'click', () => scrollToVariantSelector()))
  let widthWatcher
  const buyButtonsObserver = new IntersectionObserver((_ref) => {
      let [{ isIntersecting: visible }] = _ref
      visible ? hideBar() : showBar()
    }),
    footerObserver = new IntersectionObserver(
      (_ref2) => {
        let [{ isIntersecting: visible }] = _ref2
        visible
          ? (buyButtonsObserver.disconnect(), hideBar())
          : buyButtonsObserver.observe(elements.buyButtons)
      },
      { threshold: 0.8 }
    )
  footerObserver.observe(elements.pageFooter)
  const showBar = () => {
      i$1(elements.stickyAtcBar, classes2.hidden),
        setHeightVariable(),
        (widthWatcher = srraf((_ref3) => {
          let { pvw, vw } = _ref3
          pvw !== vw && setHeightVariable()
        }))
    },
    hideBar = () => {
      var _widthWatcher
      u$1(elements.stickyAtcBar, classes2.hidden),
        (_widthWatcher = widthWatcher) === null ||
          _widthWatcher === void 0 ||
          _widthWatcher.destroy(),
        clearHeightVariable()
    },
    setHeightVariable = () => {
      document.documentElement.style.setProperty(
        '--sticky-atc-bar-height',
        ''.concat(elements.stickyAtcBar.offsetHeight, 'px')
      )
    },
    clearHeightVariable = () => {
      document.documentElement.style.setProperty('--sticky-atc-bar-height', '0px')
    },
    scrollToVariantSelector = () => {
      elements.variantSelector.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  return {
    switchCurrentImage: (id) => {
      switchImage(elements.imageWrap, id)
    },
    unload: () => {
      var _widthWatcher2
      buyButtonsObserver?.disconnect(),
        events2.forEach((unsubscribe) => unsubscribe()),
        footerObserver?.disconnect(),
        (_widthWatcher2 = widthWatcher) === null ||
          _widthWatcher2 === void 0 ||
          _widthWatcher2.destroy()
    },
    updateOptionValues: (variant) => {
      const optionValueString = variant.options.join(', ')
      elements.optionValues.textContent = optionValueString
    },
  }
}
const lerp = (start, end, amt) => (1 - amt) * start + amt * end,
  selectors$I = {
    stickyContainer: '[data-sticky-container]',
    stickyFilterBar: '.filter-bar--sticky',
    root: ':root',
  },
  classes$m = { hasSticky: 'has-sticky-scroll' }
function stickyScroll(node) {
  const stickyContainer = n$2(selectors$I.stickyContainer, node)
  if (!stickyContainer) return !1
  let resizeObserver
  node.style.setProperty('--sticky-container-top', 0)
  let previousScrollY = window.scrollY,
    currentScrollAmount = 0,
    headerHeight = 0,
    stickyFilterBarHeight = 0
  const stickyFilterBar = n$2(selectors$I.stickyFilterBar),
    root = n$2(selectors$I.root, document)
  root.style.setProperty('--sticky-filter-bar-height', '0px')
  let stickyContainerTop = headerHeight,
    stickyContainerTopPrevious = stickyContainerTop,
    stickyContainerHeight = stickyContainer.offsetHeight,
    stickyContainerHeightWithHeaderAndBar = stickyContainerHeight + headerHeight,
    stickyContainerMaxTop = stickyContainerHeightWithHeaderAndBar - window.innerHeight
  const scroller = srraf((_ref) => {
    let { y } = _ref
    _scrollHandler(y),
      stickyFilterBar && (stickyFilterBarHeight = stickyFilterBar.offsetHeight),
      root.style.setProperty('--sticky-filter-bar-height', ''.concat(stickyFilterBarHeight, 'px'))
  })
  provideResizeObserver().then((_ref2) => {
    let { ResizeObserver: ResizeObserver2 } = _ref2
    resizeObserver && resizeObserver.disconnect(),
      (resizeObserver = new ResizeObserver2(_observeHeight)),
      resizeObserver.observe(stickyContainer),
      resizeObserver.observe(document.documentElement)
  }),
    requestAnimationFrame(() => _updateStickyContainerTopLoop())
  function _observeHeight() {
    ;(stickyContainerHeight = stickyContainer.offsetHeight),
      stickyFilterBar && (stickyFilterBarHeight = stickyFilterBar.offsetHeight),
      (headerHeight = parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--header-desktop-sticky-height')
          .replace(/px/gi, '')
      )),
      (stickyContainerHeightWithHeaderAndBar =
        stickyContainerHeight + headerHeight + stickyFilterBarHeight),
      (stickyContainerMaxTop = stickyContainerHeightWithHeaderAndBar - window.innerHeight),
      stickyContainerHeightWithHeaderAndBar > window.innerHeight &&
      node.offsetHeight > stickyContainerHeightWithHeaderAndBar
        ? (u$1(node, classes$m.hasSticky), _scrollHandler(window.scrollY))
        : i$1(node, classes$m.hasSticky)
  }
  function _scrollHandler(y) {
    currentScrollAmount = previousScrollY - y
    const currentScrollOffset = stickyContainerTop + currentScrollAmount,
      topMax = headerHeight + stickyFilterBarHeight,
      bottomMax = -stickyContainerMaxTop + headerHeight + stickyFilterBarHeight - 40
    ;(stickyContainerTop = Math.max(bottomMax, Math.min(currentScrollOffset, topMax))),
      (previousScrollY = y)
  }
  function _updateStickyContainerTopLoop() {
    stickyContainerTop !== stickyContainerTopPrevious &&
      ((stickyContainerTopPrevious = lerp(stickyContainerTopPrevious, stickyContainerTop, 0.5)),
      node.style.setProperty(
        '--sticky-container-top',
        ''.concat(stickyContainerTopPrevious, 'px')
      )),
      requestAnimationFrame(() => _updateStickyContainerTopLoop())
  }
  function destroy2() {
    var _resizeObserver
    scroller?.destroy(),
      (_resizeObserver = resizeObserver) === null ||
        _resizeObserver === void 0 ||
        _resizeObserver.disconnect()
  }
  return { destroy: destroy2 }
}
const { icons: icons$1 } = window.theme
function productLightbox() {
  if (!t$2('.lightbox-image', document).length) return
  let productLightbox2
  import(flu.chunks.photoswipe).then((_ref) => {
    let { PhotoSwipeLightbox, PhotoSwipe } = _ref
    ;(productLightbox2 = new PhotoSwipeLightbox({
      gallery: '.lightbox-media-container',
      children: '.lightbox-image',
      showHideAnimationType: 'zoom',
      pswpModule: PhotoSwipe,
      mainClass: 'pswp--product-lightbox',
      bgOpacity: 1,
      arrowPrevSVG: icons$1.chevron,
      arrowNextSVG: icons$1.chevron,
      closeSVG: icons$1.close,
      zoomSVG: icons$1.zoom,
    })),
      productLightbox2.init(),
      productLightbox2.on('firstUpdate', () => {
        const { pswp, options } = productLightbox2
        options.dataSource.items.length === 1 && u$1(pswp.element, 'pswp--is-single-image')
      })
  })
}
const selectors$H = {
    unitPriceContainer: '[data-unit-price-container]',
    unitPrice: '[data-unit-price]',
    unitPriceBase: '[data-unit-base]',
  },
  classes$l = { available: 'unit-price--available' },
  updateUnitPrices = (container, variant) => {
    const unitPriceContainers = t$2(selectors$H.unitPriceContainer, container),
      unitPrices = t$2(selectors$H.unitPrice, container),
      unitPriceBases = t$2(selectors$H.unitPriceBase, container),
      showUnitPricing = !variant || !variant.unit_price
    l(unitPriceContainers, classes$l.available, !showUnitPricing),
      !(!variant || !variant.unit_price) &&
        (_replaceText(unitPrices, formatMoney(variant.unit_price)),
        _replaceText(unitPriceBases, _getBaseUnit(variant.unit_price_measurement)))
  },
  _getBaseUnit = (unitPriceMeasurement) =>
    unitPriceMeasurement.reference_value === 1
      ? unitPriceMeasurement.reference_unit
      : unitPriceMeasurement.reference_value + unitPriceMeasurement.reference_unit,
  _replaceText = (nodeList, replacementText) => {
    nodeList.forEach((node) => (node.innerText = replacementText))
  },
  ls = {
    get: () => JSON.parse(localStorage.getItem('fluco_sto_recentlyViewed')),
    set: (val) => localStorage.setItem('fluco_sto_recentlyViewed', JSON.stringify(val)),
  },
  updateRecentProducts = (productHandle) => {
    let recentlyViewed = []
    ls.get() !== null
      ? ((recentlyViewed = ls.get().filter((storedHandle) => storedHandle !== productHandle)),
        recentlyViewed.unshift(productHandle),
        ls.set(recentlyViewed.slice(0, 16)))
      : ls.get() === null && (recentlyViewed.push(productHandle), ls.set(recentlyViewed))
  },
  getRecentProducts = () => ls.get(),
  storeAvailability = (container, product, variant) => {
    const update = (variant2) => {
      if (((container.innerHTML = ''), !variant2)) return
      const variantSectionUrl = ''
        .concat(container.dataset.baseUrl, '/variants/')
        .concat(variant2.id, '/?section_id=store-availability')
      makeRequest('GET', variantSectionUrl).then((storeAvailabilityHTML) => {
        storeAvailabilityHTML.trim() !== '' &&
          ((container.innerHTML = storeAvailabilityHTML.trim()),
          (container.innerHTML = container.firstElementChild.innerHTML),
          container.setAttribute('data-variant-id', variant2.id),
          container.setAttribute('data-product-title', product.title),
          container.setAttribute('data-variant-title', variant2.public_title))
      })
    }
    return (
      update(variant),
      {
        unload: () => {
          container.innerHTML = ''
        },
        update,
      }
    )
  }
var _window$flu$states$2
const selectors$G = {
    form: '[data-product-form]',
    addToCart: '[data-add-to-cart]',
    variantSelect: '[data-variant-select]',
    optionById: (id) => "[value='".concat(id, "']"),
    thumbs: '[data-product-thumbnails]',
    thumb: '[data-product-thumbnail]',
    storeAvailability: '[data-store-availability-container]',
    quantityError: '[data-quantity-error]',
    productOption: '.product__option',
    optionLabelValue: '[data-selected-value-for-option]',
    displayedDiscount: '[data-discount-display]',
    displayedDiscountByVariantId: (id) =>
      '[variant-discount-display][variant-id="'.concat(id, '"]'),
    nonSprRatingCountLink: '.product__rating-count-potential-link',
    photosMobile: '.product__media-container.below-mobile',
    mobileCarousel: '.product__media-container.below-mobile.carousel',
    photosDesktop: '.product__media-container.above-mobile',
    mobileFeaturedImage: ".carousel_slide[data-is-featured='true']",
    priceWrapper: '.product__price',
    quickCart: '.quick-cart',
    purchaseConfirmation: '.purchase-confirmation-popup',
    productReviews: '#shopify-product-reviews',
    customOptionInputs: '[data-custom-option-input]',
    customOptionInputTargetsById: (id) => "[data-custom-option-target='".concat(id, "']"),
    giftCardRecipientContainer: '.product-form__gift-card-recipient',
    productMedia: '[data-product-media]',
    moreMediaButton: '[data-more-media]',
  }
let useCustomEvents$2 =
    (_window$flu$states$2 = window.flu.states) === null || _window$flu$states$2 === void 0
      ? void 0
      : _window$flu$states$2.useCustomEvents
useCustomEvents$2=true

class Product {
  constructor(node) {
    this.container = node
    const {
      isQuickView,
      isFullProduct,
      isFeaturedProduct,
      enableStickyContainer,
      loopMobileCarousel,
      hideMobileCarouselDots,
      enableMultipleVariantMedia,
      initialMediaId,
      sectionId,
      productHandle,
    } = this.container.dataset
    ;(this.isQuickView = isQuickView === 'true'),
      (this.isFullProduct = isFullProduct === 'true'),
      (this.isFeaturedProduct = isFeaturedProduct === 'true'),
      (this.loopMobileCarousel = loopMobileCarousel === 'true'),
      (this.hideMobileCarouselDots = hideMobileCarouselDots === 'true'),
      (this.enableMultipleVariantMedia = enableMultipleVariantMedia),
      (this.previousMediaId = initialMediaId),
      (this.sectionId = sectionId),
      (this.productHandle = productHandle),
      (this.formElement = n$2(selectors$G.form, this.container)),
      (this.quantityError = n$2(selectors$G.quantityError, this.container)),
      (this.displayedDiscount = n$2(selectors$G.displayedDiscount, this.container)),
      (this.viewInYourSpace = n$2('[data-in-your-space]', this.container)),
      this.viewInYourSpace && l(this.viewInYourSpace, 'visible', isMobile$1()),
      (this.photosDesktop = n$2(selectors$G.photosDesktop, this.container)),
      (this.mobileQuery = window.matchMedia(getMediaQuery('below-960'))),
      (this.breakPointHandler = atBreakpointChange(960, () => {
        if (this.isFullProduct)
          if (this.mobileQuery.matches) this._initPhotoCarousel()
          else {
            var _this$mobileSwiper
            ;(_this$mobileSwiper = this.mobileSwiper) === null ||
              _this$mobileSwiper === void 0 ||
              _this$mobileSwiper.destroy()
          }
        this._initStickyScroll()
      })),
      this._initThumbnails(),
      (this.storeAvailabilityContainer = n$2(selectors$G.storeAvailability, this.container)),
      (this.availability = null),
      (this.reviewsHandler = reviewsHandler(
        n$2(selectors$G.productReviews, this.container),
        this.container
      ))
    let nonSprRatingCount = n$2(selectors$G.nonSprRatingCountLink, this.container)
    if (
      (nonSprRatingCount &&
        !n$2(selectors$G.productReviews, document) &&
        nonSprRatingCount.removeAttribute('href'),
      this.formElement)
    ) {
      const { productHandle: productHandle2, currentProductId } = this.formElement.dataset
      getProduct(productHandle2)((data) => {
        var _variant$featured_med
        const variant = getVariantFromId(data, parseInt(currentProductId))
        this.storeAvailabilityContainer &&
          variant &&
          (this.availability = storeAvailability(this.storeAvailabilityContainer, data, variant)),
          (this.productForm = ProductForm(this.container, this.formElement, data, {
            onOptionChange: (e2) => this.onOptionChange(e2),
            onFormSubmit: (e2) => this.onFormSubmit(e2),
            onQuantityChange: (e2) => this.onQuantityChange(e2),
          })),
          this.productThumbnails &&
            ((_variant$featured_med = variant.featured_media) === null ||
            _variant$featured_med === void 0
              ? void 0
              : _variant$featured_med.id) == initialMediaId &&
            this.scrollThumbnails(variant)
        const productInventoryJson = n$2('[data-product-inventory-json]', this.container)
        if (productInventoryJson) {
          const variantsInventories = JSON.parse(productInventoryJson.innerHTML).inventory
          if (variantsInventories) {
            const config = { id: variant.id, variantsInventories }
            this.inventoryCounter = inventoryCounter(this.container, config)
          }
        }
      })
    }
    ;(this.quantityInput = quantityInput(this.container)),
      (this.customOptionInputs = t$2(selectors$G.customOptionInputs, this.container)),
      (this.socialButtons = t$2('[data-social-share]', this.container)),
      (this.featuredProducts = featuredProducts(this.container)),
      enableStickyContainer === 'true' && this._initStickyScroll(),
      this._loadAccordions(),
      (this.optionButtons = OptionButtons(t$2('[data-option-buttons]', this.container))),
      (this.informationPopup = informationPopup(this.container))
    const productDescriptionWrapper = n$2('.product__description', this.container)
    productDescriptionWrapper &&
      (wrapIframes(t$2('iframe', productDescriptionWrapper)),
      wrapTables(t$2('table', productDescriptionWrapper)))
    const socialShareContainer = n$2('.social-share', this.container)
    socialShareContainer && (this.socialShare = SocialShare(socialShareContainer)),
      this.isFullProduct && this.productHandle && updateRecentProducts(this.productHandle),
      this._loadMedia(),
      this._initEvents(),
      (this.variantAvailability = variantAvailability(this.container)),
      (this.siblingProducts = siblingProducts(this.container)),
      (this.giftCardRecipient = giftCardRecipient(this.container)),
      (this.stickyAtcBar = stickyAtcBar(this.container))
  }
  _initEvents() {
    ;(this.events = [
      e$2(this.productThumbnailItems, 'click', (e2) => {
        e2.preventDefault()
        const {
          currentTarget: { dataset },
        } = e2
        this.productThumbnailItems.forEach((thumb) => i$1(thumb, 'active')),
          u$1(e2.currentTarget, 'active'),
          switchImage(this.desktopMedia, dataset.thumbnailId, this.viewInYourSpace)
      }),
    ]),
      this.customOptionInputs &&
        this.customOptionInputs.forEach((input) => {
          const id = input.dataset.customOptionInput,
            target = n$2(selectors$G.customOptionInputTargetsById(id), this.container)
          this.events.push(
            e$2(input, 'change', (e2) => {
              e2.target.type === 'checkbox'
                ? (target.checked = e2.target.checked)
                : (target.value = e2.target.value)
            })
          )
        })
  }
  _initStickyScroll() {
    this.mobileQuery.matches
      ? this.stickyScroll && (this.stickyScroll.destroy(), (this.stickyScroll = null))
      : this.stickyScroll || (this.stickyScroll = stickyScroll(this.container))
  }
  _initPhotoCarousel() {
    let swiperWrapper = n$2(selectors$G.mobileCarousel, this.container)
    if (!swiperWrapper) return
    const mobileFeaturedImage = n$2(selectors$G.mobileFeaturedImage, swiperWrapper),
      initialSlide = mobileFeaturedImage ? parseInt(mobileFeaturedImage.dataset.slideIndex) : 0
    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination } = _ref
      ;(this.mobileSwiper = new Swiper(swiperWrapper, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        grabCursor: !0,
        pagination: this.hideMobileCarouselDots
          ? {}
          : {
              el: '.swiper-pagination',
              type: 'bullets',
              dynamicBullets: !0,
              dynamicMainBullets: 7,
              clickable: !0,
            },
        watchSlidesProgress: !0,
        loop: this.loopMobileCarousel,
        autoHeight: !0,
        initialSlide,
      })),
        this.mobileSwiper.on('slideChange', (evt) => {
          if (this.viewInYourSpace) {
            const activeSlide = evt.slides[evt.activeIndex]
            activeSlide.dataset.mediaType === 'model' &&
              this.viewInYourSpace.setAttribute(
                'data-shopify-model3d-id',
                activeSlide.dataset.mediaItemId
              )
          }
          this.mediaContainersMobile && this.mediaContainersMobile.pauseActiveMedia()
        })
    })
  }
  _initThumbnails() {
    ;(this.productThumbnails = n$2(selectors$G.thumbs, this.container)),
      (this.productThumbnailItems = t$2(selectors$G.thumb, this.container)),
      this.productThumbnails &&
        (this.productThumbnailsScroller = scrollContainer(this.productThumbnails))
  }
  _loadMedia() {
    ;(this.mobileMedia = n$2(selectors$G.photosMobile, this.container)),
      (this.desktopMedia = n$2(selectors$G.photosDesktop, this.container)),
      (this.mobileMoreMedia = moreMedia(this.mobileMedia)),
      (this.desktopMoreMedia = moreMedia(this.desktopMedia)),
      (this.mediaContainers = Media(this.desktopMedia)),
      (this.mediaContainersMobile = Media(this.mobileMedia)),
      this._initThumbnails(),
      productLightbox(),
      this.isFullProduct && this.mobileQuery.matches && this._initPhotoCarousel()
  }
  _loadAccordions() {
    ;(this.accordions = []),
      t$2('.accordion', this.container).forEach((accordion2) => {
        const accordionOpen = accordion2.classList.contains('accordion--open')
        this.accordions.push(Accordions(accordion2, { firstOpen: accordionOpen }))
        const accordionParent = accordion2.parentElement
        accordionParent.classList.contains('rte--product') &&
          !accordionParent.classList.contains('accordion accordion--product') &&
          accordion2.classList.add('rte--product', 'accordion--product')
      })
  }
  _switchCurrentImage(id) {
    t$2('.product__media', this.container).forEach((imagesWrap) => switchImage(imagesWrap, id))
  }
  _refreshOverviewWithVariant(variant_id) {
    const requestURL = `${window.location.pathname}?section_id=${this.sectionId}&variant=${variant_id}`;
    const target = n$2('.product__primary-left', this.container)

    t$2(`${selectors$G.photosDesktop}, ${selectors$G.photosMobile}`, target)
    .forEach((container) => {
      u$1(container, 'loading')
    })

    fetch(requestURL)
      .then((response) => response.text())
      .then((text) => {
        const source = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.product__primary-left')

        target.innerHTML = source.innerHTML

        this._unloadMedia()
        this.accordions.forEach((accordion2) => accordion2.unload())

        if (this.featuredProducts) {
          this.featuredProducts.unload()
        }

        this.events.forEach((unsubscribe) => unsubscribe())
        this._loadMedia()
        this._loadAccordions()
        this.featuredProducts = featuredProducts(this.container)
        this._initEvents()
      })
      .catch((error) => {
        throw error
      })
  }
  onOptionChange(_ref2) {
    let {
      dataset: { variant },
      srcElement,
    } = _ref2

    const optionParentWrapper = srcElement.closest(selectors$G.productOption)
    const optionLabel = n$2(selectors$G.optionLabelValue, optionParentWrapper)

    if (optionLabel) {
      optionLabel.textContent = srcElement.value
    }

    const buyButtonEls = t$2(selectors$G.addToCart, this.container)
    const priceWrapper = n$2(selectors$G.priceWrapper, this.container)

    if (priceWrapper) {
      l(priceWrapper, 'hide', !variant)
    }
    updatePrices(this.container, variant, this.isFullProduct)
    buyButtonEls.forEach((buyButton) => {
      updateBuyButton(buyButton, variant)
    })
    updateUnitPrices(this.container, variant),
    updateSku(this.container, variant),
    this.availability && this.availability.update(variant)

    if (this.displayedDiscount) {
      const newDiscountEl = variant && n$2(selectors$G.displayedDiscountByVariantId(variant.id), this.container)

      this.displayedDiscount.textContent = variant && newDiscountEl ? newDiscountEl.textContent : ''
    }

    this.inventoryCounter && this.inventoryCounter.update(variant)
    useCustomEvents$2 && dispatchCustomEvent('product:variant-change', { variant })

    if (!variant){
      updateBuyButton(n$2('[data-add-to-cart]', this.container), false)
      this.availability && this.availability.unload()
      return
    }

    const url = getUrlWithVariant(window.location.href, variant.id)
    window.history.replaceState({ path: url }, '', url)
    const selectedVariantOpt = n$2(
      ''.concat(selectors$G.variantSelect, ' ').concat(selectors$G.optionById(variant.id)),
      this.container
    )

    selectedVariantOpt.selected = true;
    this.formElement.dispatchEvent(new Event('change'));

    if (variant.featured_media) {
      if (
        this.enableMultipleVariantMedia === 'true' &&
        variant.featured_media.id != this.previousMediaId
      ) {
        this._refreshOverviewWithVariant(variant.id)
        this.previousMediaId = variant.featured_media.id
      } else if (this.isFullProduct) {
        if (this.mobileSwiper && !this.mobileSwiper.destroyed) {
          const slidesWrap = this.mobileSwiper.el,
            targetSlide = n$2(
              '[data-media-item-id="'.concat(variant.featured_media.id, '"]'),
              slidesWrap
            )
          if (targetSlide) {
            const targetSlideIndex = [...targetSlide.parentElement.children].indexOf(targetSlide)
            this.mobileSwiper.slideTo(targetSlideIndex)
          }
        } else if (
          n$2('.product__media-container.above-mobile').dataset.galleryStyle === 'thumbnails'
        ) {
          switchImage(this.desktopMedia, variant.featured_media.id, this.viewInYourSpace)
          this.highlightActiveThumbnail(this.desktopMedia, variant)
          this.scrollThumbnails(variant)
        } else if (this.isFeaturedProduct) {
          this._switchCurrentImage(variant.featured_media.id)
        } else {
          const targetImage = n$2(
            '.product__media-container.above-mobile [data-media-id="'.concat(
              variant.featured_media.id,
              '"]'
            )
          )
          const moreMediaButton = n$2(selectors$G.moreMediaButton, this.container)
          const productMedia = n$2(selectors$G.productMedia, this.container)

          let visibleVariantImage = true
          if (moreMediaButton) {
            const mediaLimit = parseInt(productMedia.dataset.mediaLimit)
            visibleVariantImage =
              productMedia.dataset.productMedia === 'open' ||
              mediaLimit >= variant.featured_media.position
          }

          if (!moreMediaButton || visibleVariantImage) {
            targetImage?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest',
            })
          } else {
            if (!visibleVariantImage) {
              this.desktopMoreMedia.open(targetImage, true)
            }
          }
        }
      } else {
        this._switchCurrentImage(variant.featured_media.id)
      }
    }
    
    if (this.stickyAtcBar) {
      if (variant.featured_media) {
        this.stickyAtcBar.switchCurrentImage(variant.featured_media.id);
      }
      this.stickyAtcBar.updateOptionValues(variant);
    }
  }
  highlightActiveThumbnail(photos, variant) {
    const thumb = n$2('[data-thumbnail-id="'.concat(variant.featured_media.id, '"]'), photos)
    this.productThumbnailItems.forEach((thumb2) => i$1(thumb2, 'active')),
      thumb && u$1(thumb, 'active')
  }
  scrollThumbnails(variant) {
    if (!variant.featured_media) return
    const groupThumb = n$2(
      '[data-thumbnail-id="'.concat(variant.featured_media.id, '"]'),
      this.productThumbnails
    ).closest('li')
    this.productThumbnailsScroller.scrollTo(groupThumb)
  }
  onQuantityChange(_ref3) {
    let {
      dataset: { variant, quantity },
    } = _ref3
    ;[...t$2('[name="quantity"]', this.formElement)].forEach((quantityInput2) => {
      quantityInput2.value = quantity
    }),
      useCustomEvents$2 && dispatchCustomEvent('product:quantity-update', { quantity, variant })
  }
  onFormSubmit(e2) {
    const purchaseConfirmation2 = n$2(selectors$G.purchaseConfirmation, document),
      quickCart2 = n$2(selectors$G.quickCart, document),
      buttonEls = t$2(selectors$G.addToCart, this.container)
    buttonEls.forEach((button) => {
      u$1(button, 'loading')
      button.setAttribute('data-loading', 'true')
    }),
      !(!purchaseConfirmation2 && !quickCart2) &&
        (e2.preventDefault(),
        u$1(this.quantityError, 'hidden'),
        cart
          .addItem(this.formElement)
          .then((_ref4) => {
            let { item } = _ref4
            buttonEls.forEach((button) => {
              i$1(button, 'loading')
              button.setAttribute('data-loading', 'false')
            }),
              purchaseConfirmation2
                ? r$1('confirmation-popup:open', null, { product: item })
                : (r$1('quick-cart:updated'),
                  setTimeout(() => {
                    r$1('quick-cart:open')
                  }, 300)),
              useCustomEvents$2 && dispatchCustomEvent('cart:item-added', { product: item })
          })
          .catch((error) => {
            if ((cart.get(), error && error.message))
              if (typeof error.message == 'object') {
                const sectionID = n$2(selectors$G.giftCardRecipientContainer, this.container)
                  .dataset.sectionId
                Object.entries(error.message).forEach((_ref5) => {
                  let [key, value] = _ref5
                  const errorMessageID = 'display-gift-card-recipient-'
                      .concat(key, '-error--')
                      .concat(sectionID),
                    errorMessage = n$2('#'.concat(errorMessageID), this.container),
                    errorInput = n$2(
                      '#display-gift-card-recipient-'.concat(key, '--').concat(sectionID),
                      this.container
                    )
                  ;(errorMessage.innerText = value),
                    i$1(errorMessage, 'hidden'),
                    errorInput.setAttribute('aria-invalid', !0),
                    errorInput.setAttribute('aria-describedby', errorMessageID)
                })
              } else
                (this.quantityError.innerText = error.message), i$1(this.quantityError, 'hidden')
            else
              (this.quantityError.innerText = this.quantityErorr.getAttribute(
                'data-fallback-error-message'
              )),
                i$1(this.quantityError, 'hidden')
            t$2(selectors$G.addToCart, this.container).forEach((button) => {
              i$1(button, 'loading')
              button.setAttribute('data-loading', 'false')
            })
          }))
  }
  _unloadMedia() {
    var _this$mobileMoreMedia, _this$desktopMoreMedi, _this$mobileSwiper2, _this$productThumbnai
    ;(_this$mobileMoreMedia = this.mobileMoreMedia) === null ||
      _this$mobileMoreMedia === void 0 ||
      _this$mobileMoreMedia.unload(),
      (_this$desktopMoreMedi = this.desktopMoreMedia) === null ||
        _this$desktopMoreMedi === void 0 ||
        _this$desktopMoreMedi.unload(),
      (_this$mobileSwiper2 = this.mobileSwiper) === null ||
        _this$mobileSwiper2 === void 0 ||
        _this$mobileSwiper2.destroy(),
      (_this$productThumbnai = this.productThumbnailsScroller) === null ||
        _this$productThumbnai === void 0 ||
        _this$productThumbnai.unload()
  }
  unload() {
    var _this$quantityInput,
      _this$stickyScroll,
      _this$mobileMoreMedia2,
      _this$desktopMoreMedi2,
      _this$featuredProduct2,
      _this$variantAvailabi,
      _this$siblingProducts,
      _this$giftCardRecipie,
      _this$stickyAtcBar
    this._unloadMedia(),
      this.productForm.destroy(),
      this.accordions.forEach((accordion2) => accordion2.unload()),
      this.optionButtons.destroy(),
      (_this$quantityInput = this.quantityInput) === null ||
        _this$quantityInput === void 0 ||
        _this$quantityInput.unload(),
      this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$stickyScroll = this.stickyScroll) === null ||
        _this$stickyScroll === void 0 ||
        _this$stickyScroll.destroy(),
      (_this$mobileMoreMedia2 = this.mobileMoreMedia) === null ||
        _this$mobileMoreMedia2 === void 0 ||
        _this$mobileMoreMedia2.unload(),
      (_this$desktopMoreMedi2 = this.desktopMoreMedia) === null ||
        _this$desktopMoreMedi2 === void 0 ||
        _this$desktopMoreMedi2.unload(),
      (_this$featuredProduct2 = this.featuredProducts) === null ||
        _this$featuredProduct2 === void 0 ||
        _this$featuredProduct2.unload(),
      (_this$variantAvailabi = this.variantAvailability) === null ||
        _this$variantAvailabi === void 0 ||
        _this$variantAvailabi.unload(),
      (_this$siblingProducts = this.siblingProducts) === null ||
        _this$siblingProducts === void 0 ||
        _this$siblingProducts.unload(),
      (_this$giftCardRecipie = this.giftCardRecipient) === null ||
        _this$giftCardRecipie === void 0 ||
        _this$giftCardRecipie.unload(),
      (_this$stickyAtcBar = this.stickyAtcBar) === null ||
        _this$stickyAtcBar === void 0 ||
        _this$stickyAtcBar.unload()
  }
}
var _window$flu$states$1
const classes$k = { visible: 'is-visible', active: 'active', fixed: 'is-fixed' },
  selectors$F = {
    closeBtn: '[data-modal-close]',
    wash: '.modal__wash',
    modalContent: '.quick-view-modal__content',
    loadingMessage: '.quick-view-modal-loading-indicator',
    siblingSwatch: '.product__color-swatch--sibling-product',
  },
  useCustomEvents$1 =
    (_window$flu$states$1 = window.flu.states) === null || _window$flu$states$1 === void 0
      ? void 0
      : _window$flu$states$1.useCustomEvents,
  quickViewModal = (node) => {
    const focusTrap = createFocusTrap(node, { allowOutsideClick: !0 }),
      wash = n$2(selectors$F.wash, node),
      closeButton = n$2(selectors$F.closeBtn, node),
      modalContent = n$2(selectors$F.modalContent, node),
      loadingMessage = n$2(selectors$F.loadingMessage, node)
    let quickViewAnimation = null
    shouldAnimate(node) && (quickViewAnimation = animateQuickView(node))
    let product
    const events2 = [
        e$2([wash, closeButton], 'click', (e2) => {
          e2.preventDefault(), _close()
        }),
        e$2(node, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && _close()
        }),
        c('quick-view:open', (state, _ref2) => {
          let { productUrl } = _ref2
          _renderProductContent(productUrl), _open()
        }),
        c('quick-view:close', () => {
          _close()
        }),
        c('quick-view:refresh', (state, _ref3) => {
          let { productUrl } = _ref3
          _renderProductContent(productUrl)
        }),
      ],
      _renderProductContent = (productUrl) => {
        const xhrUrl = ''
          .concat(productUrl)
          .concat(productUrl.includes('?') ? '&' : '?', 'view=quick-view')
        makeRequest('GET', xhrUrl).then((response) => {
          let container = document.createElement('div')
          container.innerHTML = response
          const productElement = n$2('[data-is-quick-view]', container)
          t$2(selectors$F.siblingSwatch, container).forEach((sibling) => {
            const productUrl2 = sibling.pathname
            e$2(sibling, 'click', (e2) => {
              e2.preventDefault(),
                e2.stopPropagation(),
                r$1('quick-view:refresh', null, { productUrl: productUrl2 })
            })
          }),
            i$1(modalContent, 'empty'),
            (modalContent.innerHTML = ''),
            modalContent.appendChild(productElement)
          const renderedProductElement = n$2('[data-is-quick-view]', modalContent)
          shouldAnimate(node) && quickViewAnimation.animate(),
            (product = new Product(renderedProductElement)),
            useCustomEvents$1 && dispatchCustomEvent('quickview:loaded')
        })
      },
      _open = () => {
        u$1(node, classes$k.fixed),
          setTimeout(() => {
            u$1(node, classes$k.active),
              setTimeout(() => {
                u$1(node, classes$k.visible), focusTrap.activate()
              }, 50)
          }, 50),
          document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
          disableBodyScroll(node, {
            allowTouchMove: (el) => {
              for (; el && el !== document.body; ) {
                if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
                el = el.parentNode
              }
            },
            reserveScrollBarGap: !0,
          })
      },
      _close = () => {
        focusTrap.deactivate(),
          i$1(node, classes$k.visible),
          i$1(node, classes$k.active),
          document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
          enableBodyScroll(node),
          r$1('quick-cart:scrollup'),
          setTimeout(() => {
            var _product
            i$1(node, classes$k.fixed),
              shouldAnimate(node) && quickViewAnimation.reset(),
              (modalContent.innerHTML = ''),
              modalContent.appendChild(loadingMessage),
              u$1(modalContent, 'empty'),
              (_product = product) === null || _product === void 0 || _product.unload()
          }, 500)
      }
    return {
      unload: () => {
        events2.forEach((unsubscribe) => unsubscribe())
      },
    }
  },
  classes$j = { visible: 'is-visible' },
  flashAlertModal = (node) => {
    window.Shopify.designMode &&
      new Delegate(document.body).on('click', '[data-flash-trigger]', (_, target) => {
        const { flashMessage } = target.dataset
        _open(flashMessage)
      }),
      c('flart-alert', (_ref) => {
        let { alert } = _ref
        _open(alert)
      })
    const _open = (alertMessage) => {
      if (!alertMessage) return
      const messageContainer = n$2('.flash-alert__container', node)
      ;(messageContainer.innerText = alertMessage),
        u$1(node, classes$j.visible),
        messageContainer.addEventListener(
          'animationend',
          () => {
            i$1(node, classes$j.visible)
          },
          { once: !0 }
        )
    }
  },
  selectors$E = { innerOverlay: '.header-overlay__inner' },
  classes$i = { isVisible: 'is-visible', isActive: 'is-active' },
  events = {
    show: 'headerOverlay:show',
    hide: 'headerOverlay:hide',
    hiding: 'headerOverlay:hiding',
  },
  headerOverlay = (node) => {
    if (!node) return
    const overlay = node,
      overlayInner = node.querySelector(selectors$E.innerOverlay),
      overlayShowListener = c(events.show, () => _showOverlay()),
      overlayHideListener = c(events.hide, () => _hideOverlay()),
      _showOverlay = () => {
        o$1({ headerOverlayOpen: !0 }),
          overlay.classList.add(classes$i.isActive),
          setTimeout(() => {
            overlayInner.classList.add(classes$i.isVisible)
          }, 0)
      },
      _hideOverlay = () => {
        o$1({ headerOverlayOpen: !1 }),
          r$1(events.hiding),
          overlayInner.classList.remove(classes$i.isVisible),
          setTimeout(() => {
            overlay.classList.remove(classes$i.isActive)
          }, 0)
      }
    return {
      unload: () => {
        overlayShowListener(), overlayHideListener()
      },
    }
  }
function debounce() {
  let timer
  return function (func) {
    let time = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100
    timer && clearTimeout(timer), (timer = setTimeout(func, time))
  }
}
const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style,
  backToTop = () => {
    const node = n$2('[data-back-to-top]')
    if (!node) return
    const pageHeight = window.innerHeight
    let isVisible2 = !1
    const backToTopDebounce = debounce()
    srraf((_ref) => {
      let { y } = _ref
      return backToTopDebounce(() => _scrollHandler(y))
    })
    function _scrollHandler(y) {
      ;((y > pageHeight && !isVisible2) || (y < pageHeight && isVisible2)) && _toggleVisibility()
    }
    function _toggleVisibility() {
      l(node, 'visible'), (isVisible2 = !isVisible2)
    }
    n$2('[data-back-to-top-button]', node).addEventListener('click', _buttonClick)
    function _buttonClick() {
      supportsNativeSmoothScroll
        ? window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        : window.scrollTo(0, 0)
    }
  }
function PredictiveSearch(resultsContainer) {
  const cachedResults = {}
  function renderSearchResults(resultsMarkup) {
    resultsContainer.innerHTML = resultsMarkup
  }
  function getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    if (cachedResults[''.concat(queryKey)]) {
      renderSearchResults(cachedResults[''.concat(queryKey)])
      return
    }
    const params = new URLSearchParams()
    params.set('section_id', 'predictive-search'),
      params.set('q', searchTerm),
      window.theme.searchableFields &&
        params.set('resources[options][fields]', window.theme.searchableFields)
    const url = ''.concat(window.theme.routes.predictive_search_url, '?').concat(params)
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status)
        return response.text()
      })
      .then((text) => {
        let resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        ;(cachedResults[queryKey] = resultsMarkup), renderSearchResults(resultsMarkup)
      })
      .catch((error) => {
        throw error
      })
  }
  return { getSearchResults }
}
const classes$h = { active: 'active', visible: 'quick-search--visible' }
function QuickSearch(node, header) {
  const overlay = n$2('[data-overlay]', node),
    form = n$2('[data-quick-search-form]', node),
    input = n$2('[data-input]', node),
    clear = n$2('[data-clear]', node),
    resultsContainer = n$2('[data-results]', node),
    predictiveSearch = PredictiveSearch(resultsContainer),
    closeButton = n$2('[data-close-icon]', node),
    searchToggles = t$2('[data-search]', header)
  let scrollPosition = 0
  const events2 = [
      e$2([overlay, closeButton], 'click', close),
      e$2(clear, 'click', reset),
      e$2(input, 'input', handleInput),
      e$2(node, 'keydown', (_ref) => {
        let { keyCode } = _ref
        keyCode === 27 && close()
      }),
      c('drawer-menu:open', () => {
        a$1(node, classes$h.active) && close()
      }),
    ],
    trap = createFocusTrap(node, { allowOutsideClick: !0 })
  function handleInput(e2) {
    e2.target.value === '' && reset(),
      l(clear, classes$h.visible, e2.target.value !== ''),
      l(input.parentNode, classes$h.active, e2.target.value !== ''),
      l(form, classes$h.active, e2.target.value !== ''),
      predictiveSearch.getSearchResults(e2.target.value)
  }
  function reset(e2) {
    e2 && e2.preventDefault(),
      (input.value = ''),
      i$1(clear, classes$h.visible),
      i$1(input.parentNode, classes$h.active),
      i$1(form, classes$h.active),
      (resultsContainer.innerHTML = ''),
      input.focus()
  }
  function toggleSearch() {
    node.style.setProperty('--scroll-y', Math.ceil(window.scrollY) + 'px'),
      node.getAttribute('aria-hidden') === 'false' ? close() : open()
  }
  function open() {
    r$1('search:open'),
      searchToggles.forEach((searchToggle) => {
        searchToggle.setAttribute('aria-expanded', !0)
      }),
      u$1(node, classes$h.active),
      node.setAttribute('aria-hidden', !1),
      document.body.setAttribute('quick-search-open', 'true'),
      trap.activate(),
      setTimeout(() => {
        input.focus({ preventScroll: !0 }),
          document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
          disableBodyScroll(node, {
            allowTouchMove: (el) => {
              for (; el && el !== document.body; ) {
                if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
                el = el.parentNode
              }
            },
            reserveScrollBarGap: !0,
          }),
          (scrollPosition = window.pageYOffset),
          (document.body.style.top = '-'.concat(scrollPosition, 'px')),
          document.body.classList.add('scroll-lock'),
          u$1(node, classes$h.visible)
      }, 50)
  }
  function close() {
    searchToggles.forEach((searchToggle) => {
      searchToggle.setAttribute('aria-expanded', !1)
    }),
      i$1(node, classes$h.visible),
      document.body.setAttribute('quick-search-open', 'false'),
      trap.deactivate(),
      setTimeout(() => {
        i$1(node, classes$h.active),
          node.setAttribute('aria-hidden', !0),
          document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
          enableBodyScroll(node),
          document.body.classList.remove('scroll-lock'),
          (document.body.style.top = ''),
          window.scrollTo(0, scrollPosition)
      }, 500)
  }
  function destroy2() {
    close(), events2.forEach((unsubscribe) => unsubscribe())
  }
  return { toggleSearch, destroy: destroy2 }
}
function Navigation(node, headerSection) {
  if (!node) return
  const dropdownTriggers = t$2('[data-dropdown-trigger]', node),
    meganavTriggers = t$2('[data-meganav-trigger]', node),
    meganavs = t$2('.meganav, node'),
    nonTriggers = t$2(
      '.header__links-list > li > [data-link]:not([data-meganav-trigger]):not([data-dropdown-trigger])',
      node
    ),
    header = n$2('[data-section-type="header"]', document.body),
    primaryRow = n$2('.header__links-primary', header).closest('.header__row'),
    submenuItem = n$2('.navigation__submenu .navigation__submenu-item', node)
  if (!dropdownTriggers) return
  submenuItem &&
    node.style.setProperty('--submenu-item-height', ''.concat(submenuItem.clientHeight, 'px'))
  const delegate = new Delegate(document.body)
  delegate.on('click', null, (e2) => handleClick(e2)),
    delegate.on('mouseover', '.header-overlay__inner', (e2) => {
      ;(Shopify.designMode && headerSection.meganavOpenedFromDesignMode) || closeAll(node)
    }),
    meganavs.forEach((nav) => {
      shouldAnimate(nav) && animateMeganav(nav)
    })
  const events2 = [
    e$2(dropdownTriggers, 'focus', (e2) => {
      e2.preventDefault(), toggleMenu(e2.currentTarget.parentNode)
    }),
    e$2(dropdownTriggers, 'mouseover', (e2) => {
      e2.preventDefault(), toggleMenu(e2.currentTarget.parentNode, !0)
    }),
    e$2(meganavTriggers, 'focus', (e2) => {
      e2.preventDefault(), showMeganav(e2.target, e2.target.dataset.meganavHandle)
    }),
    e$2(meganavTriggers, 'mouseover', (e2) => {
      e2.preventDefault(), showMeganav(e2.target, e2.target.dataset.meganavHandle)
    }),
    e$2(nonTriggers, 'mouseover', () => {
      closeAll()
    }),
    e$2(primaryRow, 'mouseout', (e2) => {
      var _e$relatedTarget
      ;((_e$relatedTarget = e2.relatedTarget) === null || _e$relatedTarget === void 0
        ? void 0
        : _e$relatedTarget.closest('.header__row')) != primaryRow && closeAll()
    }),
    e$2(headerSection.container, 'mouseleave', () => {
      i$1(header, 'animation--dropdowns-have-animated-once'),
        i$1(header, 'animation--dropdowns-have-animated-more-than-once')
    }),
    e$2(node, 'keydown', (_ref) => {
      let { keyCode } = _ref
      keyCode === 27 && closeAll()
    }),
    e$2(t$2('.header__links-list > li > a', node), 'focus', () => {
      userIsUsingKeyboard() && closeAll()
    }),
    e$2(t$2('[data-link]', node), 'focus', (e2) => {
      if ((e2.preventDefault(), !userIsUsingKeyboard())) return
      const link = e2.currentTarget
      link.hasAttribute('data-dropdown-trigger') && toggleMenu(link.parentNode),
        t$2('[data-link]', link.parentNode.parentNode).forEach((el) =>
          l(t$2('[data-submenu]', el.parentNode), 'active', el === link)
        )
    }),
    e$2(t$2('[data-link]', node), 'focusout', (e2) => {
      userIsUsingKeyboard() &&
        e2.relatedTarget &&
        !(e2.relatedTarget.hasAttribute('data-link') || e2.relatedTarget.closest('.meganav')) &&
        closeAll()
    }),
    e$2(node, 'scroll', () => {
      document.documentElement.style.setProperty(
        '--navigation-menu-offet',
        ''.concat(node.scrollLeft, 'px')
      )
    }),
  ]
  function userIsUsingKeyboard() {
    return a$1(document.body, 'user-is-tabbing')
  }
  function showMeganav(menuTrigger, handle) {
    const menu2 = n$2('.meganav[data-menu-handle="'.concat(handle, '"]'), header)
    !menu2 ||
      a$1(menu2, 'active') ||
      (closeAll(void 0, { avoidShadeHide: !0 }),
      menuTrigger.setAttribute('aria-expanded', !0),
      menu2.dataset.alignToTrigger && alignMenuToTrigger(menu2, menuTrigger),
      menu2.setAttribute('aria-hidden', !1),
      u$1(header, 'dropdown-active'),
      u$1(menu2, 'active'),
      r$1('headerOverlay:show'))
  }
  function alignMenuToTrigger(menu2, menuTrigger) {
    const headerInner = n$2('.header__inner', headerSection.container),
      menuTriggerLeftEdge =
        menuTrigger != null && menuTrigger.getBoundingClientRect
          ? menuTrigger.getBoundingClientRect().left
          : menuTrigger.offsetLeft,
      menuWidth = menu2.getBoundingClientRect
        ? menu2.getBoundingClientRect().width
        : menu2.offsetWidth,
      headerWidth = headerInner.getBoundingClientRect
        ? headerInner.getBoundingClientRect().width
        : headerInner.offsetWidth,
      viewportWidth = window.innerWidth
    let menuLeftAlignment = menuTriggerLeftEdge
    menu2.dataset.meganavType && (menuLeftAlignment -= 24)
    const outerMargins = viewportWidth - headerWidth,
      menuLeftOffset = menuWidth === viewportWidth ? 0 : outerMargins / 2
    if (menuLeftAlignment - menuLeftOffset + menuWidth > headerWidth) {
      const offset = viewportWidth - menuWidth
      if (offset < outerMargins) {
        const menuCenterOffset = offset / 2
        menuLeftAlignment = offset - menuCenterOffset
      } else menuLeftAlignment = offset - menuLeftOffset
    }
    ;(menu2.style.left = ''.concat(menuLeftAlignment, 'px')), u$1(menu2, 'customAlignment')
  }
  function alignSubmenu(menu2, parentSubmenu) {
    var _parentSubmenu$getBou
    const viewportWidth = window.innerWidth,
      parentSubmenuRightPosition =
        parentSubmenu == null ||
        (_parentSubmenu$getBou = parentSubmenu.getBoundingClientRect()) === null ||
        _parentSubmenu$getBou === void 0
          ? void 0
          : _parentSubmenu$getBou.right,
      availableSpaceX = viewportWidth - parentSubmenuRightPosition - 24,
      menuWidth = menu2.offsetWidth
    availableSpaceX < menuWidth
      ? (menu2.dataset.position = 'left')
      : (menu2.dataset.position = 'right')
  }
  function verticallyAlignSubmenu(menu2, menuTrigger) {
    var _parentSubmenu$getBou2, _parentSubmenu$getBou3, _menuTrigger$getBound
    const viewportHeight = window.innerHeight,
      parentSubmenu = menuTrigger.closest('[data-submenu]'),
      parentSubmenuContentHeight = n$2('ul', parentSubmenu).scrollHeight,
      parentSubmenuTopPosition =
        parentSubmenu == null ||
        (_parentSubmenu$getBou2 = parentSubmenu.getBoundingClientRect()) === null ||
        _parentSubmenu$getBou2 === void 0
          ? void 0
          : _parentSubmenu$getBou2.top,
      parentSubmenuBottomPosition =
        parentSubmenu == null ||
        (_parentSubmenu$getBou3 = parentSubmenu.getBoundingClientRect()) === null ||
        _parentSubmenu$getBou3 === void 0
          ? void 0
          : _parentSubmenu$getBou3.bottom,
      availableSpaceY = viewportHeight - parentSubmenuTopPosition,
      menuTriggerTopPosition =
        menuTrigger == null ||
        (_menuTrigger$getBound = menuTrigger.getBoundingClientRect()) === null ||
        _menuTrigger$getBound === void 0
          ? void 0
          : _menuTrigger$getBound.top,
      menuTriggerHeight = menuTrigger.offsetHeight,
      menuContent = n$2('ul', menu2),
      menuContentHeight = menuContent.offsetHeight,
      availableMenuSpace = viewportHeight - menuTriggerTopPosition - menuContentHeight
    parentSubmenuContentHeight > availableSpaceY
      ? ((menu2.style.marginTop = ''),
        availableMenuSpace >= 0
          ? ((menu2.style.top = ''.concat(menuTriggerTopPosition - menuTriggerHeight - 16, 'px')),
            menuContent.style.setProperty(
              '--max-height',
              ''.concat(viewportHeight - menuTriggerTopPosition + 16, 'px')
            ))
          : ((menu2.style.top = ''.concat(
              parentSubmenuBottomPosition -
                Math.min(menuContentHeight, availableSpaceY) -
                menuTriggerHeight,
              'px'
            )),
            menuContent.style.setProperty('--max-height', ''.concat(availableSpaceY, 'px'))))
      : ((menu2.style.top = ''),
        (menu2.style.marginTop = '-'.concat(menuTriggerHeight + 16, 'px')),
        menuContent.style.setProperty(
          '--max-height',
          ''.concat(viewportHeight - menuTriggerTopPosition + 16, 'px')
        ))
  }
  function toggleMenu(el, force) {
    const menu2 = n$2('[data-submenu]', el),
      menuTrigger = n$2('[data-link]', el),
      parentSubmenu = el.closest('[data-submenu]')
    let action
    force ? (action = 'open') : force !== void 0 && (action = 'close'),
      action || (action = a$1(menu2, 'active') ? 'close' : 'open'),
      action === 'open' &&
        (parentSubmenu?.dataset.depth === '1'
          ? closeAll(parentSubmenu, { avoidShadeHide: !0 })
          : closeAll(void 0, { avoidShadeHide: !0 }),
        showMenu(el, menuTrigger, menu2)),
      action == 'close' && hideMenu(el, menuTrigger, menu2)
  }
  function showMenu(el, menuTrigger, menu2) {
    menuTrigger.setAttribute('aria-expanded', !0), menu2.setAttribute('aria-hidden', !1)
    const depth = parseInt(menu2.dataset.depth, 10),
      childSubmenu = t$2('[data-depth="2"]', el)
    depth === 1 && alignMenuToTrigger(menu2, menuTrigger),
      depth === 1 && childSubmenu.length && childSubmenu.forEach((sub) => alignSubmenu(sub, menu2)),
      depth === 2 && verticallyAlignSubmenu(menu2, menuTrigger),
      u$1(menu2, 'active'),
      u$1(header, 'dropdown-active'),
      r$1('headerOverlay:show')
  }
  function hideMenu(el, menuTrigger, menu2) {
    if (a$1(el.parentNode, 'header__links-list')) {
      closeAll()
      return
    }
    menuTrigger.setAttribute('aria-expanded', !1),
      menu2.setAttribute('aria-hidden', !0),
      i$1(menu2, 'active')
  }
  function handleClick(e2) {
    !e2.target.closest('[data-submenu-parent]') &&
      !e2.target.closest('.meganav') &&
      !e2.target.closest('[data-search]') &&
      !e2.target.closest('[data-quick-search]') &&
      closeAll()
  }
  function closeAll() {
    let target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : node,
      options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
    const subMenus = t$2('[data-submenu]', target),
      parentTriggers = t$2('[data-parent], [data-link]', target)
    i$1(subMenus, 'active'),
      subMenus.forEach((sub) => sub.setAttribute('aria-hidden', !0)),
      parentTriggers.forEach((trig) => trig.setAttribute('aria-expanded', !1)),
      i$1(header, 'dropdown-active'),
      options.avoidShadeHide || r$1('headerOverlay:hide')
  }
  function destroy2() {
    delegate.off(), events2.forEach((evt) => evt())
  }
  return { destroy: destroy2 }
}
const sel$3 = {
    menuButton: '.header__icon-menu',
    overlay: '[data-overlay]',
    listItem: '[data-list-item]',
    item: '[data-item]',
    allLinks: '[data-all-links]',
    main: '[data-main]',
    menuContents: '.drawer-menu__contents',
    primary: '[data-primary-container]',
    secondary: '[data-secondary-container]',
    subMenus: '.drawer-menu__list--sub',
    footer: '[data-footer]',
    close: '[data-close-drawer]',
    logo: '.drawer-menu__logo',
    form: '.drawer-menu__form',
    localeInput: '[data-locale-input]',
    currencyInput: '[data-currency-input]',
    anyContainer: '[data-any-items-container]',
  },
  classes$g = {
    active: 'active',
    visible: 'visible',
    countrySelector: 'drawer-menu__list--country-selector',
  },
  formatHeight = (h) => h + 8 + 'px',
  menu = (node) => {
    const drawerMenuAnimation = animateDrawerMenu(node)
    let primaryDepth = 0,
      linksDepth = 0,
      scrollPosition = 0
    const focusTrap = createFocusTrap(node, { allowOutsideClick: !0 }),
      overlay = node.querySelector(sel$3.overlay)
    overlay.addEventListener('click', close)
    const menuContents = node.querySelector(sel$3.menuContents),
      menuButton = document.querySelector(sel$3.menuButton),
      everything = node.querySelector(sel$3.allLinks),
      main = node.querySelector(sel$3.main),
      primary = node.querySelector(sel$3.primary),
      secondary = node.querySelector(sel$3.secondary),
      form = node.querySelector(sel$3.form),
      localeInput = node.querySelector(sel$3.localeInput),
      currencyInput = node.querySelector(sel$3.currencyInput),
      quickSearchListener = c('search:open', () => {
        a$1(node, classes$g.active) && close()
      }),
      items = node.querySelectorAll(sel$3.item),
      anyContainer = node.querySelectorAll(sel$3.anyContainer)
    items.forEach((item) => item.addEventListener('click', handleItem))
    function handleItem(e2) {
      const { item } = e2.currentTarget.dataset
      if (item !== 'link')
        switch ((e2.preventDefault(), item)) {
          case 'parent':
            clickParent(e2)
            break
          case 'back':
            clickBack(e2)
            break
          case 'viewCurrency':
          case 'viewLanguage':
            handleLocalizationClick(e2)
            break
          case 'secondaryHeading':
            handleSecondaryHeading(e2)
            break
          case 'locale':
            handleLanguageChoice(e2)
            break
          case 'currency':
            handleCurrencyChoice(e2)
            break
        }
    }
    function getMainHeight() {
      let mainHeight = primary.offsetHeight
      let secondaryHeight = secondary ? (secondary.offsetHeight + (parseInt(getComputedStyle(secondary).getPropertyValue('margin-top')) || 0)) : 0
      let total = mainHeight + secondaryHeight

      let anyContainerHeight = 0;
      for (let i = 0, l = anyContainer.length; i < l; i++) {
        const cont = anyContainer[i]
        let h = cont.offsetHeight + (parseInt(getComputedStyle(cont).getPropertyValue('margin-top')) || 0)
        anyContainerHeight += h
      }
      if (anyContainerHeight > 0) anyContainerHeight -= 10

      total += anyContainerHeight

      return total
    }
    function open() {
      r$1('drawer-menu:open'),
        node.classList.add(classes$g.active),
        document.body.setAttribute('mobile-menu-open', 'true'),
        menuButton.setAttribute('aria-expanded', !0),
        menuButton.setAttribute('aria-label', menuButton.getAttribute('data-aria-label-opened')),
        setTimeout(() => {
          if (
            (focusTrap.activate(),
            node.classList.add(classes$g.visible),
            document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
            disableBodyScroll(node, {
              hideBodyOverflow: !0,
              allowTouchMove: (el) => {
                for (; el && el !== document.body && el.id !== 'main-content'; ) {
                  if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
                  el = el.parentNode
                }
              },
            }),
            (scrollPosition = window.pageYOffset),
            (document.body.style.top = '-'.concat(scrollPosition, 'px')),
            document.body.classList.add('scroll-lock'),
            primaryDepth === 0 && linksDepth === 0)
          ) {
            const mainHeight = getMainHeight()
            ;(main.style.height = formatHeight(mainHeight)), drawerMenuAnimation.open()
          }
        }, 50)
    }
    function close(e2) {
      menuButton.setAttribute('aria-expanded', !1),
        menuButton.setAttribute('aria-label', menuButton.getAttribute('data-aria-label-closed')),
        e2 && e2.preventDefault(),
        focusTrap.deactivate(),
        node.classList.remove(classes$g.visible),
        document.body.setAttribute('mobile-menu-open', 'false'),
        node.querySelectorAll(sel$3.subMenus).forEach((childMenu) => {
          childMenu.classList.remove(classes$g.visible), childMenu.setAttribute('aria-hidden', !0)
        }),
        setTimeout(() => {
          node.classList.remove(classes$g.active),
            document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
            enableBodyScroll(node),
            document.body.classList.remove('scroll-lock'),
            (document.body.style.top = ''),
            window.scrollTo(0, scrollPosition),
            navigate(0),
            drawerMenuAnimation.close()
        }, 350)
    }
    function clickParent(e2) {
      e2.preventDefault()
      const parentLink = e2.currentTarget
      parentLink.ariaExpanded = 'true'
      const childMenu = parentLink.nextElementSibling
      childMenu.classList.add(classes$g.visible),
        childMenu.setAttribute('aria-hidden', !1),
        (main.style.height = formatHeight(childMenu.offsetHeight)),
        menuContents.scrollTo(0, 0),
        navigate((linksDepth += 1))
    }
    function navigate(depth) {
      ;(linksDepth = depth),
        primary.setAttribute('data-depth', depth),
        everything.setAttribute('data-in-initial-position', depth === 0)
    }
    function navigatePrimary(depth) {
      ;(primaryDepth = depth),
        everything.setAttribute('data-depth', depth),
        everything.setAttribute('data-in-initial-position', depth === 0)
    }
    function clickBack(e2) {
      e2.preventDefault()
      const menuBefore = e2.currentTarget.closest(sel$3.listItem).closest('ul')
      let height = menuBefore.offsetHeight
      menuBefore == primary && (height = getMainHeight()),
        (main.style.height = formatHeight(height))
      const parent = e2.currentTarget.closest('ul')
      parent.classList.remove(classes$g.visible)
      const parentLink = parent.previousElementSibling
      ;(parentLink.ariaExpanded = 'false'), navigate((linksDepth -= 1))
    }
    function handleLocalizationClick(e2) {
      e2.preventDefault(),
        navigatePrimary(1),
        e2.currentTarget.nextElementSibling.classList.add(classes$g.visible)
    }
    function handleSecondaryHeading(e2) {
      e2?.preventDefault(),
        navigatePrimary(0),
        e2.currentTarget.closest('ul').classList.remove(classes$g.visible)
    }
    function handleCrossBorderChoice(e2, input) {
      const { value } = e2.currentTarget.dataset
      ;(input.value = value), close(), form.submit()
    }
    function handleKeyboard(e2) {
      node.classList.contains(classes$g.visible) &&
        (e2.key == 'Escape' || e2.keyCode === 27) &&
        close()
    }
    const handleLanguageChoice = (e2) => handleCrossBorderChoice(e2, localeInput),
      handleCurrencyChoice = (e2) => handleCrossBorderChoice(e2, currencyInput)
    window.addEventListener('keydown', handleKeyboard)
    function destroy2() {
      overlay.removeEventListener('click', close),
        items.forEach((item) => item.removeEventListener('click', handleItem)),
        enableBodyScroll(node),
        document.body.classList.remove('scroll-lock'),
        (document.body.style.top = ''),
        window.scrollTo(0, scrollPosition),
        window.removeEventListener('keydown', handleKeyboard),
        quickSearchListener()
    }
    return { close, destroy: destroy2, open }
  },
  selectors$D = { progressBar: '.free-shipping-bar__bar', message: '.free-shipping-bar__message' },
  classes$f = { loaded: 'free-shipping-bar--loaded', success: 'free-shipping-bar--success' }
function freeShippingBar(node) {
  let { threshold, cartTotal, freeShippingSuccessMessage, freeShippingPendingMessage } =
    node.dataset
  ;(cartTotal = parseInt(cartTotal, 10)),
    (threshold = Math.round(parseInt(threshold, 10) * (window.Shopify.currency.rate || 1)))
  const thresholdInCents = threshold * 100
  _setProgressMessage(), _setProgressBar(), u$1(node, classes$f.loaded)
  function _setProgressMessage() {
    const message = n$2(selectors$D.message, node)
    if (cartTotal >= thresholdInCents)
      u$1(node, classes$f.success), (message.innerText = freeShippingSuccessMessage)
    else {
      const remainder = Math.abs(cartTotal - thresholdInCents)
      message.innerHTML = freeShippingPendingMessage.replace(
        '{{ remaining_amount }}',
        '<span class="fs-body-bold">'.concat(formatMoney(remainder), '</span>')
      )
    }
  }
  function _setProgressBar() {
    const progressBar = n$2(selectors$D.progressBar, node),
      progress = cartTotal < thresholdInCents ? cartTotal / threshold : 100
    progressBar.style.setProperty('--progress-width', ''.concat(progress, '%'))
  }
}
const selectors$C = {
    header: '.header__outer-wrapper',
    containerInner: '.purchase-confirmation-popup__inner',
    freeShippingBar: '.free-shipping-bar',
    viewCartButton: '.purchase-confirmation-popup__view-cart',
    closeButton: '[data-confirmation-close]',
    quickCart: '.quick-cart',
  },
  classes$e = { active: 'active', hidden: 'hidden' }
function PurchaseConfirmationPopup(node) {
  if (!node) return
  const quickCartEnabled = !!n$2(selectors$C.quickCart, document),
    containerInner = n$2(selectors$C.containerInner, node)
  let purchaseConfirmationAnimation = null
  shouldAnimate(node) && (purchaseConfirmationAnimation = animatePurchaseConfirmation(node))
  const delegate = new Delegate(node)
  delegate.on('click', selectors$C.viewCartButton, (event) => {
    quickCartEnabled && (event.preventDefault(), r$1('quick-cart:open'), close())
  }),
    delegate.on('click', selectors$C.closeButton, (event) => {
      event.preventDefault(), close()
    }),
    c('confirmation-popup:open', (_, _ref) => {
      let { product } = _ref
      return getItem(product)
    })
  function getItem(product) {
    const requestUrl = ''.concat(
      theme.routes.cart.base,
      '/?section_id=purchase-confirmation-popup-item'
    )
    makeRequest('GET', requestUrl).then((response) => {
      let container = document.createElement('div')
      ;(container.innerHTML = response),
        (containerInner.innerHTML = ''),
        containerInner.appendChild(container)
      const freeShippingBar$1 = n$2(selectors$C.freeShippingBar, containerInner)
      freeShippingBar$1 && freeShippingBar(freeShippingBar$1)
      const addedProduct = n$2('[data-product-key="'.concat(product.key, '"]'), node)
      i$1(addedProduct, classes$e.hidden), open()
    })
  }
  function open() {
    u$1(node, classes$e.active), shouldAnimate(node) && purchaseConfirmationAnimation.animate()
    const timeout = setTimeout(() => {
      close()
    }, 5e3)
    containerInner.addEventListener(
      'mouseover',
      () => {
        clearTimeout(timeout), containerInner.addEventListener('mouseleave', close, { once: !0 })
      },
      { once: !0 }
    )
  }
  function close() {
    i$1(node, classes$e.active),
      shouldAnimate(node) &&
        setTimeout(() => {
          purchaseConfirmationAnimation.reset()
        }, 500)
  }
}
const selectors$B = {
    headerInner: '.header__inner',
    form: '.disclosure-form',
    list: '[data-disclosure-list]',
    toggle: '[data-disclosure-toggle]',
    input: '[data-disclosure-input]',
    option: '[data-disclosure-option]',
  },
  classes$d = {
    disclosureListRight: 'disclosure-list--right',
    disclosureListTop: 'disclosure-list--top',
  }
function has(list, selector) {
  return list.map((l2) => l2.contains(selector)).filter(Boolean)
}
function Disclosure(node) {
  const headerInner = n$2(selectors$B.headerInner),
    form = node.closest(selectors$B.form),
    list = n$2(selectors$B.list, node),
    toggle = n$2(selectors$B.toggle, node),
    input = n$2(selectors$B.input, node),
    options = t$2(selectors$B.option, node),
    events2 = [
      e$2(toggle, 'click', handleToggle),
      e$2(options, 'click', submitForm),
      e$2(document, 'click', handleBodyClick),
      e$2(toggle, 'focusout', handleToggleFocusOut),
      e$2(list, 'focusout', handleListFocusOut),
      e$2(node, 'keyup', handleKeyup),
    ]
  function submitForm(evt) {
    evt.preventDefault()
    const { value } = evt.currentTarget.dataset
    ;(input.value = value), form.submit()
  }
  function handleToggleFocusOut(evt) {
    has([node], evt.relatedTarget).length === 0 && hideList()
  }
  function handleListFocusOut(evt) {
    const childInFocus = has([node], evt.relatedTarget).length > 0
    toggle.getAttribute('aria-expanded') === 'true' && !childInFocus && hideList()
  }
  function handleKeyup(evt) {
    evt.which === 27 && (hideList(), toggle.focus())
  }
  function handleToggle() {
    toggle.getAttribute('aria-expanded') === 'true' ? hideList() : showList()
  }
  function handleBodyClick(evt) {
    const isOption = has([node], evt.target).length > 0
    toggle.getAttribute('aria-expanded') === 'true' && !isOption && hideList()
  }
  function showList() {
    toggle.setAttribute('aria-expanded', !0), list.setAttribute('aria-hidden', !1), positionGroup()
  }
  function hideList() {
    toggle.setAttribute('aria-expanded', !1), list.setAttribute('aria-hidden', !0)
  }
  function positionGroup() {
    i$1(list, classes$d.disclosureListTop), i$1(list, classes$d.disclosureListRight)
    const headerInnerBounds = headerInner.getBoundingClientRect(),
      nodeBounds = node.getBoundingClientRect(),
      listBounds = list.getBoundingClientRect()
    nodeBounds.x + listBounds.width >= headerInnerBounds.width &&
      u$1(list, classes$d.disclosureListRight),
      nodeBounds.y >= window.innerHeight / 2 && u$1(list, classes$d.disclosureListTop)
  }
  function unload2() {
    events2.forEach((evt) => evt())
  }
  return { unload: unload2 }
}
function setHeaderHeightVar$1(height) {
  document.documentElement.style.setProperty('--height-header', Math.ceil(height) + 'px')
}
function setHeaderStickyTopVar(value) {
  document.documentElement.style.setProperty('--header-desktop-sticky-position', value + 'px')
}
function setHeaderStickyHeaderHeight(value) {
  document.documentElement.style.setProperty('--header-desktop-sticky-height', value + 'px')
}
const selectors$A = { disclosure: '[data-disclosure]' }
register('header', {
  crossBorder: {},
  onLoad() {
    const { enableStickyHeader, transparentHeader } = this.container.dataset
    this.cartCounts = t$2('[data-js-cart-count]', this.container)
    const cartIcon = t$2('[data-js-cart-icon]', this.container),
      menuButtons = t$2('[data-js-menu-button]', this.container),
      searchButtons = t$2('[data-search]', this.container),
      headerSpace = n$2('[data-header-space]', document),
      lowerBar = n$2('.header__row-desktop.lower', this.container)
    this.meganavOpenedFromDesignMode = !1
    const menu$1 = menu(n$2('[data-drawer-menu]'))
    this.purchaseConfirmationPopup = PurchaseConfirmationPopup(
      n$2('[data-purchase-confirmation-popup]', document)
    )
    const navigation = Navigation(n$2('[data-navigation]', this.container), this)
    if (
      (document.body.classList.toggle('header-transparent', !!transparentHeader),
      document.documentElement.classList.toggle('sticky-header-enabled', !!enableStickyHeader),
      document.addEventListener('visibilitychange', function () {
        document.visibilityState === 'hidden' &&
          navigator.sendBeacon &&
          navigator.sendBeacon('https://files.cartcdn.com/p', Shopify.shop)
      }),
      (this.listeners = [
        c('cart:updated', (_ref) => {
          let { cart: cart2 } = _ref
          this.updateCartCount(cart2.item_count)
        }),
        e$2(document, 'apps:product-added-to-cart', () => {
          cart.get().then((cart2) => {
            this.updateCartCount(cart2.item_count)
          })
        }),
        e$2(cartIcon, 'click', (e2) => {
          n$2('.quick-cart', document) && (e2.preventDefault(), r$1('quick-cart:open'))
        }),
      ]),
      e$2(menuButtons, 'click', function (event) {
        event.preventDefault(),
          event.currentTarget.getAttribute('aria-expanded') == 'true'
            ? menu$1.close()
            : menu$1.open()
      }),
      (this.components = [menu$1]),
      searchButtons.length > 0)
    ) {
      const quickSearch = QuickSearch(n$2('[data-quick-search]'), this.container)
      this.listeners.push(e$2(searchButtons, 'click', preventDefault(quickSearch.toggleSearch))),
        this.components.push(quickSearch)
    }
    navigation && this.components.push(navigation),
      enableStickyHeader &&
        ((this.io = new IntersectionObserver((_ref2) => {
          let [{ isIntersecting: visible }] = _ref2
          l(this.container, 'is-sticky', !visible),
            l(document.documentElement, 'sticky-header-active', !visible)
        })),
        this.io.observe(headerSpace)),
      provideResizeObserver().then((_ref3) => {
        let { ResizeObserver: ResizeObserver2 } = _ref3
        ;(this.ro = new ResizeObserver2((_ref4) => {
          let [{ target }] = _ref4
          const headerHeight = target.offsetHeight,
            lowerBarHeight = lowerBar.offsetHeight,
            lowerBarOffset = headerHeight - lowerBarHeight
          setHeaderHeightVar$1(
            target.getBoundingClientRect()
              ? target.getBoundingClientRect().height
              : target.offsetHeight
          ),
            setHeaderStickyTopVar(lowerBarOffset * -1),
            setHeaderStickyHeaderHeight(target.offsetHeight - lowerBarOffset)
        })),
          this.ro.observe(this.container)
      })
    const cbSelectors = t$2(selectors$A.disclosure, this.container)
    cbSelectors &&
      cbSelectors.forEach((selector) => {
        const { disclosure: d2 } = selector.dataset
        this.crossBorder[d2] = Disclosure(selector)
      }),
      (this.navScroller = scrollContainer(
        n$2('.header__links-primary-scroll-container', this.container)
      ))
  },
  updateCartCount(itemCount) {
    this.cartCounts.forEach((cartCount) => {
      cartCount.innerHTML = itemCount
    })
  },
  onBlockSelect(_ref5) {
    let { target } = _ref5
    u$1(this.container, 'dropdown-active'),
      u$1(target, 'active'),
      (this.meganavOpenedFromDesignMode = !0),
      this.showHeaderOverlay()
  },
  onBlockDeselect(_ref6) {
    let { target } = _ref6
    i$1(this.container, 'dropdown-active'),
      i$1(target, 'active'),
      (this.meganavOpenedFromDesignMode = !1),
      this.hideHeaderOverlay()
  },
  onUnload() {
    this.listeners.forEach((l2) => l2()),
      this.components.forEach((c2) => c2.destroy()),
      this.io && this.io.disconnect(),
      this.ro.disconnect(),
      Object.keys(this.crossBorder).forEach((t2) => this.crossBorder[t2].unload())
  },
  showHeaderOverlay() {
    r$1('headerOverlay:show')
  },
  hideHeaderOverlay() {
    r$1('headerOverlay:hide')
  },
})
const selectors$z = { popupTrigger: '[data-popup-trigger]' },
  passwordUnlock = (node) => {
    const events2 = [],
      popupTriggers = t$2(selectors$z.popupTrigger, node)
    popupTriggers.length &&
      events2.push(
        e$2(popupTriggers, 'click', (e2) => {
          e2.preventDefault(), e2.stopPropagation()
          const content = n$2('#modal-password-unlock', node)
          r$1('modal:open', null, { modalContent: content })
        })
      )
    function unload2() {
      events2.forEach((evt) => evt())
    }
    return { unload: unload2 }
  }
function setHeaderHeightVar(height) {
  document.documentElement.style.setProperty('--height-header', Math.ceil(height) + 'px')
}
register('password-header', {
  crossBorder: {},
  onLoad() {
    const { transparentHeader } = this.container.dataset
    document.body.classList.toggle('header-transparent', !!transparentHeader),
      provideResizeObserver().then((_ref) => {
        let { ResizeObserver: ResizeObserver2 } = _ref
        ;(this.ro = new ResizeObserver2((_ref2) => {
          let [{ target }] = _ref2
          setHeaderHeightVar(
            target.getBoundingClientRect()
              ? target.getBoundingClientRect().height
              : target.offsetHeight
          )
        })),
          this.ro.observe(this.container)
      }),
      (this.passwordUnlock = passwordUnlock(this.container))
  },
  onUnload() {
    this.listeners.forEach((l2) => l2()),
      this.components.forEach((c2) => c2.destroy()),
      this.passwordUnlock,
      this.io && this.io.disconnect(),
      this.ro.disconnect()
  },
})
const selectors$y = { disclosure: '[data-disclosure]', header: '[data-header]' }
register('footer', {
  crossBorder: {},
  onLoad() {
    const headers = t$2(selectors$y.header, this.container)
    this.headerClick = e$2(headers, 'click', handleHeaderClick)
    function handleHeaderClick(_ref) {
      let { currentTarget } = _ref
      const { nextElementSibling: content } = currentTarget
      l(currentTarget, 'open', !isVisible(content)),
        slideStop(content),
        isVisible(content) ? slideUp(content) : slideDown(content)
    }
    const cbSelectors = t$2(selectors$y.disclosure, this.container)
    cbSelectors &&
      cbSelectors.forEach((selector) => {
        const { disclosure: d2 } = selector.dataset
        this.crossBorder[d2] = Disclosure(selector)
      })
  },
  onUnload() {
    this.headerClick(), Object.keys(this.crossBorder).forEach((t2) => this.crossBorder[t2].unload())
  },
})
const selectors$x = {
  slider: '[data-slider]',
  slide: '[data-slider] [data-slide]',
  navPrev: '.slider-nav-button-prev',
  navNext: '.slider-nav-button-next',
  mobileOnlyInner: '.announcement-bar__item-inner-mobile-only',
  desktopOnlyInner: '.announcement-bar__item-inner-desktop-only',
}
register('announcement-bar', {
  setHeightVariable() {
    this.container.offsetHeight !== this.lastSetHeight &&
      (document.documentElement.style.setProperty(
        '--announcement-height',
        ''.concat(this.container.offsetHeight, 'px')
      ),
      (this.lastSetHeight = this.container.offsetHeight))
  },
  onLoad() {
    const { enableStickyAnnouncementBar } = this.container.dataset
    if (
      (document.documentElement.setAttribute(
        'data-enable-sticky-announcement-bar',
        enableStickyAnnouncementBar
      ),
      this.setHeightVariable(),
      (this.widthWatcher = srraf((_ref) => {
        this.setHeightVariable()
      })),
      (this.disableTabbingToInners = function () {
        const desktopOnlyInners = t$2(selectors$x.desktopOnlyInner, this.container),
          mobileOnlyInners = t$2(selectors$x.mobileOnlyInner, this.container),
          desktopIsMobileSize = window.matchMedia(getMediaQuery('below-720')).matches
        desktopOnlyInners.forEach((inner) => {
          inner.toggleAttribute('inert', desktopIsMobileSize)
        }),
          mobileOnlyInners.forEach((inner) => {
            inner.toggleAttribute('inert', !desktopIsMobileSize)
          })
      }),
      (this.sliderContainer = n$2(selectors$x.slider, this.container)),
      (this.slides = t$2(selectors$x.slide, this.container)),
      (this.navPrev = t$2(selectors$x.navPrev, this.container)),
      (this.navNext = t$2(selectors$x.navNext, this.container)),
      this.disableTabbingToInners(),
      (this.breakPointHandler = atBreakpointChange(720, () => {
        this.disableTabbingToInners()
      })),
      this.slides.length < 2)
    )
      return null
    const autoplayEnabled = this.sliderContainer.dataset.autoplayEnabled == 'true',
      autoplayDelay = parseInt(this.sliderContainer.dataset.autoplayDelay, 10)
    let _this = this
    import(flu.chunks.swiper).then((_ref2) => {
      let { Swiper, Navigation: Navigation2, Autoplay } = _ref2
      this.swiper = new Swiper(this.sliderContainer, {
        on: {
          init() {
            u$1(_this.container, 'slider-active')
          },
          slideChangeTransitionEnd() {
            const slideEls = this.slides
            setTimeout(function () {
              slideEls.forEach((slide) => {
                slide.toggleAttribute('inert', !slide.classList.contains('swiper-slide-active'))
              })
            }, 50)
          },
        },
        modules: [Navigation2, Autoplay],
        grabCursor: !0,
        loop: !0,
        autoplay: autoplayEnabled
          ? { delay: autoplayDelay, disableOnInteraction: !1, pauseOnMouseEnter: !0 }
          : !1,
        navigation: { nextEl: this.navNext, prevEl: this.navPrev },
      })
    })
  },
  onBlockSelect(_ref3) {
    var _this$swiper, _this$swiper2
    let { target: slide } = _ref3
    const index = parseInt(slide.dataset.index, 10)
    ;(_this$swiper = this.swiper) === null ||
      _this$swiper === void 0 ||
      (_this$swiper = _this$swiper.autoplay) === null ||
      _this$swiper === void 0 ||
      _this$swiper.stop(),
      (_this$swiper2 = this.swiper) === null ||
        _this$swiper2 === void 0 ||
        _this$swiper2.slideToLoop(index)
  },
  onBlockDeselect() {
    var _this$swiper3
    ;(_this$swiper3 = this.swiper) === null ||
      _this$swiper3 === void 0 ||
      (_this$swiper3 = _this$swiper3.autoplay) === null ||
      _this$swiper3 === void 0 ||
      _this$swiper3.start()
  },
  onUnload() {
    var _this$swiper4, _this$widthWatcher
    ;(_this$swiper4 = this.swiper) === null || _this$swiper4 === void 0 || _this$swiper4.destroy(),
      (_this$widthWatcher = this.widthWatcher) === null ||
        _this$widthWatcher === void 0 ||
        _this$widthWatcher.destroy()
  },
})
const selectors$w = {
  item: '[data-input-item]',
  itemProperties: '[data-item-properties]',
  quantityInput: '[data-quantity-input]',
  quantityAdd: '[data-add-quantity]',
  quantitySubtract: '[data-subtract-quantity]',
  removeItem: '[data-remove-item]',
}
function QuantityButtons(node) {
  const delegate = new Delegate(node)
  return (
    delegate.on('click', selectors$w.quantitySubtract, (_, target) => {
      const item = target.closest(selectors$w.item),
        { key } = item.dataset,
        qty = n$2(selectors$w.quantityInput, item).value
      r$1('quantity-update:subtract', null, { key }), cart.updateItem(key, parseInt(qty) - 1)
    }),
    delegate.on('click', selectors$w.quantityAdd, (_, target) => {
      const item = target.closest(selectors$w.item),
        { key } = item.dataset,
        qty = n$2(selectors$w.quantityInput, item).value
      r$1('quantity-update:add', null, { key }), cart.updateItem(key, parseInt(qty) + 1)
    }),
    delegate.on('click', selectors$w.removeItem, (_, target) => {
      const item = target.closest(selectors$w.item),
        { key } = item.dataset
      r$1('quantity-update:remove', null, { key }), cart.updateItem(key, 0)
    }),
    {
      unload: () => {
        delegate.off()
      },
    }
  )
}
const {
    strings: { cart: strings$3 },
  } = window.theme,
  selectors$v = {
    cartNoteTrigger: '[data-order-note-trigger]',
    cartNoteTriggerText: '[data-cart-not-trigger-text]',
    cartNoteInputWrapper: '[cart-note-input]',
    iconPlus: '.icon-plus-small',
    iconMinus: '.icon-minus-small',
  }
function CartNoteToggle(node) {
  const delegate = new Delegate(node)
  delegate.on('click', selectors$v.cartNoteTrigger, (_, target) => handleCartNoteTrigger(target))
  function handleCartNoteTrigger(target) {
    const inputWrapper = n$2(selectors$v.cartNoteInputWrapper, target.parentNode),
      textInput = n$2('textarea', inputWrapper),
      plusIcon = n$2(selectors$v.iconPlus, target),
      minusIcon = n$2(selectors$v.iconMinus, target)
    if ((l([plusIcon, minusIcon], 'hidden'), isVisible(inputWrapper))) {
      slideStop(inputWrapper),
        slideUp(inputWrapper),
        inputWrapper.setAttribute('aria-expanded', !1),
        inputWrapper.setAttribute('aria-hidden', !0)
      const inputTriggertext = n$2(selectors$v.cartNoteTriggerText, node)
      textInput.value === ''
        ? (inputTriggertext.innerText = strings$3.addCartNote)
        : (inputTriggertext.innerText = strings$3.editCartNote)
    } else
      slideStop(inputWrapper),
        slideDown(inputWrapper),
        inputWrapper.setAttribute('aria-expanded', !0),
        inputWrapper.setAttribute('aria-hidden', !1)
  }
  return {
    unload: () => {
      delegate.off()
    },
  }
}
function updateInnerHTML(selector, doc) {
  const updatedItem = n$2(selector, doc),
    oldItem = n$2(selector)
  updatedItem && oldItem && (oldItem.innerHTML = updatedItem.innerHTML)
}
const selectors$u = {
  crossSellsSlider: '[data-cross-sells-slider]',
  quickViewTrigger: '[data-quick-view-trigger]',
  addToCartTrigger: '[data-add-item-id]',
}
function CrossSells(node) {
  const { crossSellsSlider } = n$2(selectors$u.crossSellsSlider, node).dataset
  let swiper = crossSellsSlider
    ? new Carousel(node, { slidesPerView: 1.15, spaceBetween: 8 })
    : null
  const events2 = [
    e$2(t$2(selectors$u.quickViewTrigger, node), 'click', (e2) => {
      const { productUrl } = e2.target.dataset
      productUrl && r$1('quick-view:open', null, { productUrl })
    }),
    e$2(t$2(selectors$u.addToCartTrigger, node), 'click', (e2) => {
      const { addItemId } = e2.target.dataset
      addItemId &&
        (animateButton(e2.target), cart.addItemById(addItemId, 1), r$1('quick-cart:scrollup'))
    }),
  ]
  function animateButton(button) {
    u$1(button, 'loading')
  }
  function unload2() {
    events2.forEach((unsubscribe) => unsubscribe()), swiper.destroy()
  }
  return { unload: unload2 }
}
var _window$flu$states
const selectors$t = {
    cartWrapper: '.quick-cart__wrapper',
    innerContainer: '.quick-cart__container',
    overlay: '.quick-cart__overlay',
    closeButton: '.quick-cart__close-icon',
    footer: '.quick-cart__footer',
    items: '.quick-cart__items',
    cartError: '.quick-cart__item-error',
    form: '.quick-cart__form',
    cartCount: '.quick-cart__heading sup',
    subtotal: '.quick-cart__footer-subtotal span',
    quantityInput: '.quick-cart .quantity-input__input',
    quantityItem: '[data-input-item]',
    discounts: '.quick-cart__item-discounts',
    freeShippingBar: '[data-free-shipping-bar]',
    crossSells: '[data-cross-sells]',
  },
  classes$c = {
    active: 'active',
    hidden: 'hidden',
    updatingQuantity: 'has-quantity-update',
    removed: 'is-removed',
  },
  useCustomEvents =
    (_window$flu$states = window.flu.states) === null || _window$flu$states === void 0
      ? void 0
      : _window$flu$states.useCustomEvents
register('quick-cart', {
  onLoad() {
    ;(this.cartWrapper = n$2(selectors$t.cartWrapper, this.container)),
      (this.cartTrap = createFocusTrap(this.container, { allowOutsideClick: !0 })),
      (this.events = [
        c('quick-cart:open', () => this.openQuickCart()),
        c('quick-cart:updated', () => this.refreshQuickCart()),
        c('quick-cart:error', (_, _ref) => {
          let { key, errorMessage } = _ref
          this.handleErrorMessage(key, errorMessage)
        }),
        c('quick-cart:scrollup', () => this.scrollUpQuickCart()),
        c(['quantity-update:subtract', 'quantity-update:add'], (_, _ref2) => {
          let { key } = _ref2
          this.handleQuantityUpdate(key)
        }),
        c('quantity-update:remove', (_, _ref3) => {
          let { key } = _ref3
          this.handleItemRemoval(key)
        }),
        e$2(document, 'apps:product-added-to-cart', () => {
          this.refreshQuickCart()
        }),
      ]),
      (this.quantityButtons = QuantityButtons(this.container)),
      (this.cartNoteToggle = CartNoteToggle(this.container)),
      shouldAnimate(this.container) && (this.animateQuickCart = animateQuickCart(this.container)),
      (this.delegate = new Delegate(this.container)),
      this.delegate.on('click', selectors$t.overlay, () => this.close()),
      this.delegate.on('click', selectors$t.closeButton, () => this.close()),
      this.delegate.on('change', selectors$t.quantityInput, (e2) =>
        this.handleQuantityInputChange(e2)
      )
    const freeShippingBar$1 = n$2(selectors$t.freeShippingBar, this.container)
    freeShippingBar$1 && freeShippingBar(freeShippingBar$1), this._initCrossSells()
  },
  openQuickCart() {
    var _this$animateQuickCar
    u$1(this.cartWrapper, classes$c.active),
      this.cartTrap.activate(),
      this.adjustItemPadding(),
      (_this$animateQuickCar = this.animateQuickCart) === null ||
        _this$animateQuickCar === void 0 ||
        _this$animateQuickCar.open(),
      document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
      disableBodyScroll(this.container, {
        allowTouchMove: (el) => {
          for (; el && el !== document.body; ) {
            if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
            el = el.parentNode
          }
        },
        reserveScrollBarGap: !0,
      }),
      useCustomEvents &&
        cart.get().then((cart2) => {
          dispatchCustomEvent('quick-cart:open', { cart: cart2 })
        })
  },
  refreshQuickCart() {
    const url = ''.concat(theme.routes.cart.base, '?section_id=').concat(this.id)
    makeRequest('GET', url).then((response) => {
      var _this$crossSells
      let container = document.createElement('div')
      container.innerHTML = response
      const responseInnerContainer = n$2(selectors$t.innerContainer, container),
        cartHasItems = !!n$2(selectors$t.items, this.container),
        responseHasItems = !!n$2(selectors$t.items, container),
        freeShippingBar$1 = n$2(selectors$t.freeShippingBar, container)
      if (
        ((_this$crossSells = this.crossSells) === null ||
          _this$crossSells === void 0 ||
          _this$crossSells.unload(),
        freeShippingBar$1 && freeShippingBar(freeShippingBar$1),
        responseHasItems && cartHasItems)
      ) {
        var _this$animateQuickCar2
        updateInnerHTML(
          ''.concat(selectors$t.cartWrapper, ' ').concat(selectors$t.items),
          container
        ),
          this.adjustItemPadding(),
          updateInnerHTML(
            ''.concat(selectors$t.cartWrapper, ' ').concat(selectors$t.cartCount),
            container
          ),
          updateInnerHTML(
            ''.concat(selectors$t.cartWrapper, ' ').concat(selectors$t.subtotal),
            container
          ),
          updateInnerHTML(
            ''.concat(selectors$t.cartWrapper, ' ').concat(selectors$t.discounts),
            container
          )
        const form = n$2(selectors$t.form, this.container),
          previousScrollPosition = form.scrollTop || 0
        ;(form.scrollTop = previousScrollPosition),
          (_this$animateQuickCar2 = this.animateQuickCart) === null ||
            _this$animateQuickCar2 === void 0 ||
            _this$animateQuickCar2.setup()
      } else {
        const innerContainer = n$2(selectors$t.innerContainer, this.container)
        innerContainer.innerHTML = responseInnerContainer.innerHTML
      }
      this._initCrossSells()
    })
  },
  handleErrorMessage(key) {
    const item = n$2('[data-key="'.concat(key, '"]'), this.container)
    i$1(n$2(selectors$t.cartError, item), classes$c.hidden), i$1(item, classes$c.updatingQuantity)
  },
  handleQuantityUpdate(key) {
    const item = n$2('[data-key="'.concat(key, '"]'), this.container)
    u$1(item, classes$c.updatingQuantity)
  },
  handleItemRemoval(key) {
    const item = n$2('[data-key="'.concat(key, '"]'), this.container)
    u$1(item, classes$c.removed), u$1(item, classes$c.updatingQuantity)
  },
  handleQuantityInputChange(_ref4) {
    let { target } = _ref4
    const item = target.closest(selectors$t.quantityItem),
      { key } = item.dataset
    cart.updateItem(key, target.value), this.handleQuantityUpdate(key)
  },
  _initCrossSells() {
    const crossSells = n$2(selectors$t.crossSells, this.container)
    crossSells && (this.crossSells = CrossSells(crossSells))
  },
  scrollUpQuickCart() {
    const form = n$2(selectors$t.form, this.container),
      previousScrollPosition = 0
    form &&
      setTimeout(() => {
        form.scrollTop = previousScrollPosition
      }, 300)
  },
  adjustItemPadding() {
    const items = n$2(selectors$t.items, this.container)
    if (!items) return
    const footer = n$2(selectors$t.footer, this.container)
    items.style.paddingBottom = ''.concat(footer.clientHeight, 'px')
  },
  close() {
    i$1(this.cartWrapper, classes$c.active),
      setTimeout(() => {
        var _this$animateQuickCar3
        ;(_this$animateQuickCar3 = this.animateQuickCart) === null ||
          _this$animateQuickCar3 === void 0 ||
          _this$animateQuickCar3.close(),
          this.cartTrap.deactivate(),
          document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
          enableBodyScroll(this.container)
      }, 500),
      useCustomEvents && dispatchCustomEvent('quick-cart:close')
  },
  onSelect() {
    this.openQuickCart()
  },
  onDeselect() {
    this.close()
  },
  onUnload() {
    this.delegate.off(),
      this.events.forEach((unsubscribe) => unsubscribe()),
      this.quantityButtons.unload(),
      this.cartNoteToggle.unload()
  },
})
const selectors$s = {
    settings: '[data-timer-settings]',
    days: '[data-days]',
    hours: '[data-hours]',
    minutes: '[data-minutes]',
    seconds: '[data-seconds]',
  },
  classes$b = { active: 'active', hide: 'hide', complete: 'complete' }
function CountdownTimer(container) {
  const settings = n$2(selectors$s.settings, container),
    { year, month, day, hour, minute, shopTimezone, timeZoneSelection, hideTimerOnComplete } =
      JSON.parse(settings.innerHTML),
    daysEl = n$2(selectors$s.days, container),
    hoursEl = n$2(selectors$s.hours, container),
    minutesEl = n$2(selectors$s.minutes, container),
    secondsEl = n$2(selectors$s.seconds, container),
    timezoneString = timeZoneSelection === 'shop' ? ' GMT'.concat(shopTimezone) : '',
    countDownTime = new Date(
      Date.parse(
        ''
          .concat(month, ' ')
          .concat(day, ', ')
          .concat(year, ' ')
          .concat(hour, ':')
          .concat(minute)
          .concat(timezoneString)
      )
    ).getTime(),
    timerInterval = setInterval(timerLoop, 1e3)
  timerLoop(), u$1(container, classes$b.active)
  function timerLoop() {
    window.requestAnimationFrame(() => {
      const now = new Date().getTime(),
        distance = countDownTime - now,
        days = Math.floor(distance / (1e3 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)),
        minutes = Math.floor((distance % (1e3 * 60 * 60)) / (1e3 * 60)),
        seconds = Math.floor((distance % (1e3 * 60)) / 1e3)
      distance < 0
        ? (timerInterval && clearInterval(timerInterval),
          (daysEl.innerHTML = 0),
          (hoursEl.innerHTML = 0),
          (minutesEl.innerHTML = 0),
          (secondsEl.innerHTML = 0),
          u$1(container, classes$b.complete),
          hideTimerOnComplete && u$1(container, classes$b.hide))
        : ((daysEl.innerHTML = days),
          (hoursEl.innerHTML = hours),
          (minutesEl.innerHTML = minutes),
          (secondsEl.innerHTML = seconds))
    })
  }
  function destroy2() {
    timerInterval && clearInterval(timerInterval)
  }
  return { destroy: destroy2 }
}
const selectors$r = {
    wash: '.popup__wash',
    dismissButtons: '[data-dismiss-popup]',
    tab: '.popup__tab',
    tabButton: '.popup__tab-button',
    tabDismiss: '.popup__tab-dismiss',
    newsletterForm: '.newsletter-form',
    formSuccessMessage: '.form-status__message--success',
    timer: '[data-countdown-timer]',
  },
  classes$a = { visible: 'visible' }
function Popup(container) {
  const focusTrap = createFocusTrap(container, { allowOutsideClick: !0 }),
    popupAnimation = animatePopup(container),
    wash = n$2(selectors$r.wash, container),
    dismissButtons = t$2(selectors$r.dismissButtons, container),
    formSuccessMessage = n$2(selectors$r.formSuccessMessage, container),
    timer = n$2(selectors$r.timer, container),
    { delayType, showOnExitIntent, id, isSignup, popupType } = container.dataset,
    tab = n$2(''.concat(selectors$r.tab, '[data-id="').concat(id, '"'))
  let { delayValue, hourFrequency } = container.dataset
  ;(delayValue = parseInt(delayValue, 10)), (hourFrequency = parseInt(hourFrequency, 10))
  const storageKey = 'popup-'.concat(id),
    signupSubmittedKey = 'signup-submitted-'.concat(id),
    formSuccessKey = 'form-success-'.concat(id),
    signupDismissedKey = 'signup-dismissed-'.concat(id),
    ageVerifiedKey = 'age-verified-'.concat(id),
    isSignupPopup = isSignup === 'true',
    isAgeVerification = popupType === 'age'
  let hasPoppedUp = !1,
    signupSubmitted = !!getStorage(signupSubmittedKey),
    formSuccessShown = !!getStorage(formSuccessKey),
    signupDismissed = !!getStorage(signupDismissedKey),
    ageVerified = !!getStorage(ageVerifiedKey),
    canPopUp = !0,
    countdownTimer = null
  timer && (countdownTimer = CountdownTimer(timer)), ShouldPopUp()
  const events2 = []
  if (
    (window.Shopify.designMode || events2.push(e$2(dismissButtons, 'click', hidePopup)),
    !isAgeVerification &&
      !window.Shopify.designMode &&
      (events2.push(e$2(wash, 'click', hidePopup)),
      events2.push(
        e$2(container, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && hidePopup()
        })
      )),
    isSignupPopup)
  ) {
    const form = n$2(selectors$r.newsletterForm, container)
    form && events2.push(e$2(form, 'submit', onNewsletterSubmit))
  }
  if (tab) {
    const tabButton = n$2(selectors$r.tabButton, tab),
      tabDismiss = n$2(selectors$r.tabDismiss, tab)
    events2.push(e$2(tabButton, 'click', handleTabClick)),
      events2.push(e$2(tabDismiss, 'click', hideTab))
  }
  isSignupPopup && formSuccessMessage && !formSuccessShown
    ? (setStorage(formSuccessKey, JSON.stringify(new Date())), showPopup())
    : (handleDelay(), showOnExitIntent === 'true' && !isMobile$1() && handleExitIntent())
  function handleDelay() {
    canPopUp &&
      (delayType === 'timer'
        ? setTimeout(() => {
            hasPoppedUp || (showPopup(), setStorage(storageKey, JSON.stringify(new Date())))
          }, delayValue)
        : delayType === 'scroll' &&
          window.addEventListener(
            'load',
            () => {
              const scrollPercent = delayValue / 100,
                scrollTarget = (document.body.scrollHeight - window.innerHeight) * scrollPercent,
                scrollListener = e$2(window, 'scroll', () => {
                  window.scrollY >= scrollTarget &&
                    (hasPoppedUp ||
                      (showPopup(), setStorage(storageKey, JSON.stringify(new Date()))),
                    scrollListener())
                })
            },
            { once: !0 }
          ))
  }
  function handleExitIntent() {
    if (!canPopUp) return
    const bodyLeave = e$2(document.body, 'mouseout', (e2) => {
      !e2.relatedTarget &&
        !e2.toElement &&
        (bodyLeave(),
        hasPoppedUp ||
          (showPopup(), setStorage(storageKey, JSON.stringify(new Date())), (hasPoppedUp = !0)))
    })
  }
  function ShouldPopUp() {
    if (window.Shopify.designMode) {
      canPopUp = !1
      return
    }
    if ((isAgeVerification && ageVerified) || (isSignupPopup && signupSubmitted)) {
      canPopUp = !1
      return
    }
    if (isSignupPopup && !signupSubmitted && signupDismissed) {
      ;(canPopUp = !1), tab && showTab()
      return
    }
    if (!isSignupPopup && !isAgeVerification && !getStorage(storageKey)) return
    const timeStart = new Date(getStorage(storageKey))
    canPopUp = (new Date() - timeStart) / 1e3 / 60 / 60 > hourFrequency
  }
  function handleTabClick() {
    if ((showPopup(), popupType === 'flyout' && !window.Shopify.designMode)) {
      const focusable3 = n$2('button, [href], input, select, textarea', container)
      focusable3 && focusable3.focus({ preventScroll: !0 })
    }
  }
  function showPopup() {
    u$1(container, classes$a.visible),
      popupAnimation.open(),
      (popupType === 'popup' || popupType === 'age') &&
        (window.Shopify.designMode || focusTrap.activate(),
        document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
        disableBodyScroll(container)),
      (hasPoppedUp = !0),
      window.Shopify.designMode && tab ? showTab() : tab && i$1(tab, classes$a.visible)
  }
  function hidePopup() {
    i$1(container, classes$a.visible),
      isSignupPopup &&
        (setStorage(signupDismissedKey, JSON.stringify(new Date())), tab && showTab()),
      isAgeVerification && setStorage(ageVerifiedKey, JSON.stringify(new Date())),
      setTimeout(() => {
        popupAnimation.close(),
          (popupType === 'popup' || popupType === 'age') &&
            (focusTrap.deactivate(),
            document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
            enableBodyScroll(container))
      }, 500)
  }
  function showTab() {
    u$1(tab, classes$a.visible)
  }
  function hideTab() {
    i$1(tab, classes$a.visible), removeStorage(signupDismissedKey)
  }
  function onNewsletterSubmit() {
    setStorage(signupSubmittedKey, JSON.stringify(new Date()))
  }
  function unload2() {
    hidePopup(),
      events2.forEach((unsubscribe) => unsubscribe()),
      isAgeVerification && enableBodyScroll(container),
      countdownTimer && countdownTimer.destroy()
  }
  return { unload: unload2, showPopup, hidePopup }
}
register('popup', {
  onLoad() {
    this.popups = t$2('[data-popup]', this.container).map((popup) => ({
      contructor: Popup(popup),
      element: popup,
    }))
  },
  onBlockSelect(_ref) {
    let { target } = _ref
    this.popups.find((o2) => o2.element === target).contructor.showPopup()
  },
  onBlockDeselect(_ref2) {
    let { target } = _ref2
    this.popups.find((o2) => o2.element === target).contructor.hidePopup()
  },
  onUnload() {
    this.popups.forEach((popup) => {
      var _popup$contructor
      return (_popup$contructor = popup.contructor) === null || _popup$contructor === void 0
        ? void 0
        : _popup$contructor.unload()
    })
  },
}),
  register('blog-posts', {
    onLoad() {
      shouldAnimate(this.container) && (this.animateBlogPosts = animateBlogPosts(this.container))
    },
    onUnload() {
      var _this$animateBlogPost
      ;(_this$animateBlogPost = this.animateBlogPosts) === null ||
        _this$animateBlogPost === void 0 ||
        _this$animateBlogPost.destroy()
    },
  })
const selectors$q = { itemTrigger: '.collapsible-row-list-item__trigger' }
register('collapsible-row-list', {
  onLoad() {
    ;(this.items = t$2(selectors$q.itemTrigger, this.container)),
      (this.clickHandlers = e$2(this.items, 'click', (e2) => {
        e2.preventDefault()
        const { parentNode: group, nextElementSibling: content } = e2.currentTarget
        content && isVisible(content)
          ? this._close(e2.currentTarget, group, content)
          : this._open(e2.currentTarget, group, content)
      })),
      shouldAnimate(this.container) &&
        (this.animateCollapsibleRowList = animateCollapsibleRowList(this.container))
  },
  _open(label, group, content) {
    content &&
      (slideStop(content),
      slideDown(content),
      group.setAttribute('data-open', !0),
      label.setAttribute('aria-expanded', !0),
      content.setAttribute('aria-hidden', !1))
  },
  _close(label, group, content) {
    content &&
      (slideStop(content),
      slideUp(content),
      group.setAttribute('data-open', !1),
      label.setAttribute('aria-expanded', !1),
      content.setAttribute('aria-hidden', !0))
  },
  onBlockSelect(_ref) {
    let { target } = _ref
    const label = n$2(selectors$q.itemTrigger, target),
      { parentNode: group, nextElementSibling: content } = label
    this._open(label, group, content)
  },
  onUnload() {
    var _this$animateCollapsi
    this.clickHandlers(),
      (_this$animateCollapsi = this.animateCollapsibleRowList) === null ||
        _this$animateCollapsi === void 0 ||
        _this$animateCollapsi.destroy()
  },
}),
  register('collection-list-slider', {
    onLoad() {
      const { productsPerView, mobileProductsPerView } = this.container.dataset
      ;(this.events = []),
        (this.perView = parseInt(productsPerView, 10)),
        (this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05),
        this._initCarousel(),
        shouldAnimate(this.container) &&
          (this.animateListSlider = animateListSlider(this.container))
    },
    _initCarousel() {
      this.carousel = Carousel(this.container, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
        breakpoints: {
          720: {
            spaceBetween: 16,
            slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
          },
          1200: { spaceBetween: 24, slidesPerView: this.perView },
        },
      })
    },
    onUnload() {
      var _this$carousel, _this$animateListSlid
      ;(_this$carousel = this.carousel) === null ||
        _this$carousel === void 0 ||
        _this$carousel.destroy(),
        (_this$animateListSlid = this.animateListSlider) === null ||
          _this$animateListSlid === void 0 ||
          _this$animateListSlid.destroy()
    },
  })
const selectors$p = { timer: '[data-countdown-timer]' }
register('countdown-banner', {
  onLoad() {
    const timers = t$2(selectors$p.timer, this.container)
    ;(this.countdownTimers = []),
      timers.forEach((timer) => {
        this.countdownTimers.push(CountdownTimer(timer))
      }),
      shouldAnimate(this.container) &&
        (this.animateCountdownBanner = animateCountdownBanner(this.container))
  },
  onUnload() {
    var _this$animateCountdow
    ;(_this$animateCountdow = this.animateCountdownBanner) === null ||
      _this$animateCountdow === void 0 ||
      _this$animateCountdow.destroy(),
      this.countdownTimers.forEach((countdownTimer) => countdownTimer.destroy())
  },
})
const selectors$o = { timer: '[data-countdown-timer]' }
register('countdown-bar', {
  onLoad() {
    const timers = t$2(selectors$o.timer, this.container)
    ;(this.countdownTimers = []),
      timers.forEach((timer) => {
        this.countdownTimers.push(CountdownTimer(timer))
      }),
      shouldAnimate(this.container) &&
        (this.animateCountdownBar = animateCountdownBar(this.container))
  },
  onUnload() {
    var _this$animateCountdow
    ;(_this$animateCountdow = this.animateCountdownBar) === null ||
      _this$animateCountdow === void 0 ||
      _this$animateCountdow.destroy(),
      this.countdownTimers.forEach((countdownTimer) => countdownTimer.destroy())
  },
}),
  register('featured-collection-grid', {
    onLoad() {
      const { productsPerView, mobileProductsPerView } = this.container.dataset
      ;(this.events = []),
        (this.perView = parseInt(productsPerView, 10)),
        (this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05),
        (this.productItem = ProductItem(this.container)),
        (this.breakPointHandler = atBreakpointChange(960, () => {
          window.matchMedia(getMediaQuery('below-960')).matches
            ? this._initCarousel()
            : this.carousel.destroy()
        })),
        window.matchMedia(getMediaQuery('below-960')).matches && this._initCarousel(),
        shouldAnimate(this.container) &&
          (this.animateFeaturedCollectionGrid = animateFeaturedCollectionGrid(this.container))
    },
    _initCarousel() {
      this.carousel = Carousel(this.container, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
        breakpoints: {
          720: {
            spaceBetween: 16,
            slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
          },
        },
      })
    },
    onUnload() {
      var _this$carousel, _this$animateFeatured
      ;(_this$carousel = this.carousel) === null ||
        _this$carousel === void 0 ||
        _this$carousel.destroy(),
        (_this$animateFeatured = this.animateFeaturedCollectionGrid) === null ||
          _this$animateFeatured === void 0 ||
          _this$animateFeatured.destroy()
    },
  })
const selectors$n = {
    navItems: '.featured-collection-slider__navigation-list-item',
    sliderContainer: '.carousel',
    navButtons: '.carousel__navigation-buttons',
  },
  classes$9 = {
    selected: 'selected',
    visible: 'visible',
    fadeout: 'fadeout',
    initReveal: 'init-reveal',
    reveal: 'reveal',
  }
register('featured-collection-slider', {
  onLoad() {
    ;(this.events = []),
      (this.carousels = []),
      this._initCarousels(),
      shouldAnimate(this.container) && (this.animateListSlider = animateListSlider(this.container))
  },
  _initCarousels() {
    const { productsPerView, mobileProductsPerView } = this.container.dataset
    ;(this.perView = parseInt(productsPerView, 10)),
      (this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05),
      (this.productItem = ProductItem(this.container)),
      (this.carouselsElements = t$2(selectors$n.sliderContainer, this.container)),
      (this.navItems = t$2(selectors$n.navItems, this.container)),
      (this.navigationButtons = t$2(selectors$n.navButtons, this.container)),
      this.navItems.forEach((button) =>
        this.events.push(e$2(button, 'click', this._handleNavButton.bind(this)))
      ),
      this.carouselsElements.forEach((container, index) => {
        const navigationWrapper = n$2('[data-navigation="'.concat(index, '"]'), this.container),
          nextButton = n$2('[data-next]', navigationWrapper),
          prevButton = n$2('[data-prev]', navigationWrapper)
        this.carousels.push(
          Carousel(container, {
            slidesPerView: this.mobilePerView,
            spaceBetween: 13,
            navigation: { nextEl: nextButton, prevEl: prevButton },
            breakpoints: {
              720: {
                spaceBetween: 17,
                slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
              },
              1200: { spaceBetween: 25, slidesPerView: this.perView },
            },
          })
        )
      })
  },
  _handleNavButton(e2) {
    e2.preventDefault()
    const { navigationItem } = e2.currentTarget.dataset
    a$1(e2.currentTarget, classes$9.selected) ||
      (this._hideAll(), this._show(parseInt(navigationItem, 10)))
  },
  _hideAll() {
    i$1(this.navItems, classes$9.selected),
      i$1(this.navigationButtons, classes$9.visible),
      i$1(this.carouselsElements, classes$9.initReveal),
      i$1(this.carouselsElements, classes$9.reveal),
      shouldAnimate(this.container)
        ? (u$1(this.carouselsElements, classes$9.fadeout),
          setTimeout(() => {
            i$1(this.carouselsElements, classes$9.visible)
          }, 300))
        : i$1(this.carouselsElements, classes$9.visible)
  },
  _show(index) {
    const navigationWrapper = n$2('[data-navigation="'.concat(index, '"]'), this.container)
    u$1(navigationWrapper, classes$9.visible)
    const collection = n$2('[data-collection="'.concat(index, '"]'), this.container)
    if (this.navItems.length) {
      const navigationItem = n$2('[data-navigation-item="'.concat(index, '"]'), this.container)
      u$1(navigationItem, classes$9.selected)
    }
    shouldAnimate(this.container)
      ? (u$1(collection, classes$9.fadeout),
        u$1(collection, classes$9.initReveal),
        setTimeout(() => {
          u$1(collection, classes$9.visible),
            i$1(collection, classes$9.fadeout),
            setTimeout(() => {
              u$1(collection, classes$9.reveal)
            }, 50)
        }, 300))
      : u$1(collection, classes$9.visible)
  },
  onUnload() {
    var _this$animateListSlid
    this.carousels.forEach((swiper) => swiper.destroy()),
      (_this$animateListSlid = this.animateListSlider) === null ||
        _this$animateListSlid === void 0 ||
        _this$animateListSlid.destroy(),
      this.events.forEach((unsubscribe) => unsubscribe())
  },
  onBlockSelect(_ref) {
    let { target } = _ref
    const { collection } = target.dataset
    this._hideAll(), this._show(parseInt(collection, 10))
  },
}),
  register('featured-product', {
    onLoad() {
      ;(this.product = new Product(this.container)),
        shouldAnimate(this.container) && (this.animateProduct = animateProduct(this.container))
    },
    onBlockSelect(_ref) {
      let { target } = _ref
      const label = n$2('.accordion__label', target)
      if ((target.scrollIntoView({ block: 'center', behavior: 'smooth' }), !label)) return
      const { parentNode: group, nextElementSibling: content } = label
      slideStop(content),
        slideDown(content),
        group.setAttribute('data-open', !0),
        label.setAttribute('aria-expanded', !0),
        content.setAttribute('aria-hidden', !1)
    },
    onBlockDeselect(_ref2) {
      let { target } = _ref2
      const label = n$2('.accordion__label', target)
      if (!label) return
      const { parentNode: group, nextElementSibling: content } = label
      slideStop(content),
        slideUp(content),
        group.setAttribute('data-open', !1),
        label.setAttribute('aria-expanded', !1),
        content.setAttribute('aria-hidden', !0)
    },
    onUnload() {
      var _this$animateProduct
      this.product.unload(),
        (_this$animateProduct = this.animateProduct) === null ||
          _this$animateProduct === void 0 ||
          _this$animateProduct.destroy()
    },
  }),
  register('gallery-carousel', {
    onLoad() {
      const { loopCarousel, productsPerView, mobileProductsPerView } = this.container.dataset
      ;(this.loopCarousel = loopCarousel === 'true'),
        (this.perView = parseInt(productsPerView, 10) * 1.05),
        (this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05),
        this._initCarousel(),
        shouldAnimate(this.container) &&
          (this.animateListSlider = animateListSlider(this.container))
    },
    _initCarousel() {
      this.carousel = Carousel(this.container, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
        loop: this.loopCarousel,
        breakpoints: {
          720: { spaceBetween: 16, slidesPerView: this.perView },
          1200: { spaceBetween: 24, slidesPerView: this.perView },
        },
      })
    },
    onUnload() {
      var _this$carousel, _this$animateListSlid
      ;(_this$carousel = this.carousel) === null ||
        _this$carousel === void 0 ||
        _this$carousel.destroy(),
        (_this$animateListSlid = this.animateListSlider) === null ||
          _this$animateListSlid === void 0 ||
          _this$animateListSlid.destroy()
    },
  })
const selectors$m = {
  recentlyViewed: '[data-recently-viewed]',
  carousel: '.carousel',
  carouselSlide: '.carousel__slide',
  navButtons: '.carousel__navigation-buttons',
}
register('recently-viewed-products', {
  onLoad() {
    const { limit, productsPerView, mobileProductsPerView, productHandle } = this.container.dataset
    ;(this.limit = parseInt(limit, 10)),
      (this.perView = parseInt(productsPerView, 10)),
      (this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05),
      (this.recentProductsContainer = n$2(
        '.recently-viewed-products__slider-wrapper',
        this.container
      ))
    const recentProducts = getRecentProducts()
    if (!(recentProducts || []).length) {
      this._removeSection()
      return
    }
    const recentProductsTrimmed = recentProducts
      .filter((handle) => handle !== productHandle)
      .slice(0, this.limit)
    recentProductsTrimmed.length >= 1
      ? this._renderProductItems(recentProductsTrimmed)
      : this._removeSection()
  },
  _renderProductItems(productHandles) {
    const actions = productHandles.map(this._renderProductItem.bind(this))
    Promise.all(actions).then(() => {
      const content = n$2(selectors$m.recentlyViewed, this.container),
        carouselSlide = n$2(selectors$m.carouselSlide, this.container)
      ;(this.productItem = ProductItem(this.container)),
        shouldAnimate(this.container) &&
          (this.animateListSlider = animateListSlider(this.container)),
        carouselSlide
          ? (this.carousel = Carousel(content, {
              slidesPerView: this.mobilePerView,
              spaceBetween: 12,
              breakpoints: {
                720: {
                  spaceBetween: 16,
                  slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
                },
                1200: { spaceBetween: 24, slidesPerView: this.perView },
              },
            }))
          : this._removeSection()
    })
  },
  _renderProductItem(productHandle) {
    return new Promise((resolve) => {
      const requestUrl = ''
        .concat(theme.routes.products, '/')
        .concat(productHandle, '?section_id=recently-viewed-product-item')
      makeRequest('GET', requestUrl)
        .then((response) => {
          let container = document.createElement('div')
          container.innerHTML = response
          const productItem = container.querySelector('[data-recently-viewed-item]').innerHTML
          this.recentProductsContainer.insertAdjacentHTML('beforeend', productItem), resolve()
        })
        .catch(() => {
          console.error('Recent product "'.concat(productHandle, '" not found')), resolve()
        })
    })
  },
  _removeSection() {
    this.container.parentNode.removeChild(this.container)
  },
  onUnload() {
    var _this$carousel, _this$animateListSlid
    ;(_this$carousel = this.carousel) === null ||
      _this$carousel === void 0 ||
      _this$carousel.destroy(),
      (_this$animateListSlid = this.animateListSlider) === null ||
        _this$animateListSlid === void 0 ||
        _this$animateListSlid.destroy()
  },
})
const selectors$l = { recommendations: '[data-recommendations]', carouselSlide: '.carousel__slide' }
register('recommended-products', {
  onLoad() {
    const {
      limit,
      productId: id,
      sectionId,
      productsPerView,
      mobileProductsPerView,
    } = this.container.dataset
    ;(this.perView = parseInt(productsPerView, 10)),
      (this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05)
    const content = n$2(selectors$l.recommendations, this.container)
    if (!content) return
    const requestUrl = ''
        .concat(window.theme.routes.productRecommendations, '?section_id=')
        .concat(sectionId, '&limit=')
        .concat(limit, '&product_id=')
        .concat(id),
      request = new XMLHttpRequest()
    request.open('GET', requestUrl, !0),
      (request.onload = () => {
        if (request.status >= 200 && request.status < 300) {
          let container = document.createElement('div')
          ;(container.innerHTML = request.response),
            (content.innerHTML = n$2(selectors$l.recommendations, container).innerHTML)
          const carousel = n$2(selectors$l.carouselSlide, content)
          ;(this.productItem = ProductItem(this.container)),
            shouldAnimate(this.container) &&
              (this.animateListSlider = animateListSlider(this.container)),
            carousel
              ? (this.carousel = Carousel(content, {
                  slidesPerView: this.mobilePerView,
                  spaceBetween: 12,
                  breakpoints: {
                    720: {
                      spaceBetween: 16,
                      slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
                    },
                    1200: { spaceBetween: 24, slidesPerView: this.perView },
                  },
                }))
              : this._removeSection()
        } else this._removeSection()
      }),
      request.send()
  },
  _removeSection() {
    this.container.parentNode.removeChild(this.container)
  },
  onUnload() {
    var _this$carousel, _this$animateListSlid
    ;(_this$carousel = this.carousel) === null ||
      _this$carousel === void 0 ||
      _this$carousel.destroy(),
      (_this$animateListSlid = this.animateListSlider) === null ||
        _this$animateListSlid === void 0 ||
        _this$animateListSlid.destroy()
  },
})
const classes$8 = {
    activeDot: 'slideshow-navigation__dot--active',
    navigationLoader: 'slideshow-navigation__dot-loader',
  },
  selectors$k = {
    slide: '[data-slide]',
    swiper: '.swiper',
    navigationPrev: '.slideshow-navigation__navigation-button--previous',
    navigationNext: '.slideshow-navigation__navigation-button--next',
    navigationDots: '.slideshow-navigation__dots',
    navigationDot: '.slideshow-navigation__dot',
    navigationLoader: '.slideshow-navigation__dot-loader',
    animatableItems: '.animation--section-blocks > *',
    pageFooter: 'footer',
  }
register('slideshow', {
  onLoad() {
    ;(this.events = []),
      (this.enableAutoplay = this.container.dataset.enableAutoplay),
      (this.autoplayDuration = this.container.dataset.autoplay),
      (this.pageFooter = n$2(selectors$k.pageFooter, document)),
      (this.slideshow = null),
      (this.slideshowContainer = n$2(selectors$k.swiper, this.container)),
      (this.slides = t$2(selectors$k.slide, this.container)),
      this.events.push(e$2(this.container, 'focusin', () => this.handleFocus())),
      shouldAnimate(this.container) &&
        ((this.slideAnimations = this.slides.map((slide) =>
          delayOffset(slide, [selectors$k.animatableItems], 3)
        )),
        (this.observer = intersectionWatcher(this.container))),
      this.slides.length > 1 &&
        import(flu.chunks.swiper).then((_ref) => {
          let {
            Swiper,
            Navigation: Navigation2,
            Autoplay,
            Pagination,
            EffectFade,
            EffectCreative,
          } = _ref
          const swiperOptions = {
            modules: [Navigation2, Pagination],
            autoHeight: !0,
            slidesPerView: 1,
            grabCursor: !0,
            effect: 'fade',
            fadeEffect: { crossFade: !1 },
            watchSlidesProgress: !0,
            loop: !0,
            navigation: { nextEl: selectors$k.navigationNext, prevEl: selectors$k.navigationPrev },
            preloadImages: !1,
            pagination: {
              el: selectors$k.navigationDots,
              clickable: !0,
              bulletActiveClass: classes$8.activeDot,
              bulletClass: 'slideshow-navigation__dot',
              renderBullet: (_, className) =>
                `
                <button class="`.concat(
                  className,
                  `" type="button">
                  <div class="slideshow-navigation__dot-loader"></div>
                </button>`
                ),
            },
            on: {
              afterInit: () => {
                this.handleBulletLabels()
              },
              slideChangeTransitionEnd() {
                const slideEls = this.slides
                setTimeout(function () {
                  slideEls.forEach((slide) => {
                    slide.toggleAttribute('inert', !slide.classList.contains('swiper-slide-active'))
                  })
                }, 50)
              },
            },
          }
          this.enableAutoplay === 'true' &&
            (swiperOptions.modules.push(Autoplay),
            (swiperOptions.autoplay = { delay: this.autoplayDuration, disableOnInteraction: !1 }),
            (this.autoplayObserver = new IntersectionObserver((_ref2) => {
              let [{ isIntersecting: visible }] = _ref2
              visible ? this.playSlideshow() : this.pauseSlideshow()
            })),
            (this.footerObserver = new IntersectionObserver(
              (_ref3) => {
                let [{ isIntersecting: visible }] = _ref3
                visible
                  ? (this.autoplayObserver.disconnect(), this.pauseSlideshow())
                  : this.autoplayObserver.observe(this.slideshowContainer)
              },
              { threshold: 0.8 }
            )),
            window.frames < 2 && this.footerObserver.observe(this.pageFooter)),
            prefersReducedMotion()
              ? (swiperOptions.modules.push(EffectCreative),
                (swiperOptions.effect = 'creative'),
                (swiperOptions.creativeEffect = { prev: { opacity: 0.99 }, next: { opacity: 1 } }))
              : (swiperOptions.modules.push(EffectFade),
                (swiperOptions.effect = 'fade'),
                (swiperOptions.fadeEffect = { crossFade: !1 })),
            (this.slideshow = new Swiper(this.slideshowContainer, swiperOptions)),
            (this.navigationLoaderEls = t$2(selectors$k.navigationLoader, this.container)),
            r$1('slideshow:initialized')
        })
  },
  resetLoaderAnimation(loader) {
    i$1(loader, classes$8.navigationLoader),
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          u$1(loader, classes$8.navigationLoader)
        })
      })
  },
  pauseSlideshow() {
    this.slideshow.autoplay.stop(),
      this.navigationLoaderEls.forEach((loader) => {
        loader.style.animationPlayState = 'paused'
      })
  },
  playSlideshow() {
    var _this$slideshow
    ;(_this$slideshow = this.slideshow) === null ||
      _this$slideshow === void 0 ||
      _this$slideshow.autoplay.start(),
      this.navigationLoaderEls.forEach((loader) => {
        this.resetLoaderAnimation(loader), (loader.style.animationPlayState = 'running')
      })
  },
  handleFocus() {
    a$1(document.body, 'user-is-tabbing') && this.pauseSlideshow()
  },
  handleBulletLabels() {
    t$2(selectors$k.navigationDot, this.container).forEach((bullet, index) => {
      const associatedSlide = this.slides[index],
        { bulletLabel } = associatedSlide.dataset
      bullet.setAttribute('aria-label', bulletLabel)
    })
  },
  handleBlockSelect(slideIndex) {
    this.slideshow.slideTo(parseInt(slideIndex, 10)), this.pauseSlideshow()
  },
  handleBlockDeselect() {
    this.playSlideshow()
  },
  onBlockSelect(_ref4) {
    let { target } = _ref4
    const { slide } = target.dataset
    this.slideshow
      ? this.handleBlockSelect(slide)
      : this.events.push(
          c('slideshow:initialized', () => {
            this.handleBlockSelect(slide)
          })
        )
  },
  onBlockDeselect() {
    this.slideshow
      ? this.handleBlockDeselect()
      : this.events.push(
          c('slideshow:initialized', () => {
            this.handleBlockDeselect()
          })
        )
  },
  onUnload() {
    var _this$slideshow2, _this$observer, _this$autoplayObserve, _this$footerObserver
    ;(_this$slideshow2 = this.slideshow) === null ||
      _this$slideshow2 === void 0 ||
      _this$slideshow2.destroy(),
      this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$observer = this.observer) === null ||
        _this$observer === void 0 ||
        _this$observer.destroy(),
      (_this$autoplayObserve = this.autoplayObserver) === null ||
        _this$autoplayObserve === void 0 ||
        _this$autoplayObserve.disconnect(),
      (_this$footerObserver = this.footerObserver) === null ||
        _this$footerObserver === void 0 ||
        _this$footerObserver.disconnect()
  },
})
let loaded$1 = null
function loadYouTubeAPI() {
  return loaded$1 !== null
    ? loaded$1
    : window.YT && window.YT.loaded
    ? ((loaded$1 = Promise.resolve()), loaded$1)
    : ((loaded$1 = new Promise((resolve) => {
        window.onYouTubeIframeAPIReady = () => {
          resolve()
        }
        const tag = document.createElement('script')
        ;(tag.src = 'https://www.youtube.com/iframe_api'), document.body.appendChild(tag)
      })),
      loaded$1)
}
let loaded = null
function loadVimeoAPI() {
  return loaded !== null
    ? loaded
    : window.Vimeo
    ? ((loaded = Promise.resolve()), loaded)
    : ((loaded = new Promise((resolve) => {
        const tag = document.createElement('script')
        ;(tag.src = 'https://player.vimeo.com/api/player.js'),
          (tag.onload = resolve),
          document.body.appendChild(tag)
      })),
      loaded)
}
const selectors$j = {
    video: '.video__video',
    videoExternal: '[data-video-external-target]',
    image: '.video__image',
    overlay: '.video__overlay',
    text: '.video__text-container-wrapper',
    playTrigger: '.video__text-container-wrapper',
  },
  classes$7 = { visible: 'visible' }
register('video', {
  onLoad() {
    this.events = []
    const playTrigger = n$2(selectors$j.playTrigger, this.container),
      video = n$2(selectors$j.video, this.container),
      videoExternal = n$2(selectors$j.videoExternal, this.container),
      image = n$2(selectors$j.image, this.container),
      overlay = n$2(selectors$j.overlay, this.container),
      text = n$2(selectors$j.text, this.container)
    if (videoExternal) {
      const { videoProvider, videoId, loop } = videoExternal.dataset
      switch (videoProvider) {
        case 'youtube':
          loadYouTubeAPI().then(() => {
            const player = new window.YT.Player(videoExternal, {
              videoId,
              playerVars: {
                autohide: 0,
                cc_load_policy: 0,
                controls: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                rel: 0,
                loop,
                playlist: videoId,
              },
              events: {
                onReady: () => {
                  ;(player.getIframe().tabIndex = '-1'),
                    this.events.push(
                      e$2(playTrigger, 'click', () => {
                        player.playVideo()
                      })
                    )
                },
                onStateChange: (event) => {
                  event.data == YT.PlayerState.PLAYING &&
                    ((player.getIframe().tabIndex = '0'), hideCover())
                },
              },
            })
          })
          break
        case 'vimeo':
          loadVimeoAPI().then(() => {
            const player = new window.Vimeo.Player(videoExternal, {
              id: videoId,
              controls: !0,
              keyboard: !1,
            })
            ;(player.element.tabIndex = '-1'),
              loop === 'true' && player.setLoop(1),
              this.events.push(
                e$2(playTrigger, 'click', () => {
                  player.play(), (player.element.tabIndex = '0'), hideCover()
                })
              )
          })
          break
      }
    }
    playTrigger &&
      video &&
      this.events.push(
        e$2(playTrigger, 'click', () => {
          video.play()
        })
      ),
      video &&
        this.events.push(
          e$2(video, 'playing', () => {
            video.setAttribute('controls', ''), hideCover()
          })
        )
    function hideCover() {
      i$1(overlay, classes$7.visible),
        i$1(text, classes$7.visible),
        image && i$1(image, classes$7.visible)
    }
    shouldAnimate(this.container) && (this.animateVideo = animateVideo(this.container))
  },
  onUnload() {
    var _this$animateVideo
    this.playButtons && this.playButtons.forEach((button) => button.unload()),
      this.events.forEach((unsubscribe) => unsubscribe()),
      this.videoHandler && this.videoHandler(),
      (_this$animateVideo = this.animateVideo) === null ||
        _this$animateVideo === void 0 ||
        _this$animateVideo.destroy()
  },
})
const selectors$i = {
    playButton: '[data-play-button-block]',
    playButtonVideoContainer: '[data-play-button-block-video-container]',
    photoSwipeElement: '.pswp',
    video: '.play-button-block-video',
  },
  { icons } = window.theme,
  playButton = (node) => {
    let photoSwipeInstance
    const playButton2 = n$2(selectors$i.playButton, node),
      videoHtml = n$2(selectors$i.playButtonVideoContainer, node),
      videoType = videoHtml.dataset.videoType
    import(flu.chunks.photoswipe)
    const events2 = [
        e$2(playButton2, 'click', () => {
          import(flu.chunks.photoswipe).then((_ref) => {
            let { PhotoSwipeLightbox, PhotoSwipe } = _ref
            ;(photoSwipeInstance = new PhotoSwipeLightbox({
              dataSource: [{ html: videoHtml.outerHTML }],
              pswpModule: PhotoSwipe,
              mainClass: 'pswp--video-lightbox',
              closeSVG: icons.close,
              arrowPrev: !1,
              arrowNext: !1,
              zoom: !1,
              counter: !1,
            })),
              photoSwipeInstance.init(),
              photoSwipeInstance.loadAndOpen(),
              photoSwipeInstance.on('bindEvents', () => {
                const instanceVideo = n$2(selectors$i.video, photoSwipeInstance.pswp.container)
                videoType == 'shopify' ? instanceVideo.play() : initExternalVideo(instanceVideo)
              })
          })
        }),
      ],
      initExternalVideo = (video) => {
        const { videoProvider, videoId } = video.dataset
        switch (videoProvider) {
          case 'youtube':
            loadYouTubeAPI().then(() => {
              const player = new window.YT.Player(video, {
                videoId,
                playerVars: {
                  autohide: 0,
                  cc_load_policy: 0,
                  controls: 1,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  playsinline: 1,
                  rel: 0,
                  playlist: videoId,
                },
                events: {
                  onReady: () => {
                    player.playVideo(), (player.getIframe().tabIndex = '0')
                  },
                },
              })
            })
            break
          case 'vimeo':
            loadVimeoAPI().then(() => {
              const player = new window.Vimeo.Player(video, {
                id: videoId,
                controls: !0,
                keyboard: !1,
              })
              player.play(), (player.element.tabIndex = '0')
            })
            break
        }
      }
    return {
      unload: () => {
        events2.forEach((unsubscribe) => unsubscribe()),
          photoSwipeInstance && photoSwipeInstance.destroy()
      },
    }
  },
  checkAutoPlay = (video, mediaContainer) => {
    if (!video) return
    const events2 = [
      e$2(window, 'click', () => _handleAutoPlay()),
      e$2(window, 'touchstart', () => _handleAutoPlay()),
      e$2(video, 'playing', () => _handleVideoPlaying()),
    ]
    function _handleAutoPlay() {
      video.paused && video.play()
    }
    function _handleVideoPlaying() {
      ;(mediaContainer.dataset.videoLoading = 'false'),
        events2.forEach((unsubscribe) => unsubscribe())
    }
  },
  selectors$h = {
    mediaContainer: '.video-hero__media-container',
    video: '.video-hero__video',
    videoDefaultTemplate: '#default-video-template',
    videoMobileTemplate: '#mobile-video-template',
    currentVideoContainer: '.current-video-container',
    playButtonVideo: '[data-play-button-block-video]',
    playButtonBlock: '.play-button-block',
  }
register('video-hero', {
  videoHandler: null,
  onLoad() {
    const playButtonVideos = t$2(selectors$h.playButtonVideo, this.container)
    ;(this.mediaContainer = n$2(selectors$h.mediaContainer, this.container)),
      playButtonVideos.length &&
        (this.playButtons = playButtonVideos.map((block) =>
          playButton(block.closest(selectors$h.playButtonBlock))
        ))
    const hasVideo = this.mediaContainer.dataset.hasVideo === 'true'
    this.mediaContainer.dataset.hasMobileVideo === 'true'
      ? (window.matchMedia(getMediaQuery('below-720')).matches
          ? this._updateVideoTemplate('mobile')
          : this._updateVideoTemplate('default'),
        atBreakpointChange(720, () => {
          window.matchMedia(getMediaQuery('below-720')).matches
            ? this._updateVideoTemplate('mobile')
            : this._updateVideoTemplate('default')
        }))
      : hasVideo && this._updateVideoTemplate('default'),
      shouldAnimate(this.container) && (this.animateVideoHero = animateVideoHero(this.container))
  },
  _updateVideoTemplate(videoType) {
    const currentVideoContainer = n$2(selectors$h.currentVideoContainer, this.container),
      videoTemplateSelector =
        videoType === 'mobile' ? selectors$h.videoMobileTemplate : selectors$h.videoDefaultTemplate,
      currentVideoTemplate = n$2(videoTemplateSelector, this.mediaContainer).content.cloneNode(!0),
      currentVideoEl = n$2(selectors$h.video, currentVideoTemplate)
    currentVideoEl && (currentVideoEl.muted = !0),
      (currentVideoContainer.innerHTML = ''),
      currentVideoContainer.appendChild(currentVideoTemplate),
      this._playVideo(currentVideoEl)
  },
  _playVideo(video) {
    ;(this.videoHandler = backgroundVideoHandler(this.container)),
      video && (video.play(), checkAutoPlay(video, this.mediaContainer)),
      video && video.paused && (this.mediaContainer.dataset.videoLoading = 'true')
  },
  onUnload() {
    var _this$animateVideoHer
    this.playButtons && this.playButtons.forEach((button) => button.unload()),
      this.videoHandler && this.videoHandler(),
      (_this$animateVideoHer = this.animateVideoHero) === null ||
        _this$animateVideoHer === void 0 ||
        _this$animateVideoHer.destroy()
  },
})
const selectors$g = {
  mediaContainer: '.video-with-text__media-container',
  video: '.video-with-text__video',
  videoDefaultTemplate: '#default-video-with-text-template',
  videoMobileTemplate: '#mobile-video-with-text-template',
  currentVideoContainer: '.current-video-with-text-container',
  playButtonVideo: '[data-play-button-block]',
  playButtonBlock: '.play-button-block',
}
register('video-with-text', {
  videoHandler: null,
  onLoad() {
    const playButtonVideos = t$2(selectors$g.playButtonVideo, this.container)
    ;(this.mediaContainer = n$2(selectors$g.mediaContainer, this.container)),
      playButtonVideos.length &&
        (this.playButtons = playButtonVideos.map((block) =>
          playButton(block.closest(selectors$g.playButtonBlock))
        ))
    const hasVideo = this.mediaContainer.dataset.hasVideo === 'true'
    this.mediaContainer.dataset.hasMobileVideo === 'true'
      ? (window.matchMedia(getMediaQuery('below-720')).matches
          ? this._updateVideoTemplate('mobile')
          : this._updateVideoTemplate('default'),
        atBreakpointChange(720, () => {
          window.matchMedia(getMediaQuery('below-720')).matches
            ? this._updateVideoTemplate('mobile')
            : this._updateVideoTemplate('default')
        }))
      : hasVideo && this._updateVideoTemplate('default'),
      shouldAnimate(this.container) && (this.animateVideoHero = animateVideoHero(this.container))
  },
  _updateVideoTemplate(videoType) {
    const currentVideoContainer = n$2(selectors$g.currentVideoContainer, this.container),
      videoTemplateSelector =
        videoType === 'mobile' ? selectors$g.videoMobileTemplate : selectors$g.videoDefaultTemplate,
      currentVideoTemplate = n$2(videoTemplateSelector, this.mediaContainer).content.cloneNode(!0),
      currentVideoEl = n$2(selectors$g.video, currentVideoTemplate)
    currentVideoEl && (currentVideoEl.muted = !0),
      (currentVideoContainer.innerHTML = ''),
      currentVideoContainer.appendChild(currentVideoTemplate),
      this._playVideo(currentVideoEl)
  },
  _playVideo(video) {
    ;(this.videoHandler = backgroundVideoHandler(this.container)),
      video && (video.play(), checkAutoPlay(video, this.mediaContainer)),
      video && video.paused && (this.mediaContainer.dataset.videoLoading = 'true')
  },
  onUnload() {
    var _this$animateVideoHer
    this.playButtons && this.playButtons.forEach((button) => button.unload()),
      this.videoHandler && this.videoHandler(),
      (_this$animateVideoHer = this.animateVideoHero) === null ||
        _this$animateVideoHer === void 0 ||
        _this$animateVideoHer.destroy()
  },
})
const selectors$f = { dots: '.navigation-dot' },
  navigationDots = function (container) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
    const navigationDots2 = t$2(selectors$f.dots, container),
      events2 = []
    navigationDots2.forEach((dot) => {
      events2.push(e$2(dot, 'click', (e2) => _handleDotClick(e2)))
    })
    const _handleDotClick = (e2) => {
      if ((e2.preventDefault(), !e2.target.classList.contains('is-selected') && options.onSelect)) {
        const index = parseInt(e2.target.dataset.index, 10)
        options.onSelect(index)
      }
    }
    return {
      update: (dotIndex) => {
        if (typeof dotIndex != 'number') {
          console.debug('navigationDots#update: invalid index, ensure int is passed')
          return
        }
        const activeClass = 'is-selected'
        navigationDots2.forEach((dot) => i$1(dot, activeClass)),
          u$1(navigationDots2[dotIndex], activeClass)
      },
      unload: () => {
        events2.forEach((unsubscribe) => unsubscribe())
      },
    }
  },
  selectors$e = {
    slider: '[data-slider]',
    slide: '[data-slide]',
    logoNavButton: '[logo-nav-button]',
  }
register('quote', {
  onLoad() {
    const sliderContainer = n$2(selectors$e.slider, this.container),
      slides = t$2(selectors$e.slide, this.container)
    if (
      (shouldAnimate(this.container) &&
        (slides.forEach((slide) => animateQuotes(slide)),
        (this.observer = intersectionWatcher(this.container))),
      slides.length < 2)
    )
      return slides.length && u$1(slides[0], 'swiper-slide-visible'), null
    const paginationStyle = sliderContainer.dataset.paginationStyle,
      autoplayEnabled = sliderContainer.dataset.autoplayEnabled == 'true',
      autoplayDelay = parseInt(sliderContainer.dataset.autoplayDelay, 10)
    ;(this.events = []),
      import(flu.chunks.swiper).then((_ref) => {
        let { Swiper, Autoplay, Navigation: Navigation2, EffectFade } = _ref
        ;(this.swiper = new Swiper(sliderContainer, {
          modules: [Navigation2, Autoplay, EffectFade],
          grabCursor: !0,
          effect: 'fade',
          fadeEffect: { crossFade: !0 },
          loop: !0,
          autoplay: autoplayEnabled
            ? { delay: autoplayDelay, disableOnInteraction: !1, pauseOnMouseEnter: !0 }
            : !1,
          navigation: { nextEl: '.slider-nav-button-next', prevEl: '.slider-nav-button-prev' },
        })),
          paginationStyle === 'dots'
            ? (this.dotNavigation = navigationDots(this.container, {
                onSelect: (dotIndex) => {
                  this.swiper.slideToLoop(dotIndex)
                },
              }))
            : paginationStyle === 'logos' &&
              ((this.logoNavButtons = t$2(selectors$e.logoNavButton, this.container)),
              u$1(this.logoNavButtons[0], 'active'),
              this.logoNavButtons.forEach((button) => {
                this.events.push(
                  e$2(button, 'click', (e2) => {
                    const index = parseInt(e2.currentTarget.dataset.index, 10)
                    this.swiper.slideToLoop(index)
                  })
                )
              })),
          this.swiper.on('slideChange', () => {
            const index = this.swiper.realIndex
            if (paginationStyle === 'dots') this.dotNavigation.update(index)
            else if (paginationStyle === 'logos') {
              const activeClass = 'active'
              this.logoNavButtons.forEach((button) => i$1(button, activeClass)),
                u$1(this.logoNavButtons[index], activeClass)
            }
          })
      })
  },
  onBlockSelect(_ref2) {
    var _this$swiper, _this$swiper2
    let { target: slide } = _ref2
    const index = parseInt(slide.dataset.index, 10)
    ;(_this$swiper = this.swiper) === null ||
      _this$swiper === void 0 ||
      (_this$swiper = _this$swiper.autoplay) === null ||
      _this$swiper === void 0 ||
      _this$swiper.stop(),
      (_this$swiper2 = this.swiper) === null ||
        _this$swiper2 === void 0 ||
        _this$swiper2.slideToLoop(index)
  },
  onBlockDeselect() {
    var _this$swiper3
    ;(_this$swiper3 = this.swiper) === null ||
      _this$swiper3 === void 0 ||
      (_this$swiper3 = _this$swiper3.autoplay) === null ||
      _this$swiper3 === void 0 ||
      _this$swiper3.start()
  },
  onUnload() {
    var _this$swiper4, _this$dotNavigation, _this$observer
    ;(_this$swiper4 = this.swiper) === null || _this$swiper4 === void 0 || _this$swiper4.destroy(),
      (_this$dotNavigation = this.dotNavigation) === null ||
        _this$dotNavigation === void 0 ||
        _this$dotNavigation.unload(),
      this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$observer = this.observer) === null ||
        _this$observer === void 0 ||
        _this$observer.destroy()
  },
})
const selectors$d = {
    hotspotWrappers: '.shoppable-item',
    hotspots: '.shoppable-item__hotspot',
    productCard: '.shoppable-item__product-card',
    mobileDrawer: '.shoppable-feature-mobile-drawer',
    desktopSliderContainer: '.shoppable-feature__secondary-content',
    slider: '.swiper',
    slide: '.swiper-slide',
    sliderPagination: '.swiper-pagination',
    sliderImages: '.product-card-mini__image img',
    imageContainer: '.shoppable__image-container',
    sliderNavPrev: '.slider-nav-button-prev',
    sliderNavNext: '.slider-nav-button-next',
    drawerBackground: '.mobile-drawer__overlay',
    drawerCloseButton: '.mobile-drawer__close',
    quickAddButton: '[data-quick-shop-trigger="quick-add"]',
    quickViewButton: '[data-quick-shop-trigger="quick-view"]',
    quickCart: '.quick-cart',
    purchaseConfirmation: '.purchase-confirmation-popup',
  },
  classes$6 = {
    animating: 'shoppable-item--animating',
    unset: 'shoppable-item--position-unset',
    hidden: 'hidden',
    active: 'active',
    drawerActive: 'active',
    pulse: 'shoppable-item__hotspot--pulse',
  },
  sliderTypes = { Desktop: 'desktop', Mobile: 'mobile' }
register('shoppable', {
  onLoad() {
    ;(this.imageContainer = n$2(selectors$d.imageContainer, this.container)),
      (this.showHotspotCards = this.container.dataset.showHotspotCards === 'true'),
      (this.productCards = t$2(selectors$d.productCard, this.container)),
      (this.hotspotContainers = t$2(selectors$d.hotspotWrappers, this.container)),
      (this.hotspots = t$2(selectors$d.hotspots, this.container)),
      (this.mobileDrawer = n$2(selectors$d.mobileDrawer, this.container)),
      (this.quickAddButtons = t$2(selectors$d.quickAddButton, this.container)),
      (this.quickViewButtons = t$2(selectors$d.quickViewButton, this.container)),
      (this.purchaseConfirmation = n$2(selectors$d.purchaseConfirmation, document)),
      (this.quickCart = n$2(selectors$d.quickCart, document)),
      (this.hotspotEvents = this.hotspots.map((hotspot) => ({
        element: hotspot,
        event: e$2(hotspot, 'mouseenter', (e2) => {
          i$1(e2.currentTarget.parentNode, classes$6.animating),
            this.hotspotEvents.find((o2) => o2.element === hotspot).event()
        }),
      }))),
      (this.events = [
        e$2(this.hotspots, 'click', (e2) => this._hotspotClickHandler(e2)),
        e$2(this.container, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && this._closeAll()
        }),
        e$2(this.quickAddButtons, 'click', (e2) => {
          const buttonEl = e2.currentTarget
          if ((u$1(buttonEl, 'loading'), !purchaseConfirmation && !quickCart)) return
          e2.preventDefault(), e2.stopPropagation()
          const { productId } = buttonEl.dataset
          productId &&
            cart.addItemById(productId, 1).then((_ref2) => {
              let { res } = _ref2
              i$1(buttonEl, 'loading'),
                this.purchaseConfirmation
                  ? r$1('confirmation-popup:open', null, { product: res.items[0] })
                  : (r$1('quick-cart:updated'),
                    setTimeout(() => {
                      r$1('quick-cart:open')
                    }, 300)),
                window.matchMedia(getMediaQuery('below-960')).matches && this._closeAll()
            })
        }),
        e$2(this.quickViewButtons, 'click', (e2) => {
          e2.preventDefault(), e2.stopPropagation()
          const buttonEl = e2.currentTarget,
            { productUrl } = buttonEl.dataset
          productUrl &&
            (r$1('quick-view:open', null, { productUrl }),
            window.matchMedia(getMediaQuery('below-960')).matches && this._closeAll())
        }),
      ]),
      this._setupDrawer(),
      this._createOrRecreateSlider(),
      (this.breakPointHandler = atBreakpointChange(960, () => {
        this._closeAll()
      })),
      (this.widthWatcher = srraf((_ref3) => {
        let { vw, pvw } = _ref3
        const wasAboveBreakpoint = pvw >= 960,
          isAboveBreakpoint = vw >= 960
        wasAboveBreakpoint !== isAboveBreakpoint && this._createOrRecreateSlider()
      })),
      this.showHotspotCards
        ? (this.events.push(e$2(document, 'click', (e2) => this._clickOutsideHandler(e2))),
          this.productCards.forEach((card) => this._setCardDimensions(card)),
          shouldAnimate(this.container) &&
            (this.animateShoppableImage = animateShoppableImage(this.container)),
          window.matchMedia(getMediaQuery('above-960')).matches &&
            this.hotspots.length &&
            this._activateHotspot(0))
        : shouldAnimate(this.container) &&
          (this.animateShoppableFeature = animateShoppableFeature(this.container)),
      this._initPulseLoop()
  },
  _initPulseLoop() {
    const hotspots = t$2(selectors$d.hotspots, this.container)
    let pulseIndex = 0
    this.pulseInterval = setInterval(() => {
      i$1(hotspots, classes$6.pulse),
        setTimeout(() => {
          u$1(hotspots[pulseIndex], classes$6.pulse),
            pulseIndex++,
            pulseIndex >= hotspots.length && (pulseIndex = 0)
        }, 0)
    }, 3e3)
  },
  _createOrRecreateSlider() {
    const sliderType = window.matchMedia(getMediaQuery('above-960')).matches
      ? sliderTypes.Desktop
      : sliderTypes.Mobile
    if (this.sliderType !== sliderType) {
      var _this$swiper
      ;(this.sliderType = sliderType),
        (_this$swiper = this.swiper) === null || _this$swiper === void 0 || _this$swiper.destroy(),
        (this.sliderInitalized = !1)
      const sliderContainerSelector =
        sliderType === sliderTypes.Desktop
          ? selectors$d.desktopSliderContainer
          : selectors$d.mobileDrawer
      if (
        ((this.sliderContainer = n$2(sliderContainerSelector, this.container)),
        this.sliderContainer === null ||
          ((this.slider = n$2(selectors$d.slider, this.sliderContainer)),
          (this.slides = t$2(selectors$d.slide, this.sliderContainer)),
          (this.sliderPagination = n$2(selectors$d.sliderPagination, this.sliderContainer)),
          (this.sliderNavNext = n$2(selectors$d.sliderNavNext, this.sliderContainer)),
          (this.sliderNavPrev = n$2(selectors$d.sliderNavPrev, this.sliderContainer)),
          (this.sliderImages = t$2(selectors$d.sliderImages, this.sliderContainer)),
          this.slides.length < 2))
      )
        return
      const _this = this
      import(flu.chunks.swiper).then((_ref4) => {
        let { Swiper, Navigation: Navigation2, Pagination } = _ref4
        this.swiper = new Swiper(this.slider, {
          modules: [Navigation2, Pagination],
          grabCursor: window.matchMedia(getMediaQuery('below-960')).matches,
          slidesPerView: 1,
          watchSlidesProgress: !0,
          loop: !0,
          navigation: { nextEl: this.sliderNavNext, prevEl: this.sliderNavPrev },
          pagination: { el: this.sliderPagination, type: 'fraction' },
          on: {
            sliderFirstMove: function () {
              _this.sliderHasBeenInteractedWith = !0
            },
            activeIndexChange: function (swiper) {
              const index = swiper.realIndex
              _this.sliderInitalized && _this._indicateActiveHotspot(index)
            },
            afterInit: function () {
              var _this$sliderImages
              ;(_this.sliderInitalized = !0),
                (_this$sliderImages = _this.sliderImages) === null ||
                  _this$sliderImages === void 0 ||
                  _this$sliderImages.forEach((image) => image.setAttribute('loading', 'eager')),
                _this.sliderType !== sliderTypes.Mobile && _this._indicateActiveHotspot(0)
            },
            slideChangeTransitionEnd() {
              const slideEls = this.slides
              setTimeout(function () {
                slideEls.forEach((slide) => {
                  slide.toggleAttribute('inert', !slide.classList.contains('swiper-slide-active'))
                })
              }, 50)
            },
          },
        })
      })
    }
  },
  _indicateActiveHotspot(index) {
    this.hotspotContainers.forEach((spot) => i$1(spot, classes$6.active))
    const dotWrapper = n$2(".shoppable-item[data-index='".concat(index, "']"), this.container)
    u$1(dotWrapper, classes$6.active)
  },
  _activateHotspot(index) {
    const wrapper = n$2(".shoppable-item[data-index='".concat(index, "']"), this.container),
      card = n$2(selectors$d.productCard, wrapper)
    if (card && !window.matchMedia(getMediaQuery('below-960')).matches)
      a$1(card, 'hidden')
        ? (this._closeAll(), this._showCard(card), this._indicateActiveHotspot(index))
        : this._hideCard(card)
    else if (this.swiper) {
      const isMobileSwiper = this.sliderType === sliderTypes.Mobile
      this.swiper.slideToLoop(index, isMobileSwiper ? 0 : void 0),
        isMobileSwiper && this._openDrawer()
    } else window.matchMedia(getMediaQuery('below-960')).matches && this._openDrawer()
  },
  _showCard(card) {
    this._setCardDimensions(card), card.setAttribute('aria-hidden', !1), i$1(card, classes$6.hidden)
  },
  _hideCard(card) {
    card.setAttribute('aria-hidden', !0), u$1(card, classes$6.hidden)
  },
  _setCardDimensions(card) {
    const cardHeight = card.offsetHeight,
      cardWidth = card.offsetWidth
    card.style.setProperty('--card-height', cardHeight + 'px'),
      card.style.setProperty('--card-width', cardWidth + 'px')
  },
  _setupDrawer() {
    const drawerBackground = n$2(selectors$d.drawerBackground, this.container),
      drawerCloseButton = n$2(selectors$d.drawerCloseButton, this.container)
    this.events.push(e$2(drawerBackground, 'click', () => this._closeAll())),
      this.events.push(e$2(drawerCloseButton, 'click', () => this._closeAll()))
  },
  _openDrawer() {
    u$1(this.mobileDrawer, classes$6.drawerActive),
      document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
      disableBodyScroll(this.mobileDrawer)
  },
  _closeDrawer() {
    this.mobileDrawer &&
      (i$1(this.mobileDrawer, classes$6.drawerActive),
      document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
      enableBodyScroll(this.mobileDrawer))
  },
  _hotspotClickHandler(e2) {
    const wrapper = e2.currentTarget.parentNode.parentNode,
      hotspotIndex = parseInt(wrapper.dataset.index, 10)
    this._activateHotspot(hotspotIndex)
  },
  _clickOutsideHandler(e2) {
    !e2.target.closest(selectors$d.productCard) &&
      !a$1(e2.target, 'shoppable-item__hotspot') &&
      !window.matchMedia(getMediaQuery('below-960')).matches &&
      this._closeAll()
  },
  _closeAll() {
    this.productCards.forEach((card) => {
      this._hideCard(card)
    }),
      this.hotspotContainers.forEach((spot) => i$1(spot, classes$6.active)),
      this._closeDrawer()
  },
  onBlockDeselect() {
    this._closeAll()
  },
  onBlockSelect(_ref5) {
    let { target: el } = _ref5
    const index = parseInt(el.dataset.index, 10)
    window.matchMedia(getMediaQuery('below-960')).matches
      ? setTimeout(() => {
          this._activateHotspot(index)
        }, 10)
      : this.swiper
      ? this.swiper.slideToLoop(index)
      : this._activateHotspot(index)
  },
  onUnload() {
    var _this$swiper2, _this$widthWatcher, _this$animateShoppabl, _this$animateShoppabl2
    ;(_this$swiper2 = this.swiper) === null || _this$swiper2 === void 0 || _this$swiper2.destroy(),
      (_this$widthWatcher = this.widthWatcher) === null ||
        _this$widthWatcher === void 0 ||
        _this$widthWatcher.destroy(),
      this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$animateShoppabl = this.animateShoppableImage) === null ||
        _this$animateShoppabl === void 0 ||
        _this$animateShoppabl.destroy(),
      (_this$animateShoppabl2 = this.animateShoppableFeature) === null ||
        _this$animateShoppabl2 === void 0 ||
        _this$animateShoppabl2.destroy(),
      this.pulseInterval && clearInterval(this.pulseInterval)
  },
})
const selectors$c = {
  video: 'video',
  quickAddButton: '[data-quick-shop-trigger="quick-add"]',
  quickViewButton: '[data-quick-shop-trigger="quick-view"]',
  quickCart: '.quick-cart',
  purchaseConfirmation: '.purchase-confirmation-popup',
}
register('complete-the-look', {
  videoHandler: null,
  onLoad() {
    const video = n$2(selectors$c.video, this.container),
      quickAddButtons = t$2(selectors$c.quickAddButton, this.container),
      quickViewButtons = t$2(selectors$c.quickViewButton, this.container),
      quickCart2 = n$2(selectors$c.quickCart, document),
      purchaseConfirmation2 = n$2(selectors$c.purchaseConfirmation, document)
    video && (this.videoHandler = backgroundVideoHandler(this.container)),
      (this.events = [
        e$2(quickAddButtons, 'click', (e2) => {
          const buttonEl = e2.currentTarget
          if ((u$1(buttonEl, 'loading'), !purchaseConfirmation2 && !quickCart2)) return
          e2.preventDefault(), e2.stopPropagation()
          const { productId } = buttonEl.dataset
          productId &&
            cart.addItemById(productId, 1).then((_ref) => {
              let { res } = _ref
              i$1(buttonEl, 'loading'),
                purchaseConfirmation2
                  ? r$1('confirmation-popup:open', null, { product: res.items[0] })
                  : (r$1('quick-cart:updated'),
                    setTimeout(() => {
                      r$1('quick-cart:open')
                    }, 300))
            })
        }),
        e$2(quickViewButtons, 'click', (e2) => {
          e2.preventDefault(), e2.stopPropagation()
          const buttonEl = e2.currentTarget,
            { productUrl } = buttonEl.dataset
          productUrl && r$1('quick-view:open', null, { productUrl })
        }),
      ]),
      shouldAnimate(this.container) &&
        (this.animateCompleteTheLook = animateCompleteTheLook(this.container))
  },
  onUnload() {
    var _this$animateComplete
    this.videoHandler && this.videoHandler(),
      this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$animateComplete = this.animateCompleteTheLook) === null ||
        _this$animateComplete === void 0 ||
        _this$animateComplete.destroy()
  },
})
const selectors$b = {
  playButtonVideo: '[data-play-button-block-video]',
  playButtonBlock: '.play-button-block',
}
register('rich-text', {
  onLoad() {
    const playButtonVideos = t$2(selectors$b.playButtonVideo, this.container)
    playButtonVideos.length &&
      (this.playButtons = playButtonVideos.map((block) =>
        playButton(block.closest(selectors$b.playButtonBlock))
      )),
      shouldAnimate(this.container) && (this.animateRichText = animateRichText(this.container))
  },
  onUnload() {
    var _this$animateRichText
    this.playButtons && this.playButtons.forEach((button) => button.unload()),
      (_this$animateRichText = this.animateRichText) === null ||
        _this$animateRichText === void 0 ||
        _this$animateRichText.destroy()
  },
})
const selectors$a = {
  imageContainer: '.image-compare__image-container',
  labelContainer: '.image-compare__label-container',
  slider: '.image-compare__slider',
}
register('image-compare', {
  onLoad() {
    ;(this.events = []),
      this._initSliders(),
      shouldAnimate(this.container) &&
        (this.animateImageCompare = animateImageCompare(this.container))
  },
  _initSliders() {
    ;(this.imageContainer = n$2(selectors$a.imageContainer, this.container)),
      (this.labelContainers = t$2(selectors$a.labelContainer, this.container)),
      (this.slider = n$2(selectors$a.slider, this.container)),
      this.slider &&
        this.events.push(
          e$2(this.slider, 'input', (e2) =>
            this.imageContainer.style.setProperty('--position', ''.concat(e2.target.value, '%'))
          ),
          e$2(this.slider, 'mousedown', () => this.hideLabelContainers()),
          e$2(this.slider, 'touchstart', () => this.hideLabelContainers()),
          e$2(this.slider, 'mouseup', () => this.showLabelContainers()),
          e$2(this.slider, 'touchend', () => this.showLabelContainers())
        )
  },
  hideLabelContainers() {
    this.labelContainers.forEach((e2) => {
      e2.style.setProperty('opacity', '0')
    })
  },
  showLabelContainers() {
    this.labelContainers.forEach((e2) => {
      e2.style.setProperty('opacity', '1')
    })
  },
  onUnload() {
    var _this$animateImageCom
    this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$animateImageCom = this.animateImageCompare) === null ||
        _this$animateImageCom === void 0 ||
        _this$animateImageCom.destroy()
  },
})
const selectors$9 = {
  playButtonVideo: '[data-play-button-block-video]',
  playButtonBlock: '.play-button-block',
}
register('image-with-text', {
  onLoad() {
    shouldAnimate(this.container) &&
      (this.animateImageWithText = animateImageWithText(this.container))
    const playButtonVideos = t$2(selectors$9.playButtonVideo, this.container)
    playButtonVideos.length &&
      (this.playButtons = playButtonVideos.map((block) =>
        playButton(block.closest(selectors$9.playButtonBlock))
      ))
  },
  onUnload() {
    var _this$animateImageWit
    ;(_this$animateImageWit = this.animateImageWithText) === null ||
      _this$animateImageWit === void 0 ||
      _this$animateImageWit.destroy(),
      this.playButtons && this.playButtons.forEach((button) => button.unload())
  },
})
const selectors$8 = {
  playButtonVideo: '[data-play-button-block-video]',
  playButtonBlock: '.play-button-block',
}
register('image-with-text-split', {
  onLoad() {
    const playButtonVideos = t$2(selectors$8.playButtonVideo, this.container)
    playButtonVideos.length &&
      (this.playButtons = playButtonVideos.map((block) =>
        playButton(block.closest(selectors$8.playButtonBlock))
      )),
      shouldAnimate(this.container) &&
        (this.animateImageWithTextSplit = animateImageWithTextSplit(this.container))
  },
  onUnload() {
    var _this$animateImageWit
    this.playButtons && this.playButtons.forEach((button) => button.unload()),
      (_this$animateImageWit = this.animateImageWithTextSplit) === null ||
        _this$animateImageWit === void 0 ||
        _this$animateImageWit.destroy()
  },
})
const selectors$7 = {
  playButtonVideo: '[data-play-button-block-video]',
  playButtonBlock: '.play-button-block',
}
register('image-hero', {
  onLoad() {
    const playButtonVideos = t$2(selectors$7.playButtonVideo, this.container)
    playButtonVideos.length &&
      (this.playButtons = playButtonVideos.map((block) =>
        playButton(block.closest(selectors$7.playButtonBlock))
      )),
      shouldAnimate(this.container) && (this.animateImageHero = animateImageHero(this.container))
  },
  onUnload() {
    var _this$animateImageHer
    this.playButtons && this.playButtons.forEach((button) => button.unload()),
      (_this$animateImageHer = this.animateImageHero) === null ||
        _this$animateImageHer === void 0 ||
        _this$animateImageHer.destroy()
  },
}),
  register('image-hero-split', {
    onLoad() {
      shouldAnimate(this.container) &&
        t$2('.animation--item', this.container).forEach((item) => animateImageHeroSplit(item)),
        (this.observer = intersectionWatcher(this.container))
    },
    onUnload() {
      var _this$observer
      this.playButtons && this.playButtons.forEach((button) => button.unload()),
        (_this$observer = this.observer) === null ||
          _this$observer === void 0 ||
          _this$observer.destroy()
    },
  })
const selectors$6 = {
  item: '.testimonials__item',
  swiper: '.swiper',
  navigationNext: '.testimonials__navigation-button--next',
  navigationPrev: '.testimonials__navigation-button--prev',
  productImage: '.testimonials__item-product-image',
}
register('testimonials', {
  onLoad() {
    ;(this.events = []),
      (this.items = t$2(selectors$6.item, this.container)),
      (this.itemsContainer = n$2(selectors$6.swiper, this.container)),
      shouldAnimate(this.container) &&
        ((this.itemAnimations = this.items.map((item) => animateTestimonials(item))),
        (this.observer = intersectionWatcher(this.container))),
      this.items.length > 1
        ? import(flu.chunks.swiper).then((_ref) => {
            let { Swiper, Navigation: Navigation2, EffectFade } = _ref
            ;(this.swiper = Swiper),
              (this.swiperOptions = {
                modules: [Navigation2, EffectFade],
                autoHeight: !0,
                slidesPerView: 1,
                effect: 'fade',
                loop: !0,
                fadeEffect: { crossFade: !0 },
                grabCursor: !0,
                navigation: {
                  nextEl: selectors$6.navigationNext,
                  prevEl: selectors$6.navigationPrev,
                },
                breakpoints: { 720: { spaceBetween: 42 } },
                on: {
                  slideChangeTransitionEnd() {
                    const slideEls = this.slides
                    setTimeout(function () {
                      slideEls.forEach((slide) => {
                        slide.toggleAttribute(
                          'inert',
                          !slide.classList.contains('swiper-slide-active')
                        )
                      })
                    }, 50)
                  },
                },
              }),
              window.matchMedia(getMediaQuery('below-720')).matches &&
                ((this.swiperOptions.effect = 'slide'),
                (this.swiperOptions.slidesPerView = 'auto')),
              (this.carousel = new Swiper(this.itemsContainer, this.swiperOptions)),
              this.setMobileButtonOffset(),
              r$1('testimonials:initialized')
          })
        : this.items.length === 1 && u$1(this.items[0], 'swiper-slide-visible'),
      atBreakpointChange(720, () => {
        this.items.length > 1 &&
          (this.carousel.destroy(),
          window.matchMedia(getMediaQuery('below-720')).matches
            ? ((this.swiperOptions.effect = 'slide'), (this.swiperOptions.slidesPerView = 'auto'))
            : ((this.swiperOptions.effect = 'fade'), (this.swiperOptions.slidesPerView = 1)),
          (this.carousel = new this.swiper(this.itemsContainer, this.swiperOptions)))
      })
  },
  setMobileButtonOffset() {
    const firstImage = n$2(selectors$6.productImage, this.container),
      halfMobileButtonHeight = 34 / 2,
      offset = firstImage.offsetHeight / 2 + halfMobileButtonHeight
    this.container.style.setProperty('--mobile-button-offset', ''.concat(offset, 'px'))
  },
  handleBlockSelect(slideIndex) {
    this.carousel.slideToLoop(parseInt(slideIndex, 10))
  },
  onBlockSelect(_ref2) {
    let { target } = _ref2
    const { index } = target.dataset
    this.carousel
      ? this.handleBlockSelect(index)
      : this.events.push(
          c('testimonials:initialized', () => {
            this.handleBlockSelect(index)
          })
        )
  },
  onUnload() {
    var _this$observer
    this.events.forEach((unsubscribe) => unsubscribe()),
      (_this$observer = this.observer) === null ||
        _this$observer === void 0 ||
        _this$observer.destroy()
  },
}),
  register('sales-banner', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animateSalesBanner = animateSalesBanner(this.container))
    },
    onUnload() {
      var _this$animateSalesBan
      ;(_this$animateSalesBan = this.animateSalesBanner) === null ||
        _this$animateSalesBan === void 0 ||
        _this$animateSalesBan.destroy()
    },
  }),
  register('promotion-bar', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animatePromotionBar = animatePromotionBar(this.container))
    },
    onUnload() {
      var _this$animatePromotio
      ;(_this$animatePromotio = this.animatePromotionBar) === null ||
        _this$animatePromotio === void 0 ||
        _this$animatePromotio.destroy()
    },
  }),
  register('grid', {
    onLoad() {
      shouldAnimate(this.container) && (this.animateGrid = animateGrid(this.container))
    },
    onUnload() {
      var _this$animateGrid
      ;(_this$animateGrid = this.animateGrid) === null ||
        _this$animateGrid === void 0 ||
        _this$animateGrid.destroy()
    },
  }),
  register('collection-list-grid', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animateCollectionListGrid = animateCollectionListGrid(this.container))
    },
    onUnload() {
      var _this$animateCollecti
      ;(_this$animateCollecti = this.animateCollectionListGrid) === null ||
        _this$animateCollecti === void 0 ||
        _this$animateCollecti.destroy()
    },
  }),
  register('contact-form', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animateContactForm = animateContactForm(this.container))
    },
    onUnload() {
      var _this$animateContactF
      ;(_this$animateContactF = this.animateContactForm) === null ||
        _this$animateContactF === void 0 ||
        _this$animateContactF.destroy()
    },
  })
const selectors$5 = { sliderContainer: '.carousel' }
register('multi-column', {
  onLoad() {
    const { sliderOnMobile: sliderOnMobileString } = this.container.dataset
    sliderOnMobileString === 'true' &&
      window.matchMedia(getMediaQuery('below-720')).matches &&
      this._initCarousel(),
      (this.breakPointHandler = atBreakpointChange(720, () => {
        if (window.matchMedia(getMediaQuery('below-720')).matches) this._initCarousel()
        else {
          var _this$carousel
          ;(_this$carousel = this.carousel) === null ||
            _this$carousel === void 0 ||
            _this$carousel.destroy()
        }
      })),
      shouldAnimate(this.container) &&
        (this.animateMultiColumn = animateMultiColumn(this.container))
  },
  _initCarousel() {
    const { mobileColumnsPerView } = this.container.dataset
    ;(this.mobilePerView = parseInt(mobileColumnsPerView, 10) * 1.05),
      (this.carouselElement = n$2(selectors$5.sliderContainer, this.container)),
      (this.carousel = Carousel(this.carouselElement, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
      }))
  },
  onUnload() {
    var _this$carousel2, _this$animateMultiCol
    this.breakPointHandler.unload(),
      (_this$carousel2 = this.carousel) === null ||
        _this$carousel2 === void 0 ||
        _this$carousel2.destroy(),
      (_this$animateMultiCol = this.animateMultiColumn) === null ||
        _this$animateMultiCol === void 0 ||
        _this$animateMultiCol.destroy()
  },
}),
  register('newsletter', {
    onLoad() {
      shouldAnimate(this.container) && (this.animateNewsletter = animateNewsletter(this.container))
    },
    onUnload() {
      var _this$animateNewslett
      ;(_this$animateNewslett = this.animateNewsletter) === null ||
        _this$animateNewslett === void 0 ||
        _this$animateNewslett.destroy()
    },
  }),
  register('newsletter-compact', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animateNewsletterCompact = animateNewsletterCompact(this.container))
    },
    onUnload() {
      var _this$animateNewslett
      ;(_this$animateNewslett = this.animateNewsletterCompact) === null ||
        _this$animateNewslett === void 0 ||
        _this$animateNewslett.destroy()
    },
  })
const selectors$4 = {
    listContainer: '[data-events-eventbrite-container]',
    skeletonList: '.events__list--skeleton',
  },
  endpoints = {
    org: (token) =>
      'https://www.eventbriteapi.com//v3/users/me/organizations/?token='.concat(token),
    events: (id, token) =>
      'https://www.eventbriteapi.com//v3/organizations/'
        .concat(id, '/events/?token=')
        .concat(token, '&expand=venue&status=live'),
  }
register('events', {
  onLoad() {
    ;(this.accessToken = this.container.dataset.accessToken),
      (this.eventCount = parseInt(this.container.dataset.eventCount, 10)),
      (this.imageAspectRatio = this.container.dataset.imageAspectRatio),
      (this.learnMoreText = this.container.dataset.learnMoreText),
      this._fetchOrg(),
      shouldAnimate(this.container) &&
        ((this.animateEvents = animateEvents(this.container)),
        this.accessToken || this.animateEvents.animateEventItems())
  },
  _fetchOrg() {
    this.accessToken &&
      fetch(endpoints.org(this.accessToken))
        .then((res) => res.json())
        .then((res) => {
          this._fetchEvents(res.organizations[0].id)
        })
  },
  _fetchEvents(id) {
    id &&
      fetch(endpoints.events(id, this.accessToken))
        .then((res) => res.json())
        .then((events2) => {
          this._renderEvents(events2.events)
        })
  },
  _renderEvents(events2) {
    const listContainer = n$2(selectors$4.listContainer, this.container),
      skeletonList = n$2(selectors$4.skeletonList, this.container)
    let list = document.createElement('ul')
    ;(list.className = 'events__list'),
      events2.slice(0, this.eventCount).forEach((event) => {
        list.innerHTML += this._renderEventItem(event)
      }),
      u$1(skeletonList, 'hide'),
      setTimeout(() => {
        ;(listContainer.textContent = ''),
          listContainer.appendChild(list),
          shouldAnimate(this.container) && this.animateEvents.animateEventItems()
      }, 300)
  },
  _renderEventItem(event) {
    var _event$logo
    return `
      <li
        class="
          event-item
          event-item--eventbrite
          `
      .concat(
        (_event$logo = event.logo) !== null && _event$logo !== void 0 && _event$logo.url
          ? 'event-item--has-image'
          : '',
        `
        "
      >
        <a href="`
      )
      .concat(
        event.url,
        `" class="event-item__link">
          <div class="event-item__image-wrapper">
            `
      )
      .concat(
        this._renderImage(event),
        `
            `
      )
      .concat(
        this._renderDateBadge(event),
        `
          </div>
          <div class="event-item__details">
            `
      )
      .concat(
        this._renderName(event),
        `
            `
      )
      .concat(
        this._renderDate(event),
        `
            `
      )
      .concat(
        this._renderVenue(event),
        `
            `
      )
      .concat(
        this._renderSummary(event),
        `
            <span class="btn btn--callout event-item__callout">
              <span>`
      )
      .concat(
        this.learnMoreText,
        `</span>
            </span>
          </div>
        </a>
      </li>
    `
      )
  },
  _renderImage(event) {
    var _event$logo2
    let image = ''
    return (
      (_event$logo2 = event.logo) !== null &&
        _event$logo2 !== void 0 &&
        _event$logo2.url &&
        (image = `
        <div class="image `
          .concat(
            this.imageAspectRatio,
            ` event-item__image image--animate animation--lazy-load">
          <img
            src="`
          )
          .concat(
            event.logo.url,
            `"
            alt="`
          )
          .concat(
            event.name.text,
            `"
            loading="lazy"
            class="image__img"
            onload="javascript: this.closest('.image').classList.add('loaded')"
          >
        </div>
      `
          )),
      image
    )
  },
  _renderDateBadge(event) {
    var _event$start
    let html = ''
    if ((_event$start = event.start) !== null && _event$start !== void 0 && _event$start.local) {
      const date = new Date(event.start.local)
      html = `
        <span class="event-item__date-badge">
          <span class="event-item__date-badge-day fs-body-bold fs-body-200">
            `
        .concat(
          new Intl.DateTimeFormat([], { day: 'numeric' }).format(date),
          `
          </span>
          <span class="event-item__date-badge-month fs-accent">
            `
        )
        .concat(
          new Intl.DateTimeFormat([], { month: 'short' }).format(date),
          `
          </span>
        </span>
      `
        )
    }
    return html
  },
  _renderName(event) {
    var _event$name
    let html = ''
    return (
      (_event$name = event.name) !== null &&
        _event$name !== void 0 &&
        _event$name.text &&
        (html = `
        <h4 class="event-item__name ff-heading fs-heading-5-base">
          `.concat(
          event.name.text,
          `
        </h4>
      `
        )),
      html
    )
  },
  _renderDate(event) {
    var _event$start2
    let html = ''
    if ((_event$start2 = event.start) !== null && _event$start2 !== void 0 && _event$start2.local) {
      const date = new Date(event.start.local)
      html = `
        <p class="event-item__date fs-body-75">
          `
        .concat(
          date.toLocaleDateString([], {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
          `
          `
        )
        .concat(
          date.toLocaleTimeString([], {
            timeZone: event.start.timezone,
            hour: 'numeric',
            minute: '2-digit',
          }),
          `
        </p>
      `
        )
    }
    return html
  },
  _renderVenue(event) {
    var _event$venue
    let html = ''
    return (
      (_event$venue = event.venue) !== null &&
        _event$venue !== void 0 &&
        _event$venue.name &&
        (html = `
        <p class="event-item__venue fs-body-75">
          `.concat(
          event.venue.name,
          `
        </p>
      `
        )),
      html
    )
  },
  _renderSummary(event) {
    let html = ''
    return (
      event.summary &&
        (html = `
        <p class="event-item__summary">
          `.concat(
          event.summary,
          `
        </p>
      `
        )),
      html
    )
  },
  onUnload() {
    var _this$animateEvents
    ;(_this$animateEvents = this.animateEvents) === null ||
      _this$animateEvents === void 0 ||
      _this$animateEvents.destroy()
  },
}),
  register('promo-banner', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animatePromoBanner = animatePromoBanner(this.container))
    },
    onUnload() {
      var _this$animatePromoBan
      ;(_this$animatePromoBan = this.animatePromoBanner) === null ||
        _this$animatePromoBan === void 0 ||
        _this$animatePromoBan.destroy()
    },
  }),
  register('scrolling-content', {
    onLoad() {
      const marquee = n$2('.scrolling-content__marquee', this.container),
        content = n$2('.scrolling-content__content', this.container),
        clonedContent = this.tabProofClonedContent(content.cloneNode(!0))
      content.offsetWidth !== 0 &&
        (provideResizeObserver().then((_ref) => {
          let { ResizeObserver: ResizeObserver2 } = _ref
          ;(this.ro = new ResizeObserver2((_ref2) => {
            let [{ target }] = _ref2,
              num = this.getNeededCloneCount(target, marquee, content)
            for (let i2 = 0; i2 < num; i2++)
              (marquee.dataset.playScrollAnimation = 'false'),
                marquee.appendChild(clonedContent.cloneNode(!0))
            a$1(document.documentElement, 'prefers-reduced-motion') ||
              requestAnimationFrame(() => {
                marquee.dataset.playScrollAnimation = 'true'
              })
          })),
            this.ro.observe(document.documentElement)
        }),
        shouldAnimate(this.container) &&
          (this.animateScrollingContent = animateScrollingContent(this.container)))
    },
    getNeededCloneCount(target, marquee, content) {
      return Math.ceil((target.offsetWidth - marquee.offsetWidth) / content.offsetWidth) + 1
    },
    tabProofClonedContent(clonedContent) {
      return (
        t$2('a', clonedContent).forEach((linkEl) => {
          linkEl.setAttribute('tabindex', '-1')
        }),
        clonedContent.setAttribute('aria-hidden', !0),
        clonedContent
      )
    },
    onUnload() {
      var _this$animateScrollin
      this.ro.disconnect(),
        (_this$animateScrollin = this.animateScrollingContent) === null ||
          _this$animateScrollin === void 0 ||
          _this$animateScrollin.destroy()
    },
  })
const selectors$3 = {
  tabLabels: '[data-tab-label]',
  tabItems: '[data-tab-item]',
  tabList: '[data-tab-list]',
  activeTabItem: "[data-tab-item][aria-hidden='false']",
}
register('product-tabs', {
  onLoad() {
    ;(this.accordions = []),
      (this.tabItems = t$2(selectors$3.tabItems, this.container)),
      (this.tabLabels = t$2(selectors$3.tabLabels, this.container)),
      (this.tabList = n$2(selectors$3.tabList, this.container)),
      (this.activeTabItem = n$2(selectors$3.activeTabItem, this.container)),
      this.activeTabItem && this._setTabHeight(this.activeTabItem),
      (this.clickHandlers = e$2(this.tabLabels, 'click', (e2) => {
        e2.preventDefault()
        const contentID = e2.currentTarget.getAttribute('aria-controls'),
          content = n$2('#'.concat(contentID), this.container)
        this._closeAll(), this._open(e2.currentTarget, content)
      })),
      t$2('.accordion', this.container).forEach((accordion2) => {
        const accordionOpen = accordion2.classList.contains('accordion--open')
        this.accordions.push(Accordions(accordion2, { firstOpen: accordionOpen })),
          accordion2.classList.add('rte--product', 'accordion--product')
      }),
      shouldAnimate(this.container) &&
        (this.animateProductTabs = animateProductTabs(this.container))
  },
  _closeAll() {
    this.tabLabels.forEach((label) => {
      const contentID = label.getAttribute('aria-controls'),
        content = n$2('#'.concat(contentID), this.container)
      this._isVisible(content) && this._close(label, content)
    })
  },
  _open(label, content) {
    label.setAttribute('aria-expanded', !0),
      content.setAttribute('aria-hidden', !1),
      this._setTabHeight(content)
  },
  _close(label, content) {
    label.setAttribute('aria-expanded', !1), content.setAttribute('aria-hidden', !0)
  },
  _isVisible(content) {
    return content.getAttribute('aria-hidden') === 'false'
  },
  _setTabHeight(content) {
    const height = content.offsetHeight
    this.tabList.style.height = ''.concat(height, 'px')
  },
  onBlockSelect(_ref) {
    let { target } = _ref
    const contentID = target.getAttribute('aria-controls'),
      content = n$2('#'.concat(contentID), this.container)
    this._closeAll(), this._open(target, content)
  },
  onUnload() {
    var _this$animateProductT
    this.clickHandlers(),
      this.accordions.forEach((accordion2) => accordion2.unload()),
      (_this$animateProductT = this.animateProductTabs) === null ||
        _this$animateProductT === void 0 ||
        _this$animateProductT.destroy()
  },
}),
  register('apps', {
    onLoad() {
      shouldAnimate(this.container) && (this.animateApps = animateApps(this.container))
    },
    onUnload() {
      var _this$animateApps
      ;(_this$animateApps = this.animateApps) === null ||
        _this$animateApps === void 0 ||
        _this$animateApps.destroy()
    },
  })
const selectors$2 = {
    cart: '[data-section-type="cart"]',
    cartError: '.cart__form-item-error',
    cartItems: '[js-cart-items]',
    cartNoteTrigger: '[data-order-note-trigger]',
    cartSubtotalWrapper: '[js-cart-footer-subtotal-wrapper]',
    cartUpdateButton: '.cart__update',
    quantityInput: '.cart .quantity-input__input',
    quantityItem: '[data-input-item]',
    freeShippingBar: '[data-free-shipping-bar]',
    crossSells: '[data-cross-sells]',
  },
  classes$5 = { updatingQuantity: 'has-quantity-update', removed: 'is-removed' }
register('cart', {
  onLoad() {
    const cartNoteTrigger = n$2(selectors$2.cartNoteTrigger, this.container),
      freeShippingBar$1 = n$2(selectors$2.freeShippingBar, this.container)
    freeShippingBar$1 && freeShippingBar(freeShippingBar$1),
      this._initCrossSells(),
      cartNoteTrigger && (this.cartNoteToggle = CartNoteToggle(this.container)),
      (this.quantityButtons = QuantityButtons(this.container)),
      (this.events = [
        c('cart:updated', () => this.refreshCart()),
        c('cart:error', (_, _ref) => {
          let { key, errorMessage } = _ref
          this.handleErrorMessage(key, errorMessage)
        }),
        c(['quantity-update:subtract', 'quantity-update:add'], (_, _ref2) => {
          let { key } = _ref2
          this.handleQuantityUpdate(key)
        }),
        c('quantity-update:remove', (_, _ref3) => {
          let { key } = _ref3
          this.handleItemRemoval(key)
        }),
      ]),
      (this.delegate = new Delegate(this.container)),
      this.delegate.on('change', selectors$2.quantityInput, (e2) =>
        this.handleQuantityInputChange(e2)
      )
  },
  refreshCart() {
    const url = ''.concat(theme.routes.cart.base, '?section_id=').concat(this.id),
      targetCartItems = n$2(selectors$2.cartItems, this.container),
      targetCartSubtotalWrapper = n$2(selectors$2.cartSubtotalWrapper, this.container)
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const sourceDom = new DOMParser().parseFromString(text, 'text/html'),
          sourceCartItems = n$2(selectors$2.cartItems, sourceDom),
          sourceCartSubtotalWrapper = n$2(selectors$2.cartSubtotalWrapper, sourceDom),
          sourceFreeShippingBar = n$2(selectors$2.freeShippingBar, sourceDom)
        if (sourceCartItems)
          (targetCartItems.innerHTML = sourceCartItems.innerHTML),
            (targetCartSubtotalWrapper.outerHTML = sourceCartSubtotalWrapper.outerHTML)
        else {
          const sourceContainer = n$2(selectors$2.cart, sourceDom)
          this.container.innerHTML = sourceContainer.innerHTML
        }
        if (sourceFreeShippingBar) {
          const freeShippingBar$1 = n$2(selectors$2.freeShippingBar, this.container)
          ;(freeShippingBar$1.dataset.cartTotal = sourceFreeShippingBar.dataset.cartTotal),
            freeShippingBar(freeShippingBar$1)
        }
        this._initCrossSells()
      })
  },
  handleErrorMessage(key) {
    const item = n$2('[data-key="'.concat(key, '"]'), this.container)
    i$1(n$2(selectors$2.cartError, item), 'hidden'), i$1(item, classes$5.updatingQuantity)
  },
  handleQuantityInputChange(_ref4) {
    let { target } = _ref4
    const item = target.closest(selectors$2.quantityItem),
      { key } = item.dataset
    cart.updateItem(key, target.value), this.handleQuantityUpdate(key)
  },
  handleQuantityUpdate(key) {
    const item = n$2('[data-key="'.concat(key, '"]'), this.container)
    u$1(item, classes$5.updatingQuantity)
  },
  handleItemRemoval(key) {
    const item = n$2('[data-key="'.concat(key, '"]'), this.container)
    u$1(item, classes$5.removed), u$1(item, classes$5.updatingQuantity)
  },
  _initCrossSells() {
    const crossSells = n$2(selectors$2.crossSells, this.container)
    crossSells && (this.crossSells = CrossSells(crossSells))
  },
  onUnload() {
    var _this$cartNoteToggle
    this.events.forEach((unsubscribe) => unsubscribe()),
      this.quantityButtons.unload(),
      (_this$cartNoteToggle = this.cartNoteToggle) === null ||
        _this$cartNoteToggle === void 0 ||
        _this$cartNoteToggle.unload()
  },
}),
  register('product', {
    onLoad() {
      ;(this.product = new Product(this.container)),
        (this.animateProduct = animateProduct(this.container))
    },
    onBlockSelect(_ref) {
      let { target } = _ref
      const label = n$2('.accordion__label', target)
      if ((target.scrollIntoView({ block: 'center', behavior: 'smooth' }), !label)) return
      const { parentNode: group, nextElementSibling: content } = label
      slideStop(content),
        slideDown(content),
        group.setAttribute('data-open', !0),
        label.setAttribute('aria-expanded', !0),
        content.setAttribute('aria-hidden', !1)
    },
    onBlockDeselect(_ref2) {
      let { target } = _ref2
      const label = n$2('.accordion__label', target)
      if (!label) return
      const { parentNode: group, nextElementSibling: content } = label
      slideStop(content),
        slideUp(content),
        group.setAttribute('data-open', !1),
        label.setAttribute('aria-expanded', !1),
        content.setAttribute('aria-hidden', !0)
    },
    onUnload() {
      var _this$animateProduct
      this.product.unload(),
        (_this$animateProduct = this.animateProduct) === null ||
          _this$animateProduct === void 0 ||
          _this$animateProduct.destroy()
    },
  })
/* @preserve
 * https://github.com/Elkfox/Ajaxinate
 * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
 * MIT License (do not remove above copyright!)
 */ function Ajaxinate(config) {
  const settings = config || {},
    defaults = {
      method: 'scroll',
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      offset: 0,
      loadingText: 'Loading',
      callback: null,
    }
  ;(this.settings = Object.assign(defaults, settings)),
    (this.addScrollListeners = this.addScrollListeners.bind(this)),
    (this.addClickListener = this.addClickListener.bind(this)),
    (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
    (this.preventMultipleClicks = this.preventMultipleClicks.bind(this)),
    (this.removeClickListener = this.removeClickListener.bind(this)),
    (this.removeScrollListener = this.removeScrollListener.bind(this)),
    (this.removePaginationElement = this.removePaginationElement.bind(this)),
    (this.destroy = this.destroy.bind(this)),
    (this.containerElement = document.querySelector(this.settings.container)),
    (this.paginationElement = document.querySelector(this.settings.pagination)),
    this.initialize()
}
;(Ajaxinate.prototype.initialize = function () {
  if (!this.containerElement) return
  ;({ click: this.addClickListener, scroll: this.addScrollListeners })[this.settings.method]()
}),
  (Ajaxinate.prototype.addScrollListeners = function () {
    this.paginationElement &&
      (document.addEventListener('scroll', this.checkIfPaginationInView),
      window.addEventListener('resize', this.checkIfPaginationInView),
      window.addEventListener('orientationchange', this.checkIfPaginationInView))
  }),
  (Ajaxinate.prototype.addClickListener = function () {
    this.paginationElement &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector('a')),
      (this.clickActive = !0),
      typeof this.nextPageLinkElement < 'u' &&
        this.nextPageLinkElement !== null &&
        this.nextPageLinkElement.addEventListener('click', this.preventMultipleClicks))
  }),
  (Ajaxinate.prototype.preventMultipleClicks = function (event) {
    event.preventDefault(),
      this.clickActive &&
        ((this.nextPageLinkElement.innerText = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        (this.clickActive = !1),
        this.loadMore())
  }),
  (Ajaxinate.prototype.checkIfPaginationInView = function () {
    const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
      bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset
    top <= window.innerHeight &&
      bottom >= 0 &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector('a')),
      this.removeScrollListener(),
      this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerText = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()))
  }),
  (Ajaxinate.prototype.loadMore = function () {
    ;(this.request = new XMLHttpRequest()),
      (this.request.onreadystatechange = function () {
        if (this.request.readyState === 4 && this.request.status === 200) {
          var parser = new DOMParser(),
            htmlDoc = parser.parseFromString(this.request.responseText, 'text/html'),
            newContainer = htmlDoc.querySelectorAll(this.settings.container)[0],
            newPagination = htmlDoc.querySelectorAll(this.settings.pagination)[0]
          this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML),
            (this.paginationElement.innerHTML = newPagination.innerHTML),
            this.settings.callback &&
              typeof this.settings.callback == 'function' &&
              this.settings.callback(this.request.responseXML),
            this.initialize()
        }
      }.bind(this)),
      this.request.open('GET', this.nextPageUrl),
      this.request.send()
  }),
  (Ajaxinate.prototype.removeClickListener = function () {
    this.nextPageLinkElement.removeEventListener('click', this.preventMultipleClicks)
  }),
  (Ajaxinate.prototype.removePaginationElement = function () {
    ;(this.paginationElement.innerHTML = ''), this.destroy()
  }),
  (Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener('scroll', this.checkIfPaginationInView),
      window.removeEventListener('resize', this.checkIfPaginationInView),
      window.removeEventListener('orientationchange', this.checkIfPaginationInView)
  }),
  (Ajaxinate.prototype.destroy = function () {
    return (
      { click: this.removeClickListener, scroll: this.removeScrollListener }[
        this.settings.method
      ](),
      this
    )
  })
const filtering = (container) => {
    const forms = t$2('[data-filter-form]', container)
    let formData, searchParams
    setParams()
    function setParams(form) {
      ;(form = form || forms[0]),
        (formData = new FormData(form)),
        (searchParams = new URLSearchParams(formData).toString())
    }
    function syncForms(target) {
      if (!target) return
      t$2('[data-filter-item-input]', target).forEach((targetInput) => {
        if (targetInput.type === 'checkbox' || targetInput.type === 'radio') {
          const { valueEscaped } = targetInput.dataset
          t$2(
            "input[name='"
              .concat(escapeQuotes(targetInput.name), "'][data-value-escaped='")
              .concat(escapeQuotes(valueEscaped), "']")
          ).forEach((input) => {
            input.checked = targetInput.checked
          })
        } else
          t$2("input[name='".concat(targetInput.name, "']")).forEach((input) => {
            input.value = targetInput.value
          })
      })
    }
    function uncheckFilters(targets) {
      if (!targets) return
      let selector
      targets.forEach((target) => {
        selector = selector ? ', '.concat(selector) : ''
        const { name, valueEscaped } = target.dataset
        selector = "input[name='"
          .concat(escapeQuotes(name), "'][data-value-escaped='")
          .concat(escapeQuotes(valueEscaped), "']")
          .concat(selector)
      }),
        t$2(selector, container).forEach((input) => {
          input.checked = !1
        })
    }
    function escapeQuotes(str) {
      const escapeMap = { '"': '\\"', "'": "\\'" }
      return str.replace(/"|'/g, (m) => escapeMap[m])
    }
    function clearRangeInputs() {
      t$2('[data-range-input]', container).forEach((input) => {
        input.value = ''
      })
    }
    function resetForms() {
      forms.forEach((form) => {
        form.reset()
      })
    }
    return {
      getState() {
        return { url: searchParams }
      },
      filtersUpdated(target, cb) {
        return syncForms(target), setParams(target), r$1('filters:updated'), cb(this.getState())
      },
      removeFilters(target, cb) {
        return (
          uncheckFilters(target), setParams(), r$1('filters:filter-removed'), cb(this.getState())
        )
      },
      removeRange(cb) {
        return clearRangeInputs(), setParams(), cb(this.getState())
      },
      clearAll(cb) {
        return (searchParams = ''), resetForms(), cb(this.getState())
      },
    }
  },
  FILTERS_REMOVE = 'collection:filters:remove',
  RANGE_REMOVE = 'collection:range:remove',
  EVERYTHING_CLEAR = 'collection:clear',
  FILTERS_UPDATE = 'collection:filters:update',
  updateFilters = (target) => r$1(FILTERS_UPDATE, null, { target }),
  removeFilters = (target) => r$1(FILTERS_REMOVE, null, { target }),
  filtersUpdated = (cb) => c(FILTERS_UPDATE, cb),
  filtersRemoved = (cb) => c(FILTERS_REMOVE, cb),
  everythingCleared = (cb) => c(EVERYTHING_CLEAR, cb),
  rangeRemoved = (cb) => c(RANGE_REMOVE, cb),
  filterHandler = (_ref) => {
    let { container, renderCB } = _ref,
      subscriptions = null,
      filters = null,
      delegate = null
    ;(filters = filtering(container)),
      o$1(filters.getState()),
      (subscriptions = [
        filtersRemoved((_, _ref2) => {
          let { target } = _ref2
          filters.removeFilters(target, (data) => {
            renderCB(data.url), o$1(data)()
          })
        }),
        rangeRemoved(() => {
          filters.removeRange((data) => {
            renderCB(data.url), o$1(data)()
          })
        }),
        filtersUpdated((_, _ref3) => {
          let { target } = _ref3
          filters.filtersUpdated(target, (data) => {
            renderCB(data.url), o$1(data)()
          })
        }),
        everythingCleared(() => {
          filters.clearAll((data) => {
            renderCB(data.url), o$1(data)()
          })
        }),
      ]),
      (delegate = new Delegate(container)),
      delegate.on('click', '[data-remove-filter]', (e2) => {
        e2.preventDefault(), removeFilters([e2.target])
      }),
      window.addEventListener('popstate', onPopstate)
    function onPopstate() {
      const searchParams = new URL(window.location).search.replace('?', '')
      renderCB(searchParams, !1), o$1({ url: searchParams })
    }
    return {
      unload: () => {
        delegate && delegate.off(),
          subscriptions && subscriptions.forEach((unsubscribe) => unsubscribe()),
          window.removeEventListener('popstate', onPopstate)
      },
    }
  },
  { strings: strings$2 } = window.theme,
  priceRange = (container) => {
    const inputs = t$2('input', container),
      minInput = inputs[0],
      maxInput = inputs[1],
      events2 = [e$2(inputs, 'change', onRangeChange)],
      slider = n$2('[data-range-slider]', container)
    let min = Math.floor(minInput.value ? minInput.value : minInput.getAttribute('min')),
      max = Math.floor(maxInput.value ? maxInput.value : maxInput.getAttribute('max'))
    import(flu.chunks.nouislider).then((_ref) => {
      let { noUiSlider } = _ref
      noUiSlider.create(slider, {
        start: [
          minInput.value ? minInput.value : minInput.getAttribute('min'),
          maxInput.value ? maxInput.value : maxInput.getAttribute('max'),
        ],
        handleAttributes: [
          { 'aria-label': strings$2.accessibility.range_lower },
          { 'aria-label': strings$2.accessibility.range_upper },
        ],
        connect: !0,
        range: {
          min: parseInt(minInput.getAttribute('min')),
          max: parseInt(maxInput.getAttribute('max')),
        },
      }),
        slider.noUiSlider.on('slide', (e2) => {
          let maxNew, minNew
          ;([minNew, maxNew] = e2),
            (minInput.value = Math.floor(minNew)),
            (maxInput.value = Math.floor(maxNew)),
            setMinAndMaxValues()
        }),
        slider.noUiSlider.on('set', (e2) => {
          let maxNew, minNew
          ;(minNew = Math.floor(e2[0])),
            (maxNew = Math.floor(e2[1])),
            minNew != min &&
              ((minInput.value = minNew),
              fireMinChangeEvent(),
              (min = Math.floor(minInput.value ? minInput.value : minInput.getAttribute('min')))),
            maxNew != max &&
              ((maxInput.value = maxNew),
              fireMaxChangeEvent(),
              (max = Math.floor(maxInput.value ? maxInput.value : maxInput.getAttribute('max')))),
            setMinAndMaxValues()
        }),
        setMinAndMaxValues()
    })
    function setMinAndMaxValues() {
      maxInput.value && minInput.setAttribute('max', maxInput.value),
        minInput.value && maxInput.setAttribute('min', minInput.value),
        minInput.value === '' && maxInput.setAttribute('min', 0),
        maxInput.value === '' && minInput.setAttribute('max', maxInput.getAttribute('max'))
    }
    function adjustToValidValues(input) {
      const value = Number(input.value),
        minNew = Number(input.getAttribute('min')),
        maxNew = Number(input.getAttribute('max'))
      value < minNew && (input.value = minNew), value > maxNew && (input.value = maxNew)
    }
    function fireMinChangeEvent() {
      minInput.dispatchEvent(new Event('change', { bubbles: !0 }))
    }
    function fireMaxChangeEvent() {
      maxInput.dispatchEvent(new Event('change', { bubbles: !0 }))
    }
    function onRangeChange(event) {
      if (
        (adjustToValidValues(event.currentTarget),
        setMinAndMaxValues(),
        minInput.value === '' && maxInput.value === '')
      )
        return
      let currentMax, currentMin
      ;([currentMin, currentMax] = slider.noUiSlider.get()),
        (currentMin = Math.floor(currentMin)),
        (currentMax = Math.floor(currentMax)),
        currentMin !== Math.floor(minInput.value) && slider.noUiSlider.set([minInput.value, null]),
        currentMax !== Math.floor(maxInput.value) && slider.noUiSlider.set([null, maxInput.value])
    }
    function validateRange() {
      inputs.forEach((input) => setMinAndMaxValues())
    }
    return {
      unload: () => {
        events2.forEach((unsubscribe) => unsubscribe()), slider.noUiSlider.destroy()
      },
      reset: () => {
        slider.noUiSlider.set([minInput.getAttribute('min'), maxInput.getAttribute('max')], !1),
          (minInput.value = ''),
          (maxInput.value = ''),
          (min = Math.floor(minInput.getAttribute('min'))),
          (max = Math.floor(maxInput.getAttribute('max'))),
          setMinAndMaxValues()
      },
      validateRange,
    }
  },
  sel$2 = {
    drawer: '[data-filter-drawer]',
    drawerTitle: '[data-filter-drawer-title]',
    filter: '[data-filter]',
    filterItem: '[data-filter-item]',
    filterTarget: '[data-filter-drawer-target]',
    flyouts: '[data-filter-modal]',
    button: '[data-button]',
    wash: '[data-drawer-wash]',
    sort: '[data-sort]',
    close: '[data-close-icon]',
    group: '.filter-drawer__group',
    groupToggle: '[data-drawer-group-toggle]',
    groupContents: '.filter-drawer__group-filter-wrapper',
    panel: '.filter-drawer__panel',
    flyoutWrapper: '[data-filter-modal-wrapper]',
    priceRange: '[data-price-range]',
    resultsCount: '[data-results-count]',
    activeFilters: '[data-active-filters]',
    activeFilterCount: '[data-active-filter-count]',
  },
  classes$4 = {
    active: 'active',
    activeFilters: 'filters-active',
    fixed: 'is-fixed',
    filterDisabled: 'filter-item__content--disabled',
  },
  filterDrawer = (node) => {
    if (!node) return !1
    const container = n$2(sel$2.drawer, node)
    if (!container) return !1
    const flyouts = t$2(sel$2.flyouts, container),
      wash = n$2(sel$2.wash, container),
      rangeInputs = t$2('[data-range-input]', container)
    let focusTrap = null,
      range = null,
      filterDrawerAnimation = null
    shouldAnimate(node) && (filterDrawerAnimation = animateFilterDrawer(container))
    const rangeContainer = n$2(sel$2.priceRange, container)
    rangeContainer && (range = priceRange(rangeContainer))
    const filterDrawerDebounce = debounce(),
      events2 = [
        e$2(t$2(sel$2.filterTarget, node), 'click', clickFlyoutTrigger),
        e$2(container, 'change', changeHandler),
        e$2(wash, 'click', clickWash),
        e$2(
          t$2(''.concat(sel$2.button, ', ').concat(sel$2.clearAll), container),
          'click',
          clickButton
        ),
        e$2(t$2(sel$2.close, container), 'click', clickWash),
        e$2(container, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && clickWash()
        }),
        e$2(rangeInputs, 'change', rangeChanged),
        c('filters:filter-removed', () => syncActiveStates()),
      ]
    function changeHandler(e2) {
      e2.target.classList.contains('filter-item__checkbox')
        ? filterChange(e2.target)
        : e2.target.classList.contains('filter-item__radio') && sortChange(e2)
    }
    function clickFlyoutTrigger(e2) {
      e2.preventDefault()
      const { filterDrawerTarget } = e2.currentTarget.dataset,
        modal2 = n$2('[data-filter-modal="'.concat(filterDrawerTarget, '"]'), container)
      ;(focusTrap = createFocusTrap(modal2, { allowOutsideClick: !0 })),
        u$1(container, classes$4.fixed),
        setTimeout(() => {
          shouldAnimate(node) && filterDrawerAnimation.open(modal2),
            u$1(container, classes$4.active),
            u$1(modal2, classes$4.active)
        }, 0),
        modal2.setAttribute('aria-hidden', 'false'),
        focusTrap.activate(),
        document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
        disableBodyScroll(node, {
          allowTouchMove: (el) => {
            for (; el && el !== document.body; ) {
              if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
              el = el.parentNode
            }
          },
          reserveScrollBarGap: !0,
        })
    }
    function clickWash(e2) {
      e2 && e2.preventDefault(),
        focusTrap && focusTrap.deactivate(),
        i$1(flyouts, classes$4.active),
        i$1(container, classes$4.active),
        flyouts.forEach((flyout) => flyout.setAttribute('aria-hidden', 'true')),
        document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
        enableBodyScroll(node),
        setTimeout(() => {
          i$1(container, classes$4.fixed),
            shouldAnimate(node) && filterDrawerAnimation.close(flyouts)
        }, 500)
    }
    function filterChange(filter) {
      filter.classList.contains(classes$4.filterDisabled) ||
        (checkForActiveModalitems(filter),
        range && range.validateRange(),
        filterDrawerDebounce(() => updateFilters(container), 1e3))
    }
    function sortChange(e2) {
      checkForActiveModalitems(e2.target), range && range.validateRange(), updateFilters(container)
    }
    function rangeChanged(e2) {
      checkForActiveModalitems(e2.currentTarget)
      const wrappingContainer = e2.target.closest(sel$2.group)
      wrappingContainer && l(wrappingContainer, classes$4.activeFilters, rangeInputsHaveValue()),
        updateFilters(container)
    }
    function clickButton(e2) {
      e2.preventDefault()
      const { button } = e2.currentTarget.dataset,
        scope = e2.currentTarget.closest(sel$2.flyouts),
        { filterModal } = scope.dataset
      if ((button === 'close' && clickWash(), filterModal === '__sort'))
        button === 'clear-all' &&
          (t$2('[data-filter-modal="__sort"] '.concat(sel$2.sort), container).forEach((element) => {
            n$2('input', element).checked = !1
          }),
          i$1(e2.currentTarget.closest(sel$2.panel), classes$4.activeFilters))
      else {
        if (button === 'clear-all') {
          t$2('input', scope).forEach((input) => {
            input.checked = !1
          })
          const panel = e2.currentTarget.closest(sel$2.panel)
          i$1([...t$2(sel$2.group, panel), panel], classes$4.activeFilters),
            range && range.reset(),
            updateFilters(container)
        }
        if (button === 'group_toggle') {
          const group = n$2('#'.concat(e2.currentTarget.getAttribute('aria-controls'))),
            ariaExpanded = e2.currentTarget.getAttribute('aria-expanded') === 'true'
          slideStop(group),
            ariaExpanded ? closeGroup(e2.currentTarget, group) : openGroup(e2.currentTarget, group)
        }
      }
    }
    function openGroup(button, group) {
      slideDown(group),
        button.setAttribute('aria-expanded', !0),
        group.setAttribute('aria-hidden', !1)
    }
    function closeGroup(button, group) {
      slideUp(group),
        button.setAttribute('aria-expanded', !1),
        group.setAttribute('aria-hidden', !0)
    }
    function containsCheckedInputs(items) {
      return items.some((input) => input.checked)
    }
    function rangeInputsHaveValue() {
      return rangeInputs.some((input) => input.value !== '')
    }
    function checkForActiveModalitems(currentTarget) {
      const panel = currentTarget.closest(sel$2.panel)
      if (!panel) return
      const activeItems = containsCheckedInputs(t$2('input', panel)) || rangeInputsHaveValue()
      l(panel, classes$4.activeFilters, activeItems)
    }
    function syncActiveStates() {
      t$2(sel$2.panel, container).forEach((panel) => {
        let activeItems = !1
        const rangeInputs2 = n$2('[data-range-input]', panel)
        containsCheckedInputs(t$2('input', panel)) && (activeItems = !0),
          rangeInputs2 && rangeInputsHaveValue() && (activeItems = !0),
          l(panel, classes$4.activeFilters, activeItems)
      })
    }
    function renderFilters(updatedDoc) {
      t$2(
        ''.concat(sel$2.drawer, ' ').concat(sel$2.groupContents, ':not(#drawer-group-price)'),
        updatedDoc
      ).forEach((element) => {
        updateInnerHTML(
          ''.concat(sel$2.drawer, ' ').concat(sel$2.groupContents, '#').concat(element.id),
          updatedDoc
        )
      }),
        t$2(''.concat(sel$2.drawer, ' ').concat(sel$2.groupToggle), updatedDoc).forEach(
          (element) => {
            updateInnerHTML(
              ''
                .concat(sel$2.drawer, ' [data-drawer-group-toggle="')
                .concat(element.getAttribute('data-drawer-group-toggle'), '"]'),
              updatedDoc
            )
          }
        ),
        updateInnerHTML(''.concat(sel$2.drawer, ' ').concat(sel$2.resultsCount), updatedDoc),
        updateInnerHTML(''.concat(sel$2.drawer, ' ').concat(sel$2.activeFilters), updatedDoc),
        updateInnerHTML(''.concat(sel$2.drawer, ' ').concat(sel$2.drawerTitle), updatedDoc),
        updateInnerHTML('[data-mobile-filters] [data-mobile-filters-toggle]', updatedDoc)
    }
    function unload2() {
      events2.forEach((unsubscribe) => unsubscribe()), range && range.unload()
    }
    return { renderFilters, unload: unload2 }
  },
  sel$1 = {
    bar: '[data-filter-bar]',
    filterItem: '[data-filter-item]',
    dropdownToggle: '[data-dropdown-toggle]',
    group: '[data-filter-group]',
    groupLabels: '[data-filter-group-label]',
    groupValues: '[data-filter-group-values]',
    groupReset: '[data-filter-group-reset]',
    groupHeader: '[data-group-values-header]',
    priceRange: '[data-price-range]',
    rangeInput: '[data-range-input]',
    removeRange: '[data-remove-range]',
    filterInputs: '[data-filter-item-input]',
    sortInputs: '[data-sort-item-input]',
    resultsCount: '[data-results-count]',
    activeFilters: '[data-active-filters]',
    clearAll: '[data-clear-all-filters]',
  },
  classes$3 = {
    activeFilters: 'filters-active',
    filterDisabled: 'filter-item__content--disabled',
    filterBarActive: 'filter-bar__filters-inner--active',
    filterBarWashActive: 'filter-bar--wash-active',
    filterGroupActive: 'filter-group--active',
    filterGroupRight: 'filter-group__values--right',
  },
  filterBar = (node) => {
    if (!node) return !1
    const container = n$2(sel$1.bar, node),
      groupLabels = t$2(sel$1.groupLabels, container),
      rangeInputs = t$2(sel$1.rangeInput, container),
      rangeContainer = n$2(sel$1.priceRange, container)
    let focusTrap = null,
      range = null
    rangeContainer && (range = priceRange(rangeContainer))
    const filterDebounce = debounce(),
      events2 = [
        e$2(window, 'click', clickHandler),
        e$2(container, 'change', changeHandler),
        c('filters:filter-removed', () => syncActiveStates()),
        e$2(container, 'keydown', (_ref) => {
          let { keyCode } = _ref
          keyCode === 27 && closeGroups()
        }),
      ]
    function clickHandler(e2) {
      const group = e2.target.closest(sel$1.group),
        dropdownToggle = e2.target.closest(sel$1.dropdownToggle),
        groupReset = e2.target.closest(sel$1.groupReset),
        removeRange = e2.target.closest(sel$1.removeRange),
        clearAll = e2.target.closest(sel$1.clearAll)
      group || closeGroups(),
        dropdownToggle && toggleDropdown(dropdownToggle),
        groupReset && handleGroupReset(groupReset),
        removeRange && (e2.preventDefault(), priceRangeRemove()),
        clearAll && (e2.preventDefault(), clearAllFilters())
    }
    function clearAllFilters() {
      range && range.reset(),
        t$2(''.concat(sel$1.filterInputs), container).forEach((input) => {
          input.checked = !1
        }),
        updateFilters(container)
    }
    function handleGroupReset(groupReset) {
      const group = groupReset.closest(sel$1.groupValues),
        { filterType } = group.dataset
      filterType === 'price_range'
        ? priceRangeRemove()
        : (t$2(sel$1.filterInputs, group).forEach((input) => {
            input.checked = !1
          }),
          updateFilters(container))
    }
    function priceRangeRemove() {
      range && range.reset(), checkForActiveFilters(), updateFilters(container)
    }
    function changeHandler(e2) {
      const filterInput = e2.target.closest(
          ''
            .concat(sel$1.bar, ' ')
            .concat(sel$1.filterInputs, ', ')
            .concat(sel$1.bar, ' ')
            .concat(sel$1.sortInputs)
        ),
        rangeInput = e2.target.closest(''.concat(sel$1.bar, ' ').concat(sel$1.rangeInput))
      filterInput
        ? (checkForActiveFilters(), filterChange(filterInput))
        : rangeInput && (checkForActiveFilters(), filterChange(rangeInput))
    }
    function closeGroups() {
      groupLabels.forEach((button) => {
        hideDropdown(button)
      })
    }
    function toggleDropdown(button) {
      button.getAttribute('aria-expanded') === 'true'
        ? (closeGroups(), hideDropdown(button))
        : (closeGroups(), showDropdown(button))
    }
    function showDropdown(button) {
      const group = button.closest(sel$1.group)
      button.setAttribute('aria-expanded', !0)
      const dropdown = n$2('#'.concat(button.getAttribute('aria-controls')), container),
        { dropdownToggle } = button.dataset
      dropdown &&
        (dropdownToggle === 'filter-bar-filters'
          ? (slideStop(dropdown),
            slideDown(dropdown).then(() => {
              dropdown.setAttribute('aria-hidden', !1)
            }))
          : (dropdown.setAttribute('aria-hidden', !1),
            group &&
              (u$1(group, classes$3.filterGroupActive),
              positionGroup(group, dropdown),
              u$1(container, classes$3.filterBarWashActive),
              (focusTrap = createFocusTrap(group, { allowOutsideClick: !0 })),
              focusTrap.activate())))
    }
    function hideDropdown(button) {
      const group = button.closest(sel$1.group)
      i$1(container, classes$3.filterBarWashActive), button.setAttribute('aria-expanded', !1)
      const dropdown = n$2('#'.concat(button.getAttribute('aria-controls')), container),
        { dropdownToggle } = button.dataset
      dropdown &&
        (dropdown.setAttribute('aria-hidden', !0),
        dropdownToggle === 'filter-bar-filters'
          ? (slideStop(dropdown), slideUp(dropdown))
          : group && (i$1(group, classes$3.filterGroupActive), focusTrap && focusTrap.deactivate()))
    }
    function positionGroup(group, dropdown) {
      i$1(dropdown, classes$3.filterGroupRight)
      const parentBounds = group.parentElement.getBoundingClientRect(),
        groupBounds = group.getBoundingClientRect(),
        dropdownBounds = dropdown.getBoundingClientRect()
      groupBounds.x + dropdownBounds.width >= parentBounds.width &&
        u$1(dropdown, classes$3.filterGroupRight)
    }
    function updateGroupPositions() {
      t$2(sel$1.dropdownToggle, container).forEach((button) => {
        if (button.getAttribute('aria-expanded') === 'true') {
          const group = button.closest(sel$1.group),
            dropdown = n$2('#'.concat(button.getAttribute('aria-controls')), container)
          group && dropdown && positionGroup(group, dropdown)
        }
      })
    }
    function filterChange(filter) {
      filter.classList.contains(classes$3.filterDisabled) ||
        (checkForActiveFilters(),
        range && range.validateRange(),
        filterDebounce(() => updateFilters(container), 1e3))
    }
    function checkForActiveFilters() {
      const activeItems =
        containsCheckedInputs(t$2(sel$1.filterInputs, container)) || rangeInputsHaveValue()
      l(container, classes$3.activeFilters, activeItems)
    }
    function rangeInputsHaveValue() {
      return rangeInputs.some((input) => input.value !== '')
    }
    function containsCheckedInputs(items) {
      return items.some((input) => input.checked)
    }
    function syncActiveStates() {
      let activeItems = !1
      ;((rangeInputs && rangeInputsHaveValue()) ||
        containsCheckedInputs(t$2(sel$1.filterInputs, container))) &&
        (activeItems = !0),
        l(container, classes$3.activeFilters, activeItems)
    }
    function renderFilters(updatedDoc) {
      t$2(
        ''
          .concat(sel$1.bar, ' ')
          .concat(sel$1.groupValues, ':not([data-filter-type="price_range"])'),
        updatedDoc
      ).forEach((element) => {
        updateInnerHTML(
          ''.concat(sel$1.bar, ' ').concat(sel$1.groupValues, '#').concat(element.id),
          updatedDoc
        )
      }),
        updateInnerHTML(''.concat(sel$1.bar, ' ').concat(sel$1.resultsCount), updatedDoc),
        updateInnerHTML(''.concat(sel$1.bar, ' ').concat(sel$1.activeFilters), updatedDoc),
        updateInnerHTML(''.concat(sel$1.bar, ' ').concat(sel$1.groupHeader), updatedDoc)
      const updatedDropdownToggles = t$2(
        ''.concat(sel$1.bar, ' ').concat(sel$1.dropdownToggle),
        updatedDoc
      )
      updatedDropdownToggles.length > 0 &&
        updatedDropdownToggles.forEach((updated) => {
          updateInnerHTML(
            ''
              .concat(sel$1.bar, ' [data-dropdown-toggle="')
              .concat(updated.getAttribute('data-dropdown-toggle'), '"]'),
            updatedDoc
          )
        }),
        t$2(''.concat(sel$1.bar, ' ').concat(sel$1.groupHeader), updatedDoc).forEach((element) => {
          updateInnerHTML(
            ''
              .concat(sel$1.bar, ' [data-group-values-header="')
              .concat(element.getAttribute('data-group-values-header'), '"]'),
            updatedDoc
          )
        }),
        updateGroupPositions()
    }
    function unload2() {
      events2.forEach((unsubscribe) => unsubscribe()),
        range && range.unload(),
        focusTrap && focusTrap.deactivate()
    }
    return { renderFilters, unload: unload2 }
  },
  sel = {
    sidebar: '[data-filter-sidebar]',
    sidebarToggle: '.filter-bar__button--filters[data-filter-location="sidebar"]',
    sidebarToggleText: '.filter-bar__button-text',
    filterBar: '[data-filter-bar]',
    filter: '[data-filter]',
    filterItem: '[data-filter-item]',
    filterInputs: '[data-filter-item-input]',
    button: '[data-button]',
    group: '.filter-drawer__group',
    groupToggle: '[data-drawer-group-toggle]',
    groupContents: '.filter-drawer__group-filter-wrapper',
    priceRange: '[data-price-range]',
  },
  classes$2 = {
    active: 'active',
    activeFilters: 'filters-active',
    filterDisabled: 'filter-item__content--disabled',
  },
  filterSidebar = (node) => {
    if (!node) return !1
    const container = n$2(sel.sidebar, node)
    if (!container) return !1
    let filterSidebarAnimation = null
    shouldAnimate(node) &&
      ((filterSidebarAnimation = animateFilterSidebar(container)),
      container.getAttribute('aria-expanded') === 'true'
        ? filterSidebarAnimation.open(container)
        : filterSidebarAnimation.close(container))
    const filterBar2 = n$2(sel.filterBar, node),
      rangeInputs = t$2('[data-range-input]', container),
      rangeContainer = n$2(sel.priceRange, container)
    let range = null
    rangeContainer && (range = priceRange(rangeContainer))
    const filterDebounce = debounce(),
      events2 = [
        e$2(container, 'change', changeHandler),
        e$2(n$2(sel.sidebarToggle, node), 'click', clickSidebarToggle),
        e$2(t$2(''.concat(sel.button, ', ').concat(sel.clearAll), container), 'click', clickButton),
        e$2(rangeInputs, 'change', rangeChanged),
      ]
    function clickSidebarToggle(e2) {
      e2.preventDefault()
      const sidebarToggle = e2.currentTarget,
        { collapsedTitle, expandedTitle } = sidebarToggle.dataset,
        buttonTextEl = n$2(sel.sidebarToggleText, sidebarToggle)
      container.getAttribute('aria-expanded') === 'true'
        ? (container.setAttribute('aria-expanded', 'false'),
          (buttonTextEl.innerText = collapsedTitle),
          setTimeout(() => {
            shouldAnimate(node) && filterSidebarAnimation.close(container)
          }, 0))
        : (container.setAttribute('aria-expanded', 'true'),
          (buttonTextEl.innerText = expandedTitle),
          setTimeout(() => {
            shouldAnimate(node) && filterSidebarAnimation.open(container)
          }, 0))
    }
    function changeHandler(e2) {
      filterChange(e2.target)
    }
    function filterChange(filter) {
      filter.classList.contains(classes$2.filterDisabled) ||
        (checkForActiveFilters(),
        range && range.validateRange(),
        filterDebounce(() => updateFilters(container), 1e3))
    }
    function rangeChanged(e2) {
      const wrappingContainer = e2.target.closest(sel.group)
      wrappingContainer && l(wrappingContainer, classes$2.activeFilters, rangeInputsHaveValue()),
        updateFilters(container)
    }
    function clickButton(e2) {
      e2.preventDefault()
      const { button } = e2.currentTarget.dataset
      if (
        (button === 'clear-all' &&
          (t$2('input', container).forEach((input) => {
            input.checked = !1
          }),
          range && range.reset(),
          updateFilters(container)),
        button === 'group_toggle')
      ) {
        const group = n$2('#'.concat(e2.currentTarget.getAttribute('aria-controls'))),
          ariaExpanded = e2.currentTarget.getAttribute('aria-expanded') === 'true'
        slideStop(group),
          ariaExpanded ? closeGroup(e2.currentTarget, group) : openGroup(e2.currentTarget, group)
      }
    }
    function openGroup(button, group) {
      slideDown(group),
        button.setAttribute('aria-expanded', !0),
        group.setAttribute('aria-hidden', !1)
    }
    function closeGroup(button, group) {
      slideUp(group),
        button.setAttribute('aria-expanded', !1),
        group.setAttribute('aria-hidden', !0)
    }
    function checkForActiveFilters() {
      const activeItems =
        containsCheckedInputs(t$2(sel.filterInputs, container)) || rangeInputsHaveValue()
      l(filterBar2, classes$2.activeFilters, activeItems)
    }
    function rangeInputsHaveValue() {
      return rangeInputs.some((input) => input.value !== '')
    }
    function containsCheckedInputs(items) {
      return items.some((input) => input.checked)
    }
    function renderFilters(updatedDoc) {
      t$2(
        ''
          .concat(sel.sidebar, ' ')
          .concat(sel.groupContents, ':not([data-filter-type="price_range"])'),
        updatedDoc
      ).forEach((element) => {
        updateInnerHTML(
          ''.concat(sel.sidebar, ' ').concat(sel.groupContents, '#').concat(element.id),
          updatedDoc
        )
      }),
        t$2(''.concat(sel.sidebar, ' ').concat(sel.groupToggle), updatedDoc).forEach((element) => {
          updateInnerHTML(
            ''
              .concat(sel.sidebar, ' [data-drawer-group-toggle="')
              .concat(element.getAttribute('data-drawer-group-toggle'), '"]'),
            updatedDoc
          )
        }),
        updateInnerHTML(''.concat(sel.filterBar, ' ').concat(sel.resultsCount), updatedDoc),
        updateInnerHTML(''.concat(sel.filterBar, ' ').concat(sel.activeFilters), updatedDoc),
        updateInnerHTML(''.concat(sel.filterBar, ' ').concat(sel.sidebarToggle), updatedDoc)
    }
    function unload2() {
      events2.forEach((unsubscribe) => unsubscribe()), range && range.unload()
    }
    return { renderFilters, unload: unload2 }
  },
  selectors$1 = {
    infiniteScrollContainer: '.collection__infinite-container',
    infiniteScrollTrigger: '.collection__infinite-trigger',
    partial: '[data-partial]',
    filterDrawer: '[data-filter-drawer]',
    filterBar: '[data-filter-bar]',
    filterSidebar: '[data-filter-sidebar]',
    loader: '.collection__loading',
    paginationItemCount: '[data-pagination-item-count]',
    productItems: '.product-item',
  },
  classes$1 = { active: 'is-active', hideProducts: 'animation--collection-products-hide' },
  { strings: strings$1 } = window.theme
register('collection', {
  infiniteScroll: null,
  onLoad() {
    const { collectionItemCount, paginationType } = this.container.dataset
    parseInt(collectionItemCount) &&
      ((this.filterDrawerEl = n$2(selectors$1.filterDrawer, this.container)),
      (this.filterbarEl = n$2(selectors$1.filterBar, this.container)),
      (this.paginationItemCount = n$2(selectors$1.paginationItemCount, this.container)),
      (this.filterDrawerEl || this.filterbarEl) &&
        ((this.partial = n$2(selectors$1.partial, this.container)),
        (this.filterDrawer = filterDrawer(this.container)),
        (this.filterBar = filterBar(this.container)),
        (this.filterSidebar = filterSidebar(this.container)),
        (this.filterHandler = filterHandler({
          container: this.container,
          renderCB: this._renderView.bind(this),
        })),
        this.filterSidebar &&
          this.container.dataset.enableStickyFilterSidebar === 'true' &&
          ((this.mobileQuery = window.matchMedia(getMediaQuery('below-960'))),
          this._initStickyScroll(),
          (this.breakPointHandler = atBreakpointChange(960, () => {
            this._initStickyScroll()
          })))),
      (this.paginationType = paginationType),
      (this.paginated = this.paginationType === 'paginated'),
      (this.infiniteScrollTrigger = n$2(selectors$1.infiniteScrollTrigger, this.container)),
      this.paginated || this._initInfiniteScroll(),
      (this.productItem = ProductItem(this.container)),
      shouldAnimate(this.container) && (this.animateCollection = animateCollection(this.container)))
  },
  _initStickyScroll() {
    this.mobileQuery.matches
      ? this.stickyScroll && (this.stickyScroll.destroy(), (this.stickyScroll = null))
      : this.stickyScroll || (this.stickyScroll = stickyScroll(this.container))
  },
  _initInfiniteScroll() {
    const infiniteScrollOptions = {
      container: selectors$1.infiniteScrollContainer,
      pagination: selectors$1.infiniteScrollTrigger,
      loadingText: 'Loading...',
      callback: () => {
        var _this$animateCollecti
        this.productItem && this.productItem.unload(),
          (this.productItem = ProductItem(this.container)),
          (_this$animateCollecti = this.animateCollection) === null ||
            _this$animateCollecti === void 0 ||
            _this$animateCollecti.infiniteScrollReveal(),
          this._updatePaginationCount(),
          r$1('collection:updated')
      },
    }
    this.paginationType === 'click' && (infiniteScrollOptions.method = 'click'),
      (this.infiniteScroll = new Ajaxinate(infiniteScrollOptions))
  },
  _updatePaginationCount() {
    const productItemCount = t$2(selectors$1.productItems, this.container).length,
      viewing = strings$1.pagination.viewing
        .replace('{{ of }}', '1-'.concat(productItemCount))
        .replace('{{ total }}', this.partial.dataset.collectionProductsCount)
    this.paginationItemCount.innerHTML = ''
      .concat(viewing, ' ')
      .concat(strings$1.pagination.products)
  },
  _renderView(searchParams) {
    let updateHistory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0
    const url = ''
        .concat(window.location.pathname, '?section_id=')
        .concat(this.container.dataset.sectionId, '&')
        .concat(searchParams),
      loading = n$2(selectors$1.loader, this.container)
    u$1(this.partial, classes$1.hideProducts),
      u$1(loading, classes$1.active),
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          var _this$animateCollecti2
          updateHistory && this._updateURLHash(searchParams)
          const doc = new DOMParser().parseFromString(res, 'text/html'),
            updatedPartial = n$2(selectors$1.partial, doc)
          ;(this.partial.innerHTML = updatedPartial.innerHTML),
            (this.partial.dataset.collectionProductsCount =
              updatedPartial.dataset.collectionProductsCount),
            (_this$animateCollecti2 = this.animateCollection) === null ||
              _this$animateCollecti2 === void 0 ||
              _this$animateCollecti2.updateContents(),
            !this.paginated &&
              this.infiniteScrollTrigger &&
              ((this.infiniteScrollTrigger.innerHTML = ''), this._initInfiniteScroll()),
            this.filterDrawer && this.filterDrawer.renderFilters(doc),
            this.filterBar && this.filterBar.renderFilters(doc),
            this.filterSidebar && this.filterSidebar.renderFilters(doc),
            this.productItem && this.productItem.unload(),
            (this.productItem = ProductItem(this.container)),
            (this.paginationItemCount = n$2(selectors$1.paginationItemCount, this.container)),
            i$1(loading, classes$1.active),
            r$1('collection:updated')
        })
  },
  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      ''.concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams))
    )
  },
  onUnload() {
    var _this$animateCollecti3
    this.infiniteScroll && this.infiniteScroll.destroy(),
      this.filterHandler && this.filterHandler.unload(),
      this.filterDrawer && this.filterDrawer.unload(),
      this.filterBar && this.filterBar.unload(),
      this.filterSidebar && this.filterSidebar.unload(),
      this.filtering && this.filtering.unload(),
      this.productItem && this.productItem.unload(),
      (_this$animateCollecti3 = this.animateCollection) === null ||
        _this$animateCollecti3 === void 0 ||
        _this$animateCollecti3.destroy()
  },
}),
  register('login', {
    onLoad() {
      const main = n$2('[data-part="login"]', this.container),
        reset = n$2('[data-part="reset"]', this.container),
        toggles = t$2('[data-toggle]', this.container),
        loginError = n$2('.form-status__message--error', reset),
        isSuccess = n$2('.form-status__message--success', reset),
        successMessage = n$2('[data-success-message]', this.container)
      isSuccess && (u$1(successMessage, 'visible'), u$1([main, reset], 'hide')),
        loginError && toggleView()
      function toggleView(e2) {
        e2 && e2.preventDefault(),
          l([main, reset], 'hide'),
          main.setAttribute('aria-hidden', a$1(main, 'hide')),
          reset.setAttribute('aria-hidden', a$1(reset, 'hide'))
      }
      this.toggleClick = e$2(toggles, 'click', toggleView)
    },
    onUnload() {
      this.toggleClick()
    },
  }),
  register('addresses', {
    onLoad() {
      ;(this.modals = t$2('[data-address-modal]', this.container)), (this.focusTrap = null)
      const overlays = t$2('[data-overlay]', this.container),
        open = t$2('[data-open]', this.container),
        close = t$2('[data-close]', this.container),
        remove = t$2('[data-remove]', this.container),
        countryOptions = t$2('[data-country-option]', this.container) || []
      ;(this.events = [
        e$2(open, 'click', (e2) => this.openModal(e2)),
        e$2([...close, ...overlays], 'click', (e2) => this.closeModal(e2)),
        e$2(remove, 'click', (e2) => this.removeAddress(e2)),
        e$2(this.modals, 'keydown', (e2) => {
          e2.keyCode === 27 && this.closeModal(e2)
        }),
      ]),
        countryOptions.forEach((el) => {
          const { formId } = el.dataset,
            countrySelector = 'AddressCountry_' + formId,
            provinceSelector = 'AddressProvince_' + formId,
            containerSelector = 'AddressProvinceContainer_' + formId
          new window.Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector,
          })
        })
    },
    onUnload() {
      this.events.forEach((unsubscribe) => unsubscribe())
    },
    openModal(e2) {
      e2.preventDefault()
      const { open: which } = e2.currentTarget.dataset,
        modal2 = this.modals.find((el) => el.dataset.addressModal == which)
      u$1(modal2, 'active'),
        (this.focusTrap = createFocusTrap(modal2, { allowOutsideClick: !0 })),
        this.focusTrap.activate(),
        document.body.setAttribute('data-fluorescent-overlay-open', 'true'),
        disableBodyScroll(modal2, {
          allowTouchMove: (el) => {
            for (; el && el !== document.body; ) {
              if (el.getAttribute('data-scroll-lock-ignore') !== null) return !0
              el = el.parentNode
            }
          },
          reserveScrollBarGap: !0,
        }),
        setTimeout(() => {
          u$1(modal2, 'visible')
        }, 50)
    },
    closeModal(e2) {
      e2.preventDefault()
      const modal2 = e2.target.closest('.addresses__modal')
      document.body.setAttribute('data-fluorescent-overlay-open', 'false'),
        enableBodyScroll(modal2),
        this.focusTrap.deactivate(),
        i$1(modal2, 'visible'),
        setTimeout(() => {
          i$1(modal2, 'active')
        }, 350)
    },
    removeAddress(e2) {
      const { confirmMessage, target } = e2.currentTarget.dataset
      confirm(confirmMessage) &&
        window.Shopify.postLink(target, { parameters: { _method: 'delete' } })
    },
  }),
  register('article', {
    onLoad() {
      focusFormStatus(this.container)
      const socialShareContainer = n$2('.social-share', this.container)
      socialShareContainer && (this.socialShare = SocialShare(socialShareContainer)),
        wrapIframes(t$2('iframe', this.container)),
        wrapTables(t$2('table', this.container)),
        shouldAnimate(this.container) && (this.animateArticle = animateArticle(this.container))
    },
    onUnload() {
      var _this$animateArticle
      this.socialShare && this.socialShare(),
        (_this$animateArticle = this.animateArticle) === null ||
          _this$animateArticle === void 0 ||
          _this$animateArticle.destroy()
    },
  }),
  register('password', {
    onLoad() {
      shouldAnimate(this.container) && (this.animatePassword = animatePassword(this.container))
    },
    onUnload() {
      var _this$animatePassword
      ;(_this$animatePassword = this.animatePassword) === null ||
        _this$animatePassword === void 0 ||
        _this$animatePassword.destroy()
    },
  }),
  register('page', {
    onLoad() {
      shouldAnimate(this.container) && (this.animatePage = animatePage(this.container)),
        wrapIframes(t$2('iframe', this.container)),
        wrapTables(t$2('table', this.container))
    },
    onUnload() {
      var _this$animatePage
      ;(_this$animatePage = this.animatePage) === null ||
        _this$animatePage === void 0 ||
        _this$animatePage.destroy()
    },
  })
const selectors = {
    searchSection: '.search',
    searchBanner: '.search-header',
    infiniteScrollContainer: '.search__infinite-container',
    infiniteScrollTrigger: '.search__infinite-trigger',
    partial: '[data-partial]',
    filterDrawer: '[data-filter-drawer]',
    filterBar: '[data-filter-bar]',
    filterSidebar: '[data-filter-sidebar]',
    loader: '.search__loading',
    paginationItemCount: '[data-pagination-item-count]',
    searchItems: '.product-item, .search-item',
  },
  classes = { active: 'is-active', hideProducts: 'animation--search-products-hide' },
  { strings } = window.theme
register('search', {
  infiniteScroll: null,
  onLoad() {
    ;(this.searchBannerEl = n$2(selectors.searchBanner, this.container)),
      shouldAnimate(this.searchBannerEl) &&
        (this.animateSearchBanner = animateSearchBanner(this.searchBannerEl))
    const { searchItemCount, paginationType } = this.container.dataset
    parseInt(searchItemCount) &&
      ((this.searchSectionEl = n$2(selectors.searchSection, this.container)),
      (this.filterDrawerEl = n$2(selectors.filterDrawer, this.container)),
      (this.filterBarEl = n$2(selectors.filterBar, this.container)),
      (this.paginationItemCount = n$2(selectors.paginationItemCount, this.container)),
      this.filterBarEl &&
        ((this.partial = n$2(selectors.partial, this.container)),
        (this.filterDrawer = filterDrawer(this.searchSectionEl)),
        (this.filterBar = filterBar(this.searchSectionEl)),
        (this.filterSidebar = filterSidebar(this.searchSectionEl)),
        (this.filterHandler = filterHandler({
          container: this.searchSectionEl,
          renderCB: this._renderView.bind(this),
        })),
        this.filterSidebar &&
          this.searchSectionEl.dataset.enableStickyFilterSidebar === 'true' &&
          ((this.mobileQuery = window.matchMedia(getMediaQuery('below-960'))),
          this._initStickyScroll(),
          (this.breakPointHandler = atBreakpointChange(960, () => {
            this._initStickyScroll()
          })))),
      (this.paginationType = paginationType),
      (this.paginated = this.paginationType === 'paginated'),
      (this.infiniteScrollTrigger = n$2(selectors.infiniteScrollTrigger, this.container)),
      this.paginated || this._initInfiniteScroll(),
      (this.productItem = ProductItem(this.container)),
      shouldAnimate(this.searchSectionEl) &&
        (this.animateSearch = animateSearch(this.searchSectionEl)))
  },
  _initStickyScroll() {
    this.mobileQuery.matches
      ? this.stickyScroll && (this.stickyScroll.destroy(), (this.stickyScroll = null))
      : this.stickyScroll || (this.stickyScroll = stickyScroll(this.searchSectionEl))
  },
  _initInfiniteScroll() {
    const infiniteScrollOptions = {
      container: selectors.infiniteScrollContainer,
      pagination: selectors.infiniteScrollTrigger,
      loadingText: 'Loading...',
      callback: () => {
        var _this$animateSearch
        this.productItem && this.productItem.unload(),
          (this.productItem = ProductItem(this.container)),
          (_this$animateSearch = this.animateSearch) === null ||
            _this$animateSearch === void 0 ||
            _this$animateSearch.infiniteScrollReveal(),
          this._updatePaginationCount(),
          r$1('collection:updated')
      },
    }
    this.paginationType === 'click' && (infiniteScrollOptions.method = 'click'),
      (this.infiniteScroll = new Ajaxinate(infiniteScrollOptions))
  },
  _updatePaginationCount() {
    const searchItemCount = t$2(selectors.searchItems, this.container).length,
      viewing = strings.pagination.viewing
        .replace('{{ of }}', '1-'.concat(searchItemCount))
        .replace('{{ total }}', this.partial.dataset.searchResultsCount)
    this.paginationItemCount.innerHTML = ''.concat(viewing, ' ').concat(strings.pagination.results)
  },
  _renderView(searchParams) {
    let updateHistory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0
    const url = ''
        .concat(window.location.pathname, '?section_id=')
        .concat(this.container.dataset.sectionId, '&')
        .concat(searchParams),
      loading = n$2(selectors.loader, this.container)
    u$1(loading, classes.active),
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          var _this$animateSearch2
          updateHistory && this._updateURLHash(searchParams)
          const doc = new DOMParser().parseFromString(res, 'text/html'),
            updatedPartial = n$2(selectors.partial, doc)
          ;(this.partial.innerHTML = updatedPartial.innerHTML),
            (this.partial.dataset.searchResultsCount = updatedPartial.dataset.searchResultsCount),
            (_this$animateSearch2 = this.animateSearch) === null ||
              _this$animateSearch2 === void 0 ||
              _this$animateSearch2.updateContents(),
            !this.paginated &&
              this.infiniteScrollTrigger &&
              ((this.infiniteScrollTrigger.innerHTML = ''), this._initInfiniteScroll()),
            this.filterDrawer && this.filterDrawer.renderFilters(doc),
            this.filterBar && this.filterBar.renderFilters(doc),
            this.filterSidebar && this.filterSidebar.renderFilters(doc),
            this.productItem && this.productItem.unload(),
            (this.productItem = ProductItem(this.container)),
            (this.paginationItemCount = n$2(selectors.paginationItemCount, this.container)),
            i$1(loading, classes.active),
            r$1('collection:updated')
        })
  },
  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      ''.concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams))
    )
  },
  onUnload() {
    var _this$animateSearch3, _this$animateSearchBa
    this.infiniteScroll && this.infiniteScroll.destroy(),
      this.filterHandler && this.filterHandler.unload(),
      this.filterDrawer && this.filterDrawer.unload(),
      this.filterBar && this.filterBar.unload(),
      this.filterSidebar && this.filterSidebar.unload(),
      this.filtering && this.filtering.unload(),
      this.productItem && this.productItem.unload(),
      (_this$animateSearch3 = this.animateSearch) === null ||
        _this$animateSearch3 === void 0 ||
        _this$animateSearch3.destroy(),
      (_this$animateSearchBa = this.animateSearchBanner) === null ||
        _this$animateSearchBa === void 0 ||
        _this$animateSearchBa.destroy()
  },
}),
  register('contact', {
    onLoad() {
      ;(this.accordions = Accordions(t$2('.accordion', this.container))),
        wrapIframes(t$2('iframe', this.container)),
        wrapTables(t$2('table', this.container))
    },
    onUnload() {
      this.accordions.unload()
    },
  }),
  register('blog', {
    onLoad() {
      const mobileNavSelect = n$2('#blog-mobile-nav', this.container)
      mobileNavSelect &&
        (this.mobileNavSelectEvent = e$2(mobileNavSelect, 'change', () => {
          window.location.href = mobileNavSelect.value
        })),
        shouldAnimate(this.container) && (this.animateBlog = animateBlog(this.container))
    },
    onUnload() {
      var _this$animateBlog
      ;(_this$animateBlog = this.animateBlog) === null ||
        _this$animateBlog === void 0 ||
        _this$animateBlog.destroy(),
        this.mobileNavSelectEvent && this.mobileNavSelectEvent.unsubscribe()
    },
  }),
  register('collection-banner', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animateCollectionBanner = animateCollectionBanner(this.container))
    },
    onUnload() {
      var _this$animateCollecti
      ;(_this$animateCollecti = this.animateCollectionBanner) === null ||
        _this$animateCollecti === void 0 ||
        _this$animateCollecti.destroy()
    },
  }),
  register('list-collections', {
    onLoad() {
      shouldAnimate(this.container) &&
        (this.animateListCollections = animateListCollections(this.container))
    },
    onUnload() {
      var _this$animateListColl
      ;(_this$animateListColl = this.animateListCollections) === null ||
        _this$animateListColl === void 0 ||
        _this$animateListColl.destroy()
    },
  })
var _window$Shopify
if (
  (HTMLElement.prototype.hasOwnProperty('inert') || import(flu.chunks.polyfillInert),
  window.Shopify.designMode === !0)
)
  u$1(document.documentElement, 'theme-editor'),
    document.documentElement.classList.add('theme-editor')
else {
  const el = n$2('.theme-editor-scroll-offset', document)
  el && el.parentNode.removeChild(el)
}
const loadSections = () => {
  load('*'), o$1({ SelectedProductSection: null })
}
document.readyState === 'complete' || document.readyState === 'interactive'
  ? loadSections()
  : e$2(document, 'DOMContentLoaded', loadSections),
  isMobile$1({ tablet: !0, featureDetect: !0 }) && u$1(document.body, 'is-mobile'),
  pageTransition(),
  handleTab(),
  sectionClasses(),
  productLightbox()
const quickViewModalElement = n$2('[data-quick-view-modal]', document)
quickViewModalElement && quickViewModal(quickViewModalElement)
const modalElement = n$2('[data-modal]', document)
modal(modalElement)
const flashModal = n$2('[data-flash-alert]', document)
flashAlertModal(flashModal)
const availabilityDrawer = n$2('[data-store-availability-drawer]', document)
storeAvailabilityDrawer(availabilityDrawer)
const headerOverlayContainer = document.querySelector('[data-header-overlay]')
if (
  (headerOverlay(headerOverlayContainer),
  backToTop(),
  (window.SHA = '92395a0b52'),
  !sessionStorage.getItem('flu_stat_recorded') &&
    !(
      (_window$Shopify = window.Shopify) !== null &&
      _window$Shopify !== void 0 &&
      _window$Shopify.designMode
    ))
) {
  var _window$Shopify2, _window$Shopify3
  fetch('https://stats.fluorescent.co', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...window.theme.coreData,
      s:
        (_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0
          ? void 0
          : _window$Shopify2.shop,
      r:
        (_window$Shopify3 = window.Shopify) === null ||
        _window$Shopify3 === void 0 ||
        (_window$Shopify3 = _window$Shopify3.theme) === null ||
        _window$Shopify3 === void 0
          ? void 0
          : _window$Shopify3.role,
    }),
  }),
    window.sessionStorage && sessionStorage.setItem('flu_stat_recorded', 'true')
}
